/* eslint-disable */
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react"), require("react-dom"), require("prop-types")) : "function" == typeof define && define.amd ? define(["react", "react-dom", "prop-types"], t) : e.mobiscroll = t(e.React, e.ReactDOM, e.PropTypes);
}(this, function (e, t, n) {
  "use strict";

  e = e && e.hasOwnProperty("default") ? e.default : e, t = t && t.hasOwnProperty("default") ? t.default : t, n = n && n.hasOwnProperty("default") ? n.default : n;

  var s = s || {},
      a = {},
      o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      i = function i(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  },
      r = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var s = t[n];
        s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
      }
    }

    return function (t, n, s) {
      return n && e(t.prototype, n), s && e(t, s), t;
    };
  }(),
      l = function e(t, n, s) {
    null === t && (t = Function.prototype);
    var a = Object.getOwnPropertyDescriptor(t, n);

    if (void 0 === a) {
      var o = Object.getPrototypeOf(t);
      return null === o ? void 0 : e(o, n, s);
    }

    if ("value" in a) return a.value;
    var i = a.get;
    return void 0 !== i ? i.call(s) : void 0;
  },
      c = function c(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  },
      u = function u(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  },
      m = {
    "column-count": 1,
    columns: 1,
    "font-weight": 1,
    "line-height": 1,
    opacity: 1,
    "z-index": 1,
    zoom: 1
  },
      d = {
    readonly: "readOnly"
  },
      p = [],
      h = Array.prototype.slice;

  function f(e) {
    return "function" == typeof e;
  }

  function T(e) {
    return "object" === (void 0 === e ? "undefined" : o(e));
  }

  function x(e) {
    return "number" == typeof e.length;
  }

  function b(e) {
    return e.replace(/-+(.)?/g, function (e, t) {
      return t ? t.toUpperCase() : "";
    });
  }

  function v(e) {
    return e.replace(/::/g, "/").replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").replace(/_/g, "-").toLowerCase();
  }

  function y(e, t) {
    return "number" != typeof t || m[v(e)] ? t : t + "px";
  }

  var g,
      S,
      _,
      k,
      M = function () {
    var e = function e(_e2) {
      var n = 0;

      for (n = 0; n < _e2.length; n++) {
        this[n] = _e2[n];
      }

      return this.length = _e2.length, t(this);
    },
        t = function t(n, s) {
      var a,
          o,
          i,
          r = [],
          l = 0;
      if (n && !s && n instanceof e) return n;
      if (f(n)) return t(document).ready(n);
      if (n) if ("string" == typeof n) {
        if (n = i = n.trim(), i.indexOf("<") >= 0 && i.indexOf(">") >= 0) {
          var c = "div";

          for (0 === i.indexOf("<li") && (c = "ul"), 0 === i.indexOf("<tr") && (c = "tbody"), 0 !== i.indexOf("<td") && 0 !== i.indexOf("<th") || (c = "tr"), 0 === i.indexOf("<tbody") && (c = "table"), 0 === i.indexOf("<option") && (c = "select"), (o = document.createElement(c)).innerHTML = i, l = 0; l < o.childNodes.length; l++) {
            r.push(o.childNodes[l]);
          }
        } else for (s || "#" !== n[0] || n.match(/[ .<>:~]/) ? (s instanceof e && (s = s[0]), a = (s || document).querySelectorAll(n)) : a = [document.getElementById(n.split("#")[1])], l = 0; l < a.length; l++) {
          a[l] && r.push(a[l]);
        }
      } else if (n.nodeType || n === window || n === document) r.push(n);else if (n.length > 0 && n[0].nodeType) for (l = 0; l < n.length; l++) {
        r.push(n[l]);
      } else t.isArray(n) && (r = n);
      return new e(r);
    };

    return e.prototype = {
      ready: function ready(e) {
        return (document.attachEvent ? "complete" == document.readyState : "loading" != document.readyState) ? e(t) : document.addEventListener("DOMContentLoaded", function () {
          e(t);
        }, !1), this;
      },
      concat: p.concat,
      empty: function empty() {
        return this.each(function () {
          this.innerHTML = "";
        });
      },
      map: function map(e) {
        return t(t.map(this, function (t, n) {
          return e.call(t, n, t);
        }));
      },
      slice: function slice() {
        return t(h.apply(this, arguments));
      },
      addClass: function addClass(e) {
        if (void 0 === e) return this;

        for (var t = e.split(" "), n = 0; n < t.length; n++) {
          for (var s = 0; s < this.length; s++) {
            void 0 !== this[s].classList && "" !== t[n] && this[s].classList.add(t[n]);
          }
        }

        return this;
      },
      removeClass: function removeClass(e) {
        if (void 0 === e) return this;

        for (var t = e.split(" "), n = 0; n < t.length; n++) {
          for (var s = 0; s < this.length; s++) {
            void 0 !== this[s].classList && "" !== t[n] && this[s].classList.remove(t[n]);
          }
        }

        return this;
      },
      hasClass: function hasClass(e) {
        return !!this[0] && this[0].classList.contains(e);
      },
      toggleClass: function toggleClass(e) {
        for (var t = e.split(" "), n = 0; n < t.length; n++) {
          for (var s = 0; s < this.length; s++) {
            void 0 !== this[s].classList && this[s].classList.toggle(t[n]);
          }
        }

        return this;
      },
      closest: function closest(e, n) {
        var s = this[0],
            a = !1;

        for (T(e) && (a = t(e)); s && !(a ? a.indexOf(s) >= 0 : t.matches(s, e));) {
          s = s !== n && s.nodeType !== s.DOCUMENT_NODE && s.parentNode;
        }

        return t(s);
      },
      attr: function attr(e, t) {
        var n;

        if (1 !== arguments.length || "string" != typeof e) {
          for (var s = 0; s < this.length; s++) {
            if (2 === arguments.length) this[s].setAttribute(e, t);else for (var a in e) {
              this[s][a] = e[a], this[s].setAttribute(a, e[a]);
            }
          }

          return this;
        }

        if (this.length) return n = this[0].getAttribute(e), n || "" === n ? n : void 0;
      },
      removeAttr: function removeAttr(e) {
        for (var t = 0; t < this.length; t++) {
          this[t].removeAttribute(e);
        }

        return this;
      },
      prop: function prop(e, t) {
        if (e = d[e] || e, 1 === arguments.length && "string" == typeof e) return this[0] ? this[0][e] : void 0;

        for (var n = 0; n < this.length; n++) {
          this[n][e] = t;
        }

        return this;
      },
      val: function val(e) {
        if (void 0 === e) return this.length && this[0].multiple ? t.map(this.find("option:checked"), function (e) {
          return e.value;
        }) : this[0] ? this[0].value : void 0;
        if (this.length && this[0].multiple) t.each(this[0].options, function () {
          this.selected = -1 != e.indexOf(this.value);
        });else for (var n = 0; n < this.length; n++) {
          this[n].value = e;
        }
        return this;
      },
      on: function on(e, n, s, a) {
        var o,
            i,
            r = e.split(" ");

        function l(e) {
          var a,
              o,
              i = e.target;
          if (t(i).is(n)) s.call(i, e);else for (o = t(i).parents(), a = 0; a < o.length; a++) {
            t(o[a]).is(n) && s.call(o[a], e);
          }
        }

        function c(e, t, n, s) {
          var a = t.split(".");
          e.DomNameSpaces || (e.DomNameSpaces = []), e.DomNameSpaces.push({
            namespace: a[1],
            event: a[0],
            listener: n,
            capture: s
          }), e.addEventListener(a[0], n, s);
        }

        for (o = 0; o < this.length; o++) {
          if (f(n) || !1 === n) for (f(n) && (a = s || !1, s = n), i = 0; i < r.length; i++) {
            -1 != r[i].indexOf(".") ? c(this[o], r[i], s, a) : this[o].addEventListener(r[i], s, a);
          } else for (i = 0; i < r.length; i++) {
            this[o].DomLiveListeners || (this[o].DomLiveListeners = []), this[o].DomLiveListeners.push({
              listener: s,
              liveListener: l
            }), -1 != r[i].indexOf(".") ? c(this[o], r[i], l, a) : this[o].addEventListener(r[i], l, a);
          }
        }

        return this;
      },
      off: function off(e, t, n, s) {
        var a,
            o,
            i,
            r,
            l = this;

        function c(e) {
          var t,
              n,
              s,
              a = e.split("."),
              o = a[0],
              i = a[1];

          for (t = 0; t < l.length; ++t) {
            if (l[t].DomNameSpaces) {
              for (n = 0; n < l[t].DomNameSpaces.length; ++n) {
                (s = l[t].DomNameSpaces[n]).namespace != i || s.event != o && o || (l[t].removeEventListener(s.event, s.listener, s.capture), s.removed = !0);
              }

              for (n = l[t].DomNameSpaces.length - 1; n >= 0; --n) {
                l[t].DomNameSpaces[n].removed && l[t].DomNameSpaces.splice(n, 1);
              }
            }
          }
        }

        for (a = e.split(" "), o = 0; o < a.length; o++) {
          for (i = 0; i < this.length; i++) {
            if (f(t) || !1 === t) f(t) && (s = n || !1, n = t), 0 === a[o].indexOf(".") ? c(a[o].substr(1)) : this[i].removeEventListener(a[o], n, s);else {
              if (this[i].DomLiveListeners) for (r = 0; r < this[i].DomLiveListeners.length; r++) {
                this[i].DomLiveListeners[r].listener === n && this[i].removeEventListener(a[o], this[i].DomLiveListeners[r].liveListener, s);
              }
              this[i].DomNameSpaces && this[i].DomNameSpaces.length && a[o] && c(a[o]);
            }
          }
        }

        return this;
      },
      trigger: function trigger(e, t) {
        for (var n = e.split(" "), s = 0; s < n.length; s++) {
          for (var a = 0; a < this.length; a++) {
            var o;

            try {
              o = new CustomEvent(n[s], {
                detail: t,
                bubbles: !0,
                cancelable: !0
              });
            } catch (e) {
              (o = document.createEvent("Event")).initEvent(n[s], !0, !0), o.detail = t;
            }

            this[a].dispatchEvent(o);
          }
        }

        return this;
      },
      width: function width(e) {
        return void 0 !== e ? this.css("width", e) : this[0] === window ? window.innerWidth : this[0] === document ? document.documentElement.scrollWidth : this.length > 0 ? parseFloat(this.css("width")) : null;
      },
      height: function height(e) {
        if (void 0 !== e) return this.css("height", e);
        if (this[0] === window) return window.innerHeight;

        if (this[0] === document) {
          var t = document.body,
              n = document.documentElement;
          return Math.max(t.scrollHeight, t.offsetHeight, n.clientHeight, n.scrollHeight, n.offsetHeight);
        }

        return this.length > 0 ? parseFloat(this.css("height")) : null;
      },
      innerWidth: function innerWidth() {
        var e = this;

        if (this.length > 0) {
          if (this[0].innerWidth) return this[0].innerWidth;
          var t = this[0].offsetWidth;
          return ["left", "right"].forEach(function (n) {
            t -= parseInt(e.css(b("border-" + n + "-width")) || 0, 10);
          }), t;
        }
      },
      innerHeight: function innerHeight() {
        var e = this;

        if (this.length > 0) {
          if (this[0].innerHeight) return this[0].innerHeight;
          var t = this[0].offsetHeight;
          return ["top", "bottom"].forEach(function (n) {
            t -= parseInt(e.css(b("border-" + n + "-width")) || 0, 10);
          }), t;
        }
      },
      offset: function offset() {
        if (this.length > 0) {
          var e = this[0].getBoundingClientRect(),
              t = document.documentElement;
          return {
            top: e.top + window.pageYOffset - t.clientTop,
            left: e.left + window.pageXOffset - t.clientLeft
          };
        }
      },
      hide: function hide() {
        for (var e = 0; e < this.length; e++) {
          this[e].style.display = "none";
        }

        return this;
      },
      show: function show() {
        for (var e = 0; e < this.length; e++) {
          "none" == this[e].style.display && (this[e].style.display = ""), "none" == getComputedStyle(this[e], "").getPropertyValue("display") && (this[e].style.display = "block");
        }

        return this;
      },
      clone: function clone() {
        return this.map(function () {
          return this.cloneNode(!0);
        });
      },
      styles: function styles() {
        return this[0] ? window.getComputedStyle(this[0], null) : void 0;
      },
      css: function css(e, t) {
        var n,
            s,
            a = this[0],
            o = "";

        if (arguments.length < 2) {
          if (!a) return;
          if ("string" == typeof e) return a.style[e] || getComputedStyle(a, "").getPropertyValue(e);
        }

        if ("string" == typeof e) t || 0 === t ? o = v(e) + ":" + y(e, t) : this.each(function () {
          this.style.removeProperty(v(e));
        });else for (s in e) {
          if (e[s] || 0 === e[s]) o += v(s) + ":" + y(s, e[s]) + ";";else for (n = 0; n < this.length; n++) {
            this[n].style.removeProperty(v(s));
          }
        }
        return this.each(function () {
          this.style.cssText += ";" + o;
        });
      },
      each: function each(e) {
        for (var t = 0; t < this.length && !1 !== e.apply(this[t], [t, this[t]]); t++) {
          ;
        }

        return this;
      },
      filter: function filter(n) {
        for (var s = [], a = 0; a < this.length; a++) {
          f(n) ? n.call(this[a], a, this[a]) && s.push(this[a]) : t.matches(this[a], n) && s.push(this[a]);
        }

        return new e(s);
      },
      html: function html(e) {
        if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
        this.empty();

        for (var t = 0; t < this.length; t++) {
          this[t].innerHTML = e;
        }

        return this;
      },
      text: function text(e) {
        if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;

        for (var t = 0; t < this.length; t++) {
          this[t].textContent = e;
        }

        return this;
      },
      is: function is(e) {
        return this.length > 0 && t.matches(this[0], e);
      },
      not: function not(e) {
        var n = [];
        if (f(e) && void 0 !== e.call) this.each(function (t) {
          e.call(this, t) || n.push(this);
        });else {
          var s = "string" == typeof e ? this.filter(e) : x(e) && f(e.item) ? h.call(e) : t(e);
          T(s) && (s = t.map(s, function (e) {
            return e;
          })), this.each(function (e, t) {
            s.indexOf(t) < 0 && n.push(t);
          });
        }
        return t(n);
      },
      indexOf: function indexOf(e) {
        for (var t = 0; t < this.length; t++) {
          if (this[t] === e) return t;
        }
      },
      index: function index(e) {
        return e ? this.indexOf(t(e)[0]) : this.parent().children().indexOf(this[0]);
      },
      get: function get(e) {
        return void 0 === e ? h.call(this) : this[e >= 0 ? e : e + this.length];
      },
      eq: function eq(t) {
        if (void 0 === t) return this;
        var n,
            s = this.length;
        return new e(t > s - 1 ? [] : t < 0 ? (n = s + t) < 0 ? [] : [this[n]] : [this[t]]);
      },
      append: function append(t) {
        var n, s;

        for (n = 0; n < this.length; n++) {
          if ("string" == typeof t) {
            var a = document.createElement("div");

            for (a.innerHTML = t; a.firstChild;) {
              this[n].appendChild(a.firstChild);
            }
          } else if (t instanceof e) for (s = 0; s < t.length; s++) {
            this[n].appendChild(t[s]);
          } else this[n].appendChild(t);
        }

        return this;
      },
      appendTo: function appendTo(e) {
        return t(e).append(this), this;
      },
      prepend: function prepend(t) {
        var n, s;

        for (n = 0; n < this.length; n++) {
          if ("string" == typeof t) {
            var a = document.createElement("div");

            for (a.innerHTML = t, s = a.childNodes.length - 1; s >= 0; s--) {
              this[n].insertBefore(a.childNodes[s], this[n].childNodes[0]);
            }
          } else if (t instanceof e) for (s = 0; s < t.length; s++) {
            this[n].insertBefore(t[s], this[n].childNodes[0]);
          } else this[n].insertBefore(t, this[n].childNodes[0]);
        }

        return this;
      },
      prependTo: function prependTo(e) {
        return t(e).prepend(this), this;
      },
      insertBefore: function insertBefore(e) {
        for (var n = t(e), s = 0; s < this.length; s++) {
          if (1 === n.length) n[0].parentNode.insertBefore(this[s], n[0]);else if (n.length > 1) for (var a = 0; a < n.length; a++) {
            n[a].parentNode.insertBefore(this[s].cloneNode(!0), n[a]);
          }
        }

        return this;
      },
      insertAfter: function insertAfter(e) {
        for (var n = t(e), s = 0; s < this.length; s++) {
          if (1 === n.length) n[0].parentNode.insertBefore(this[s], n[0].nextSibling);else if (n.length > 1) for (var a = 0; a < n.length; a++) {
            n[a].parentNode.insertBefore(this[s].cloneNode(!0), n[a].nextSibling);
          }
        }

        return this;
      },
      next: function next(n) {
        return this.length > 0 ? n ? this[0].nextElementSibling && t(this[0].nextElementSibling).is(n) ? new e([this[0].nextElementSibling]) : new e([]) : this[0].nextElementSibling ? new e([this[0].nextElementSibling]) : new e([]) : new e([]);
      },
      nextAll: function nextAll(n) {
        var s = [],
            a = this[0];
        if (!a) return new e([]);

        for (; a.nextElementSibling;) {
          var o = a.nextElementSibling;
          n ? t(o).is(n) && s.push(o) : s.push(o), a = o;
        }

        return new e(s);
      },
      prev: function prev(n) {
        return this.length > 0 ? n ? this[0].previousElementSibling && t(this[0].previousElementSibling).is(n) ? new e([this[0].previousElementSibling]) : new e([]) : this[0].previousElementSibling ? new e([this[0].previousElementSibling]) : new e([]) : new e([]);
      },
      prevAll: function prevAll(n) {
        var s = [],
            a = this[0];
        if (!a) return new e([]);

        for (; a.previousElementSibling;) {
          var o = a.previousElementSibling;
          n ? t(o).is(n) && s.push(o) : s.push(o), a = o;
        }

        return new e(s);
      },
      parent: function parent(e) {
        for (var n = [], s = 0; s < this.length; s++) {
          null !== this[s].parentNode && (e ? t(this[s].parentNode).is(e) && n.push(this[s].parentNode) : n.push(this[s].parentNode));
        }

        return t(t.unique(n));
      },
      parents: function parents(e) {
        for (var n = [], s = 0; s < this.length; s++) {
          for (var a = this[s].parentNode; a;) {
            e ? t(a).is(e) && n.push(a) : n.push(a), a = a.parentNode;
          }
        }

        return t(t.unique(n));
      },
      find: function find(t) {
        for (var n = [], s = 0; s < this.length; s++) {
          for (var a = this[s].querySelectorAll(t), o = 0; o < a.length; o++) {
            n.push(a[o]);
          }
        }

        return new e(n);
      },
      children: function children(n) {
        for (var s = [], a = 0; a < this.length; a++) {
          for (var o = this[a].childNodes, i = 0; i < o.length; i++) {
            n ? 1 === o[i].nodeType && t(o[i]).is(n) && s.push(o[i]) : 1 === o[i].nodeType && s.push(o[i]);
          }
        }

        return new e(t.unique(s));
      },
      remove: function remove() {
        for (var e = 0; e < this.length; e++) {
          this[e].parentNode && this[e].parentNode.removeChild(this[e]);
        }

        return this;
      },
      add: function add() {
        var e, n;

        for (e = 0; e < arguments.length; e++) {
          var s = t(arguments[e]);

          for (n = 0; n < s.length; n++) {
            this[this.length] = s[n], this.length++;
          }
        }

        return this;
      },
      before: function before(e) {
        return t(e).insertBefore(this), this;
      },
      after: function after(e) {
        return t(e).insertAfter(this), this;
      },
      scrollTop: function scrollTop(e) {
        if (this.length) {
          var t = "scrollTop" in this[0];
          return void 0 === e ? t ? this[0].scrollTop : this[0].pageYOffset : this.each(t ? function () {
            this.scrollTop = e;
          } : function () {
            this.scrollTo(this.scrollX, e);
          });
        }
      },
      scrollLeft: function scrollLeft(e) {
        if (this.length) {
          var t = "scrollLeft" in this[0];
          return void 0 === e ? t ? this[0].scrollLeft : this[0].pageXOffset : this.each(t ? function () {
            this.scrollLeft = e;
          } : function () {
            this.scrollTo(e, this.scrollY);
          });
        }
      },
      contents: function contents() {
        return this.map(function (e, t) {
          return h.call(t.childNodes);
        });
      },
      nextUntil: function nextUntil(e) {
        for (var n = this, s = []; n.length && !n.filter(e).length;) {
          s.push(n[0]), n = n.next();
        }

        return t(s);
      },
      prevUntil: function prevUntil(e) {
        for (var n = this, s = []; n.length && !t(n).filter(e).length;) {
          s.push(n[0]), n = n.prev();
        }

        return t(s);
      },
      detach: function detach() {
        return this.remove();
      }
    }, t.fn = e.prototype, t;
  }(),
      w = M;

  s.$ = M, w.inArray = function (e, t, n) {
    return p.indexOf.call(t, e, n);
  }, w.extend = function (e) {
    var t,
        n = h.call(arguments, 1);
    return "boolean" == typeof e && (t = e, e = n.shift()), e = e || {}, n.forEach(function (n) {
      !function e(t, n, s) {
        for (var a in n) {
          s && (w.isPlainObject(n[a]) || w.isArray(n[a])) ? ((w.isPlainObject(n[a]) && !w.isPlainObject(t[a]) || w.isArray(n[a]) && !w.isArray(t[a])) && (t[a] = {}), e(t[a], n[a], s)) : void 0 !== n[a] && (t[a] = n[a]);
        }
      }(e, n, t);
    }), e;
  }, w.isFunction = f, w.isArray = function (e) {
    return "[object Array]" === Object.prototype.toString.apply(e);
  }, w.isPlainObject = function (e) {
    return T(e) && null !== e && e !== e.window && Object.getPrototypeOf(e) == Object.prototype;
  }, w.each = function (e, t) {
    var n, s;

    if (T(e) && t) {
      if (w.isArray(e) || e instanceof M) for (n = 0; n < e.length && !1 !== t.call(e[n], n, e[n]); n++) {
        ;
      } else for (s in e) {
        if (e.hasOwnProperty(s) && "length" !== s && !1 === t.call(e[s], s, e[s])) break;
      }
      return this;
    }
  }, w.unique = function (e) {
    for (var t = [], n = 0; n < e.length; n++) {
      -1 === t.indexOf(e[n]) && t.push(e[n]);
    }

    return t;
  }, w.map = function (e, t) {
    var n,
        s,
        a,
        o = [];
    if (x(e)) for (s = 0; s < e.length; s++) {
      null !== (n = t(e[s], s)) && o.push(n);
    } else for (a in e) {
      null !== (n = t(e[a], a)) && o.push(n);
    }
    return o.length > 0 ? w.fn.concat.apply([], o) : o;
  }, w.matches = function (e, t) {
    return !(!t || !e || 1 !== e.nodeType) && (e.matchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector).call(e, t);
  };

  var C = [],
      N = "undefined" != typeof window,
      O = N ? navigator.userAgent : "",
      D = /Safari/.test(O),
      E = O.match(/Android|iPhone|iPad|iPod|Windows Phone|Windows|MSIE/i),
      P = N && window.requestAnimationFrame || function (e) {
    return setTimeout(e, 20);
  };

  N && window.cancelAnimationFrame;

  function A() {}

  function F(e) {
    return "string" == typeof e;
  }

  function L(e, t, n) {
    return Math.max(t, Math.min(e, n));
  }

  function H(e, t, n) {
    return 100 * (e - t) / (n - t);
  }

  function j(e, t, n) {
    var s = n.attr(e);
    return void 0 === s || "" === s ? t : "true" === s;
  }

  /Android/i.test(E) ? (g = "android", (S = O.match(/Android\s+([\d\.]+)/i)) && (C = S[0].replace("Android ", "").split("."))) : /iPhone|iPad|iPod/i.test(E) ? (g = "ios", (S = O.match(/OS\s+([\d\_]+)/i)) && (C = S[0].replace(/_/g, ".").replace("OS ", "").split("."))) : /Windows Phone/i.test(E) ? g = "wp" : /Windows|MSIE/i.test(E) && (g = "windows"), _ = C[0], k = C[1];
  var z,
      V = 0,
      I = void 0;

  function J() {
    V++, setTimeout(function () {
      V--;
    }, 500);
  }

  function U(e, t, n) {
    var s = e.originalEvent || e,
        a = (n ? "page" : "client") + t;
    return s.targetTouches && s.targetTouches[0] ? s.targetTouches[0][a] : s.changedTouches && s.changedTouches[0] ? s.changedTouches[0][a] : e[a];
  }

  function R(e) {
    var t = e[0],
        n = e.attr("data-role"),
        s = e.attr("type") || t.nodeName.toLowerCase();
    return /(switch|range|rating|segmented|stepper)/.test(n) && (s = n), s;
  }

  function $(e, t, n) {
    e.focus(), /(button|submit|checkbox|switch|radio)/.test(t) && n.preventDefault(), /select/.test(t) || function (e, t) {
      if (!t.mbscClick) {
        var n = (e.originalEvent || e).changedTouches[0],
            s = document.createEvent("MouseEvents");
        s.initMouseEvent("click", !0, !0, window, 1, n.screenX, n.screenY, n.clientX, n.clientY, !1, !1, !1, !1, 0, null), s.isMbscTap = !0, s.isIonicTap = !0, I = !0, t.mbscChange = !0, t.mbscClick = !0, t.dispatchEvent(s), I = !1, J(), setTimeout(function () {
          delete t.mbscClick;
        });
      }
    }(n, e);
  }

  function B(e, t, n, a, o, i) {
    var r,
        l,
        c,
        u,
        m,
        d = (0, s.$)(t);
    o = o || 9, e.settings.tap && d.on("touchstart.mbsc", function (e) {
      c || (a && e.preventDefault(), c = this, r = U(e, "X"), l = U(e, "Y"), u = !1, m = new Date());
    }).on("touchcancel.mbsc", function () {
      c = !1;
    }).on("touchmove.mbsc", function (e) {
      c && !u && (Math.abs(U(e, "X") - r) > o || Math.abs(U(e, "Y") - l) > o) && (u = !0);
    }).on("touchend.mbsc", function (t) {
      c && ((i && new Date() - m < 100 || !u) && (t.preventDefault(), n.call(c, t, e)), c = !1, J());
    }), d.on("click.mbsc", function (t) {
      a && t.preventDefault(), n.call(this, t, e);
    });
  }

  function W(e) {
    if (V && !I && !e.isMbscTap && ("TEXTAREA" != e.target.nodeName || "mousedown" != e.type)) return e.stopPropagation(), e.preventDefault(), !1;
  }

  function K(e, t, n) {
    N && Y(function () {
      Y(e).each(function () {
        new t(this);
      }), Y(document).on("mbsc-enhance", function (n, s) {
        Y(n.target).is(e) ? new t(n.target, s) : Y(e, n.target).each(function () {
          new t(this, s);
        });
      }), n && Y(document).on("mbsc-refresh", function (t) {
        var n;
        Y(t.target).is(e) ? (n = q[t.target.id]) && n.refresh() : Y(e, t.target).each(function () {
          (n = q[this.id]) && n.refresh();
        });
      });
    });
  }

  N && (["mouseover", "mousedown", "mouseup", "click"].forEach(function (e) {
    document.addEventListener(e, W, !0);
  }), "android" == g && _ < 5 && document.addEventListener("change", function (e) {
    V && "checkbox" == e.target.type && !e.target.mbscChange && (e.stopPropagation(), e.preventDefault()), delete e.target.mbscChange;
  }, !0));
  var Y = s.$,
      G = +new Date(),
      q = {},
      Z = {},
      X = {
    xsmall: 0,
    small: 576,
    medium: 768,
    large: 992,
    xlarge: 1200
  },
      Q = Y.extend;
  Q(a, {
    getCoord: U,
    preventClick: J,
    vibrate: function vibrate(e) {
      "vibrate" in navigator && navigator.vibrate(e || 50);
    }
  }), z = Q(s, {
    $: Y,
    version: "4.5.2",
    autoTheme: "mobiscroll",
    themes: {
      form: {},
      page: {},
      frame: {},
      scroller: {},
      listview: {},
      navigation: {},
      progress: {},
      card: {}
    },
    platform: {
      name: g,
      majorVersion: _,
      minorVersion: k
    },
    i18n: {},
    instances: q,
    classes: Z,
    util: a,
    settings: {},
    setDefaults: function setDefaults(e) {
      Q(this.settings, e);
    },
    customTheme: function customTheme(e, t) {
      var n,
          a = s.themes,
          o = ["frame", "scroller", "listview", "navigation", "form", "page", "progress", "card"];

      for (n = 0; n < o.length; n++) {
        a[o[n]][e] = Q({}, a[o[n]][t], {
          baseTheme: t
        });
      }
    }
  });

  var ee,
      te,
      ne,
      se,
      ae = function ae(e, t) {
    var n,
        s,
        a,
        i,
        r,
        l,
        c,
        u,
        m,
        d = this;

    function p(e) {
      var t, s;
      return r.responsive && (s = e || n.offsetWidth, Y.each(r.responsive, function (e, n) {
        s >= (n.breakpoint || X[e]) && (t = n);
      })), t;
    }

    d.settings = {}, d.element = e, d._init = A, d._destroy = A, d._processSettings = A, d._checkResp = function (e) {
      if (d && d._responsive) {
        var t = p(e);
        if (i !== t) return i = t, d.init({}), !0;
      }
    }, d.init = function (o) {
      var h, f;

      for (h in o && d.getVal && (f = d.getVal()), d.settings) {
        delete d.settings[h];
      }

      r = d.settings, Q(t, o), d._hasDef && (m = z.settings), Q(r, d._defaults, m, t), d._hasTheme && ("auto" != (c = r.theme) && c || (c = z.autoTheme), "default" == c && (c = "mobiscroll"), t.theme = c, l = z.themes[d._class] ? z.themes[d._class][c] : {}), d._hasLang && (s = z.i18n[r.lang]), Q(r, l, s, m, t), n = Y(r.context)[0], d._responsive && (i || (i = p()), Q(r, i)), d._processSettings(i || {}), d._presets && (a = d._presets[r.preset]) && (a = a.call(e, d, t), Q(r, a, t, i)), d._init(o), o && d.setVal && d.setVal(f, !0), u("onInit");
    }, d.destroy = function () {
      d && (d._destroy(), u("onDestroy"), delete q[e.id], d = null);
    }, d.tap = function (e, t, n, s, a) {
      B(d, e, t, n, s, a);
    }, d.trigger = function (n, s) {
      var o,
          i,
          r,
          c = [m, l, a, t];

      for (i = 0; i < 4; i++) {
        (r = c[i]) && r[n] && (o = r[n].call(e, s || {}, d));
      }

      return o;
    }, d.option = function (e, n) {
      var s = {};
      "object" === (void 0 === e ? "undefined" : o(e)) ? s = e : s[e] = n, ["data", "invalid", "valid", "marked", "labels", "colors", "readonly"].forEach(function (e) {
        t[e] = r[e];
      }), d.init(s);
    }, d.getInst = function () {
      return d;
    }, t = t || {}, u = d.trigger, d.__ready || (Y(e).addClass("mbsc-comp"), e.id ? q[e.id] && q[e.id].destroy() : e.id = "mobiscroll" + ++G, q[e.id] = d, d.__ready = !0);
  },
      oe = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var s in n) {
        Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
      }
    }

    return e;
  };

  var ie = n.bool,
      re = n.string,
      le = n.func,
      ce = n.number,
      ue = n.object,
      me = n.oneOfType([ue, re]),
      de = n.oneOfType([ce, n.arrayOf(ce)]),
      pe = {
    theme: re,
    lang: re,
    rtl: ie,
    responsive: ue,
    context: n.oneOfType([re, ue])
  },
      he = {
    anchor: n.oneOfType([re, ue]),
    animate: n.oneOfType([ie, n.oneOf(["fade", "flip", "pop", "swing", "slidevertical", "slidehorizontal", "slidedown", "slideup"])]),
    buttons: n.array,
    closeOnOverlayTap: ie,
    cssClass: re,
    disabled: ie,
    display: n.oneOf(["top", "bottom", "bubble", "inline", "center"]),
    focusOnClose: n.oneOfType([ie, re, ue]),
    focusTrap: ie,
    headerText: n.oneOfType([ie, re, le]),
    layout: n.oneOf(["liquid", "fixed"]),
    scrollLock: ie,
    showOnFocus: ie,
    showOnTap: ie,
    touchUi: ie,
    onBeforeClose: le,
    onBeforeShow: le,
    onCancel: le,
    onClose: le,
    onDestroy: le,
    onMarkupReady: le,
    onPosition: le,
    onShow: le
  },
      fe = {
    circular: n.oneOfType([ie, n.arrayOf(ie)]),
    height: ce,
    maxWidth: de,
    minWidth: de,
    multiline: ce,
    readOnly: n.oneOfType([ie, n.arrayOf(ie)]),
    rows: ce,
    showLabel: ie,
    showScrollArrows: ie,
    wheels: n.array,
    width: ce,
    onChange: le,
    validate: le,
    onSet: le,
    onItemTap: le,
    onClear: le,
    cancelText: re,
    clearText: re,
    selectedText: re,
    setText: re,
    formatValue: le,
    parseValue: le
  };
  n.array, n.oneOf(["iso8601", "moment", "locale", "jsdate"]), n.shape({
    hour: ce,
    minute: ce,
    second: ce,
    zeroBased: ie
  }), n.array, n.oneOf(["jalali", "hijri", "gregorian"]), n.arrayOf(re), n.arrayOf(re), n.arrayOf(re), n.arrayOf(re), n.oneOf(["horizontal", "vertical"]), n.oneOfType([me, n.array]), n.arrayOf(n.shape({
    start: me,
    end: me,
    d: n.oneOfType([ue, ce, re]),
    text: re,
    color: re,
    background: re,
    cssClass: re
  })), n.arrayOf(n.shape({
    start: me,
    end: me,
    d: n.oneOfType([ue, ce, re]),
    text: re,
    color: re,
    background: re,
    cssClass: re
  })), n.arrayOf(n.oneOfType([ue, ce, re, n.shape({
    d: n.oneOfType([ue, re, ce]),
    color: re,
    background: re,
    cssClass: re
  })])), n.arrayOf(n.shape({
    d: n.oneOfType([ue, re, ce]),
    background: re,
    cssClass: re
  })), n.oneOf(["year", "month"]), n.oneOf(["full", "short", "min"]), n.arrayOf(re), n.arrayOf(re);

  function Te(e, n) {
    var s = t.findDOMNode(this),
        a = e.replace(/\s+/g, " ").trim(),
        o = n.replace(/\s+/g, " ").trim();
    a && s.classList.remove.apply(s.classList, a.split(" ")), o && s.classList.add.apply(s.classList, o.split(" "));
  }

  function xe(e, t) {
    var n = [],
        s = [];
    return function e(t, a) {
      var i;
      if (isNaN(t) && isNaN(a) && "number" == typeof t && "number" == typeof a) return !0;
      if (t === a) return !0;
      if ("function" == typeof t && "function" == typeof a) return !1;
      if (t instanceof Date && a instanceof Date || t instanceof RegExp && a instanceof RegExp || t instanceof String && a instanceof String || t instanceof Number && a instanceof Number) return t.toString() === a.toString();
      if (!(t instanceof Object && a instanceof Object)) return !1;
      if (t.isPrototypeOf(a) || a.isPrototypeOf(t)) return !1;
      if (t.constructor !== a.constructor) return !1;
      if (t.prototype !== a.prototype) return !1;
      if (n.indexOf(t) > -1 || s.indexOf(a) > -1) return !1;

      for (i in a) {
        if (a.hasOwnProperty(i) !== t.hasOwnProperty(i)) return !1;
        if (o(a[i]) !== o(t[i])) return !1;
      }

      for (i in t) {
        if (a.hasOwnProperty(i) !== t.hasOwnProperty(i)) return !1;
        if (o(a[i]) !== o(t[i])) return !1;

        switch (o(t[i])) {
          case "object":
          case "function":
            if (n.push(t), s.push(a), !e(t[i], a[i])) return !1;
            n.pop(), s.pop();
            break;

          default:
            if (t[i] !== a[i]) return !1;
        }
      }

      return !0;
    }(e, t);
  }

  var be,
      ve,
      ye,
      ge,
      Se = function (e) {
    function t(e) {
      i(this, t);
      var n = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
      return n.initialCssClass = n.props.className || "", n;
    }

    return c(t, e), r(t, [{
      key: "render",
      value: function value() {
        return null;
      }
    }, {
      key: "getSettingsFromProps",
      value: function value(e, t) {
        var n = {};

        if (void 0 !== e) {
          /* eslint-disable no-unused-vars */
          var s = e.options,
              a = (e.children, e.value, e.data, e.className, function (e, t) {
            var n = {};

            for (var s in e) {
              t.indexOf(s) >= 0 || Object.prototype.hasOwnProperty.call(e, s) && (n[s] = e[s]);
            }

            return n;
          }(e, ["options", "children", "value", "data", "className"])),
              o = s || "{}";
          n = s || {}, void 0 !== s && "string" == typeof o && (n = new Function("return " + o + ";")()), n = Q({}, n, a, t || {});
        }

        return n;
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.instance.destroy(), delete this.instance;
      }
    }]), t;
  }(e.Component),
      _e = function (e) {
    function t(e) {
      return i(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    }

    return c(t, Se), r(t, [{
      key: "componentDidUpdate",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.optimizeUpdate ? (this.optimizeUpdate.updateOptions && this.instance.option(e), this.optimizeUpdate.updateValue && void 0 !== this.props.value && !xe(this.props.value, this.instance.getVal()) && this.instance.setVal(this.props.value, !0)) : (this.instance.option(e), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0));
      }
    }]), t;
  }(),
      ke = function (e) {
    function t(e) {
      return i(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    }

    return c(t, _e), r(t, [{
      key: "shouldComponentUpdate",
      value: function value(e) {
        var t = !xe(this.getSettingsFromProps(e), this.getSettingsFromProps(this.props)),
            n = !xe(e.value, this.props.value),
            s = !xe(e.children, this.props.children);
        return this.optimizeUpdate = {
          updateOptions: t,
          updateValue: n,
          updateChildren: s
        }, t || n || s;
      }
    }]), t;
  }();

  te = ee = function (n) {
    function s() {
      return i(this, s), u(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
    }

    return c(s, ke), r(s, [{
      key: "render",
      value: function value() {
        var t = this.props,
            n = t.type,
            s = t.readOnly,
            a = t.disabled,
            o = t.placeholder;
        return n = n || "text", this.props.children ? this.props.children : e.createElement("input", {
          className: this.initialCssClass,
          type: n,
          readOnly: s,
          disabled: a,
          placeholder: o
        });
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props, this.mbscInit),
            n = t.findDOMNode(this),
            s = Y(n).find("input");
        s.length && (n = s), this.instance = new Z[this.mbscInit.component || "Scroller"](n, e), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0);
      }
    }]), s;
  }(), ee.propTypes = oe({}, pe, he), se = ne = function (n) {
    function s() {
      return i(this, s), u(this, (s.__proto__ || Object.getPrototypeOf(s)).apply(this, arguments));
    }

    return c(s, ke), r(s, [{
      key: "render",
      value: function value() {
        return e.createElement("ul", {
          className: this.initialCssClass + " mbsc-cloak"
        }, this.props.children);
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props, this.mbscInit),
            n = t.findDOMNode(this);
        this.instance = new Z[this.mbscInit.component || "Scroller"](n, e), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0), (this.instance._markup || Y(n)).on("click", function (e) {
          e.stopPropagation();
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        !this.optimizeUpdate.updateOptions && this.optimizeUpdate.updateChildren && this.instance.option(this.getSettingsFromProps(this.props));
        var e = t.findDOMNode(this);
        (this.instance._markup || Y(e)).on("click", function (e) {
          e.stopPropagation();
        });
      }
    }]), s;
  }(), ne.propTypes = oe({}, pe, he, fe);

  function Me(e) {
    var t;

    for (t in e) {
      if (void 0 !== ve[e[t]]) return !0;
    }

    return !1;
  }

  function we(e, t) {
    if ("touchstart" == e.type) Y(t).attr("data-touch", "1");else if (Y(t).attr("data-touch")) return Y(t).removeAttr("data-touch"), !1;
    return !0;
  }

  N && (ve = document.createElement("modernizr").style, function () {
    var e,
        t = ["Webkit", "Moz", "O", "ms"];

    for (e in t) {
      if (Me([t[e] + "Transform"])) return "-" + t[e].toLowerCase() + "-";
    }

    return "";
  }().replace(/^\-/, "").replace(/\-$/, "").replace("moz", "Moz"), be = void 0 !== ve.animation ? "animationend" : "webkitAnimationEnd", ge = void 0 !== ve.transition, ye = void 0 === ve.touchAction || "ios" == g && !D);
  var Ce = "mbsc-input-wrap",
      Ne = ["touchstart", "touchmove", "touchend", "touchcancel", "mousedown", "mousemove", "mouseup", "mouseleave"],
      Oe = {
    tap: ye
  },
      De = void 0;

  function Ee(e, t) {
    var n = {},
        s = e.parent(),
        a = s.find(".mbsc-err-msg"),
        o = e.attr("data-icon-align") || "left",
        i = e.attr("data-icon");
    s.hasClass(Ce) ? s = s.parent() : Y('<span class="' + Ce + '"></span>').insertAfter(e).append(e), a && s.find("." + Ce).append(a), i && (-1 !== i.indexOf("{") ? n = JSON.parse(i) : n[o] = i), (i || t) && (Q(n, t), s.addClass((n.right ? "mbsc-ic-right " : "") + (n.left ? " mbsc-ic-left" : "")).find("." + Ce).append('<span class="mbsc-input-fill"></span>').append(n.left ? '<span class="mbsc-input-ic mbsc-left-ic mbsc-ic mbsc-ic-' + n.left + '"></span>' : "").append(n.right ? '<span class="mbsc-input-ic mbsc-right-ic mbsc-ic mbsc-ic-' + n.right + '"></span>' : ""));
  }

  function Pe(e, t, n, s, a) {
    "button" != t && "submit" != t && "segmented" != t && (e.addClass("mbsc-control-w").addClass("box" == n ? "mbsc-input-box" : "").addClass("outline" == n ? "mbsc-input-outline" : "").addClass("inline" == s ? "mbsc-label-inline" : "").addClass("stacked" == s ? "mbsc-label-stacked" : "").addClass("floating" == s ? "mbsc-label-floating" : "").addClass("floating" == s && a.value ? "mbsc-label-floating-active" : "").find("label").addClass("mbsc-label").each(function (e, t) {
      Y(t).attr("title", Y(t).text());
    }), e.contents().filter(function () {
      return 3 == this.nodeType && this.nodeValue && /\S/.test(this.nodeValue);
    }).each(function () {
      Y('<span class="mbsc-label" title="' + this.textContent.trim() + '"></span>').insertAfter(this).append(this);
    }));
  }

  function Ae(e) {
    var t = s.themes.form[e];
    return t && t.addRipple ? t : null;
  }

  function Fe(e, t, n) {
    var s = e.attr(t);
    return void 0 === s || "" === s ? n : s;
  }

  var Le = function () {
    function e(t, n) {
      var a = this;
      i(this, e);
      var o = Q({}, Oe, s.settings, n),
          r = Y(t),
          l = r.parent(),
          c = l.hasClass("mbsc-input-wrap") ? l.parent() : l,
          u = r.next().hasClass("mbsc-fr") ? r.next() : null,
          m = R(r),
          d = Fe(r, "data-input-style", o.inputStyle),
          p = Fe(r, "data-label-style", o.labelStyle);
      u && u.insertAfter(c), Pe(c, m, d, p, t), r.addClass("mbsc-control"), Ne.forEach(function (e) {
        t.addEventListener(e, a);
      }), this.settings = o, this._type = m, this._elm = t, this._$elm = r, this._$parent = c, this._$frame = u, this._ripple = Ae(o.theme), this._isFloating = "floating" == p || c.hasClass("mbsc-label-floating"), t.mbscInst = this;
    }

    return r(e, [{
      key: "destroy",
      value: function value() {
        var e = this;
        this._$elm.removeClass("mbsc-control"), Ne.forEach(function (t) {
          e._elm.removeEventListener(t, e);
        }), delete this._elm.mbscInst;
      }
    }, {
      key: "option",
      value: function value(e) {
        Q(this.settings, e), this._ripple = Ae(this.settings.theme);
      }
    }, {
      key: "handleEvent",
      value: function value(e) {
        switch (e.type) {
          case "touchstart":
          case "mousedown":
            this._onStart(e);

            break;

          case "touchmove":
          case "mousemove":
            this._onMove(e);

            break;

          case "touchend":
          case "touchcancel":
          case "mouseup":
          case "mouseleave":
            this._onEnd(e);

        }
      }
    }, {
      key: "_addRipple",
      value: function value(e) {
        this._ripple && this._$rippleElm && this._ripple.addRipple(this._$rippleElm, e);
      }
    }, {
      key: "_removeRipple",
      value: function value() {
        this._ripple && this._$rippleElm && this._ripple.removeRipple();
      }
    }, {
      key: "_onStart",
      value: function value(e) {
        var t = this._elm;
        we(e, t) && (this._startX = U(e, "X"), this._startY = U(e, "Y"), De && De.removeClass("mbsc-active"), t.disabled || (this._isActive = !0, (De = this._$elm).addClass("mbsc-active"), this._addRipple(e)));
      }
    }, {
      key: "_onMove",
      value: function value(e) {
        (this._isActive && Math.abs(U(e, "X") - this._startX) > 9 || Math.abs(U(e, "Y") - this._startY) > 9) && (this._$elm.removeClass("mbsc-active"), this._removeRipple(), this._isActive = !1);
      }
    }, {
      key: "_onEnd",
      value: function value(e) {
        var t = this,
            n = this._elm,
            s = this._type;
        this._isActive && this.settings.tap && "touchend" == e.type && !n.readOnly && $(n, s, e), this._isActive && setTimeout(function () {
          t._$elm.removeClass("mbsc-active"), t._removeRipple();
        }, 100), this._isActive = !1, De = null;
      }
    }]), e;
  }(),
      He = ["focus", "change", "blur", "animationstart"],
      je = function (e) {
    function t(e, n) {
      i(this, t);
      var s,
          a,
          o,
          r,
          l,
          c,
          m,
          d,
          p = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
      return s = p, a = p._$parent, o = p._$elm, r = {}, l = o[0], c = o.attr("data-password-toggle"), m = o.attr("data-icon-show") || "eye", d = o.attr("data-icon-hide") || "eye-blocked", c && (r.right = "password" == l.type ? m : d), Ee(o, r), c && B(s, a.find(".mbsc-right-ic").addClass("mbsc-input-toggle"), function () {
        "text" == l.type ? (l.type = "password", Y(this).addClass("mbsc-ic-" + m).removeClass("mbsc-ic-" + d)) : (l.type = "text", Y(this).removeClass("mbsc-ic-" + m).addClass("mbsc-ic-" + d));
      }), p._$parent.addClass("mbsc-input"), p.checkLabel = p.checkLabel.bind(p), He.forEach(function (e) {
        p._$elm.on(e, p.checkLabel);
      }), p;
    }

    return c(t, Le), r(t, [{
      key: "checkLabel",
      value: function value(e) {
        this._isFloating && (this._elm.value || e && ("focus" == e.type || "animationstart" == e.type && this._$elm.is("*:-webkit-autofill")) ? this._$parent.addClass("mbsc-label-floating-active") : this._$parent.removeClass("mbsc-label-floating-active"));
      }
    }, {
      key: "refresh",
      value: function value() {
        this.checkLabel();
      }
    }, {
      key: "destroy",
      value: function value() {
        var e = this;
        l(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "destroy", this).call(this), this._$parent.removeClass("mbsc-ic-left mbsc-ic-right").find(".mbsc-input-ic").remove(), this._$parent.find(".mbsc-input-fill").remove(), He.forEach(function (t) {
          e._$elm.off(t, e.checkLabel);
        });
      }
    }]), t;
  }(),
      ze = function (e) {
    function t(e, n) {
      i(this, t);
      var s = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n)),
          a = s._$elm,
          o = a.attr("data-icon");
      return a.addClass("mbsc-btn").find(".mbsc-btn-ic").remove(), o && (a.prepend('<span class="mbsc-btn-ic mbsc-ic mbsc-ic-' + o + '"></span>'), "" === a.text() && a.addClass("mbsc-btn-icon-only")), s._$rippleElm = a, s;
    }

    return c(t, Le), t;
  }(),
      Ve = function (e) {
    function t(e, n) {
      i(this, t);
      var s = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
      return s._$parent.prepend(s._$elm).addClass("mbsc-checkbox mbsc-control-w").find(".mbsc-checkbox-box").remove(), s._$elm.after('<span class="mbsc-checkbox-box"></span>'), s;
    }

    return c(t, Le), t;
  }(),
      Ie = function (e) {
    function t(e, n) {
      i(this, t);
      var s = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
      return s._$parent.addClass("mbsc-radio mbsc-control-w").find(".mbsc-radio-box").remove(), s._$elm.after('<span class="mbsc-radio-box"><span></span></span>'), s;
    }

    return c(t, Le), t;
  }(),
      Je = function (e) {
    function t(e, n) {
      i(this, t);
      var s = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n)),
          a = s._$elm,
          o = s._$parent,
          r = o.find("input.mbsc-control"),
          l = r.length ? r : Y('<input tabindex="-1" class="mbsc-control" readonly>');
      return s._$input = l, s._setText = s._setText.bind(s), o.addClass("mbsc-select" + (s._$frame ? " mbsc-select-inline" : "")), a.after(l), l.after('<span class="mbsc-select-ic mbsc-ic mbsc-ic-arrow-down5"></span>'), a.hasClass("mbsc-comp") || (a.on("change", s._setText), s._setText()), s;
    }

    return c(t, je), r(t, [{
      key: "destroy",
      value: function value() {
        l(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "destroy", this).call(this), this._$parent.find(".mbsc-select-ic").remove(), this._$elm.off("change", this._setText);
      }
    }, {
      key: "_setText",
      value: function value() {
        var e = this._elm;
        this._$elm.hasClass("mbsc-comp") || this._$input.val(-1 != e.selectedIndex ? e.options[e.selectedIndex].text : "");
      }
    }]), t;
  }(),
      Ue = ["keydown", "input", "scroll"],
      Re = void 0;

  function $e() {
    clearTimeout(Re), Re = setTimeout(function () {
      Y("textarea.mbsc-control").each(function () {
        Be(this);
      });
    }, 100);
  }

  function Be(e) {
    var t = void 0,
        n = void 0,
        s = void 0,
        a = Y(e).attr("rows") || 6;
    e.offsetHeight && (e.style.height = "", s = e.scrollHeight - e.offsetHeight, t = e.offsetHeight + (s > 0 ? s : 0), (n = Math.round(t / 24)) > a ? (t = 24 * a + (t - 24 * n), Y(e).addClass("mbsc-textarea-scroll")) : Y(e).removeClass("mbsc-textarea-scroll"), t && (e.style.height = t + "px"));
  }

  N && Y(window).on("resize orientationchange", $e);

  var We = function (e) {
    function t(e, n) {
      i(this, t);
      var s = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n));
      return s._$parent.addClass("mbsc-textarea"), Ue.forEach(function (e) {
        s._elm.addEventListener(e, s);
      }), Be(e), s;
    }

    return c(t, je), r(t, [{
      key: "destroy",
      value: function value() {
        var e = this;
        l(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "destroy", this).call(this), Ue.forEach(function (t) {
          e._elm.removeEventListener(t, e);
        });
      }
    }, {
      key: "handleEvent",
      value: function value(e) {
        switch (l(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "handleEvent", this).call(this, e), e.type) {
          case "keydown":
          case "input":
            this._onInput(e);

            break;

          case "scroll":
            !function (e) {
              var t = Y(e);

              if (!t.hasClass("mbsc-textarea-scroll")) {
                var n = e.scrollHeight - e.offsetHeight,
                    s = e.offsetHeight + n;
                Math.round(s / 24) <= (t.attr("rows") || 6) && (e.scrollTop = 0, e.style.height = s + "px");
              }
            }(this._elm);
        }
      }
    }, {
      key: "_onInput",
      value: function value() {
        var e = this;
        clearTimeout(this._debounce), this._debounce = setTimeout(function () {
          Be(e._elm);
        }, 100);
      }
    }, {
      key: "refresh",
      value: function value() {
        l(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "refresh", this).call(this), clearTimeout(this._debounce), Be(this._elm);
      }
    }]), t;
  }(),
      Ke = function (e) {
    function t(e, n) {
      i(this, t);
      var s = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n)),
          a = void 0,
          o = void 0,
          r = s._$elm,
          l = s._$parent;
      return l.hasClass("mbsc-segmented-item-ready") || (a = Y('<div class="mbsc-segmented"></div>'), l.after(a), l.parent().find('input[name="' + r.attr("name") + '"]').each(function () {
        var e = Y(this);
        o = e.parent().addClass("mbsc-segmented-item mbsc-segmented-item-ready"), Y('<span class="mbsc-segmented-content">' + (e.attr("data-icon") ? '<span class="mbsc-ic mbsc-ic-' + e.attr("data-icon") + '"></span>' : "") + "</span>").append(o.contents()).appendTo(o), o.prepend(e), a.append(o);
      })), s._$rippleElm = r.next(), s;
    }

    return c(t, Le), t;
  }();

  var Ye = function Ye(e, t) {
    var n,
        a,
        o,
        i,
        r,
        l,
        c,
        u,
        m,
        d,
        p,
        h,
        f,
        T,
        x,
        b = this,
        v = Y(e),
        y = f;

    function g() {
      var t;
      e.disabled || (t = parseFloat(Y(this).val()), k(isNaN(t) ? f : t));
    }

    function S() {
      return e.disabled;
    }

    function _(e, t) {
      k(f + t * m);
    }

    function k(e, t, s) {
      y = f, void 0 === t && (t = !0), void 0 === s && (s = t), f = Math.min(r, Math.max(Math.round(e / m) * m, l)), o.removeClass("mbsc-disabled"), t && v.val(f), f == l ? a.addClass("mbsc-disabled") : f == r && n.addClass("mbsc-disabled"), f !== y && s && v.trigger("change");
    }

    function M(e, t, n) {
      var s = v.attr(e);
      return void 0 === s || "" === s ? t : n ? s : +s;
    }

    ae.call(this, e, t, !0), b.getVal = function () {
      var e = parseFloat(v.val());
      return e = isNaN(e) ? f : e, Math.min(r, Math.max(Math.round(e / m) * m, l));
    }, b.setVal = function (e, t, n) {
      e = parseFloat(e), k(isNaN(e) ? f : e, t, n);
    }, b._init = function () {
      T = v.parent().hasClass("mbsc-stepper"), x = T ? v.closest(".mbsc-stepper-cont") : v.parent(), p = b.settings, l = void 0 === t.min ? M("min", p.min) : t.min, r = void 0 === t.max ? M("max", p.max) : t.max, m = void 0 === t.step ? M("step", p.step) : t.step, c = void 0 === t.inputStyle ? M("data-input-style", p.inputStyle, !0) : t.inputStyle, i = v.attr("data-val") || p.val, f = Math.min(r, Math.max(Math.round(+e.value / m) * m || 0, l)), h = s.themes.form[p.theme], u = h && h.addRipple ? h : null, T || x.addClass("mbsc-stepper-cont mbsc-control-w").addClass("box" == c ? "mbsc-input-box" : "").addClass("outline" == c ? "mbsc-input-outline" : "").append('<span class="mbsc-segmented mbsc-stepper"></span>').find(".mbsc-stepper").append('<span class="mbsc-segmented-item mbsc-stepper-control mbsc-stepper-minus ' + (f == l ? "mbsc-disabled" : "") + '" data-step="-1" tabindex="0"><span class="mbsc-segmented-content"><span class="mbsc-ic mbsc-ic-minus"></span></span></span>').append('<span class="mbsc-segmented-item mbsc-stepper-control mbsc-stepper-plus ' + (f == r ? "mbsc-disabled" : "") + '"  data-step="1" tabindex="0"><span class="mbsc-segmented-content"> <span class="mbsc-ic mbsc-ic-plus"></span></span></span>').prepend(v), a = Y(".mbsc-stepper-minus", x), n = Y(".mbsc-stepper-plus", x), o = Y(".mbsc-stepper-control", x), T || ("left" == i ? (x.addClass("mbsc-stepper-val-left"), v.after('<span class="mbsc-segmented-item"><span class="mbsc-segmented-content"></span></span>')) : "right" == i ? (x.addClass("mbsc-stepper-val-right"), n.after('<span class="mbsc-segmented-item"><span class="mbsc-segmented-content"></span></span>')) : a.after('<span class="mbsc-segmented-item"><span class="mbsc-segmented-content mbsc-stepper-val"></span></span>')), d || (v.on("change", g), d = function (e, t, n, s, a, o) {
        var i,
            r,
            l,
            c,
            u,
            m,
            d,
            p,
            h,
            f = s || A;

        function T(e) {
          var t;
          i = Y(this), p = +i.attr("data-step"), l = +i.attr("data-index"), r = !0, a && e.stopPropagation(), "mousedown" == e.type && e.preventDefault(), "keydown" != e.type ? (m = U(e, "X"), d = U(e, "Y"), t = we(e, this)) : t = 32 === e.keyCode, c || !t || i.hasClass("mbsc-disabled") || (y(l, p, e) && (i.addClass("mbsc-active"), o && o.addRipple(i.find(".mbsc-segmented-content"), e)), "mousedown" == e.type && Y(document).on("mousemove", x).on("mouseup", b));
        }

        function x(e) {
          (Math.abs(m - U(e, "X")) > 7 || Math.abs(d - U(e, "Y")) > 7) && (r = !0, v());
        }

        function b(e) {
          "touchend" == e.type && e.preventDefault(), v(), "mouseup" == e.type && Y(document).off("mousemove", x).off("mouseup", b);
        }

        function v() {
          c = !1, clearInterval(h), i && (i.removeClass("mbsc-active"), o && setTimeout(function () {
            o.removeRipple();
          }, 100));
        }

        function y(e, t, n) {
          return c || f(e) || (l = e, p = t, u = n, c = !0, r = !1, setTimeout(g, 100)), c;
        }

        function g() {
          i && i.hasClass("mbsc-disabled") ? v() : (!c && r || (r = !0, t(l, p, u, g)), c && n && (clearInterval(h), h = setInterval(function () {
            t(l, p, u);
          }, n)));
        }

        return e.on("touchstart mousedown keydown", T).on("touchmove", x).on("touchend touchcancel keyup", b), {
          start: y,
          stop: v,
          destroy: function destroy() {
            e.off("touchstart mousedown keydown", T).off("touchmove", x).off("touchend touchcancel keyup", b);
          }
        };
      }(o, _, 150, S, !1, u)), v.val(f).attr("data-role", "stepper").attr("min", l).attr("max", r).attr("step", m).addClass("mbsc-control"), e.mbscInst = b;
    }, b._destroy = function () {
      v.removeClass("mbsc-control").off("change", g), d.destroy(), delete e.mbscInst;
    }, b.init();
  };

  Ye.prototype = {
    _class: "stepper",
    _hasDef: !0,
    _hasTheme: !0,
    _defaults: {
      min: 0,
      max: 100,
      step: 1
    }
  }, Z.Stepper = Ye;

  var Ge = function Ge(e, t, n) {
    var s,
        a,
        o,
        i,
        r = this;
    ae.call(this, e, t, !0), r.__init = A, r.__destroy = A, r._init = function () {
      var t;
      i = r.settings, s = Y(e), t = !!a, a = (a = s.parent()).hasClass("mbsc-input-wrap") ? a.parent() : a, r._$parent = a, o && a.removeClass(o), o = r._css + " mbsc-progress-w mbsc-control-w mbsc-" + i.theme + (i.baseTheme ? " mbsc-" + i.baseTheme : "") + (i.rtl ? " mbsc-rtl" : " mbsc-ltr"), a.addClass(o), s.addClass("mbsc-control"), r.__init(), t || r._attachChange(), r.refresh(), e.mbscInst = r;
    }, r._destroy = function () {
      r.__destroy(), a.removeClass(o), s.removeClass("mbsc-control"), delete e.mbscInst;
    }, n || r.init();
  },
      qe = function qe(e, t, n) {
    var s,
        a,
        o,
        i,
        r,
        l,
        c,
        u,
        m,
        d,
        p,
        h,
        f,
        T,
        x,
        b,
        v,
        y,
        g,
        S,
        _,
        k,
        M,
        w,
        C,
        N,
        O,
        D,
        E,
        P,
        F,
        L,
        j,
        z,
        V = this,
        I = new Date();

    function R(t) {
      "mousedown" === t.type && t.preventDefault(), !we(t, this) || u && !v || e.disabled || e.readOnly || (O.stopProp && t.stopPropagation(), u = !0, M = !1, d = !1, E = U(t, "X"), P = U(t, "Y"), T = E, c.removeClass("mbsc-progress-anim"), a = w ? Y(".mbsc-slider-handle", this) : i, o && o.removeClass("mbsc-handle-curr"), o = a.parent().addClass("mbsc-active mbsc-handle-curr"), s.addClass("mbsc-active"), b = +a.attr("data-index"), j = c[0].offsetWidth, f = c[0].getBoundingClientRect().left, "mousedown" === t.type && (y = !0, Y(document).on("mousemove", $).on("mouseup", B)), "mouseenter" === t.type && (v = !0, Y(document).on("mousemove", $)));
    }

    function $(e) {
      u && (T = U(e, "X"), x = U(e, "Y"), p = T - E, h = x - P, Math.abs(p) > 5 && (M = !0), (M || y || v) && Math.abs(I - new Date()) > 50 && (I = new Date(), ee(T, O.round, S && (!v || y))), M ? e.preventDefault() : Math.abs(h) > 7 && "touchmove" == e.type && Q());
    }

    function B(e) {
      u && (e.preventDefault(), w || c.addClass("mbsc-progress-anim"), v && !y ? te(z[b], b, !1, !1, !0) : ee(T, !0, !0), M || d || ("touchend" == e.type && J(), V._onTap(z[b])), "mouseup" == e.type && (y = !1), "mouseleave" == e.type && (v = !1), v || Q());
    }

    function W() {
      u && Q();
    }

    function K() {
      var e = V._readValue(Y(this)),
          t = +Y(this).attr("data-index");

      e !== z[t] && (z[t] = e, C[t] = e, te(e, t));
    }

    function G(e) {
      e.stopPropagation();
    }

    function q(e) {
      e.preventDefault();
    }

    function Z(t) {
      var n;

      if (!e.disabled) {
        switch (t.keyCode) {
          case 38:
          case 39:
            n = 1;
            break;

          case 40:
          case 37:
            n = -1;
        }

        n && (t.preventDefault(), L || (b = +Y(this).attr("data-index"), te(z[b] + N * n, b, !0), L = setInterval(function () {
          te(z[b] + N * n, b, !0);
        }, 200)));
      }
    }

    function X(e) {
      e.preventDefault(), clearInterval(L), L = null;
    }

    function Q() {
      u = !1, o.removeClass("mbsc-active"), s.removeClass("mbsc-active"), Y(document).off("mousemove", $).off("mouseup", B);
    }

    function ee(e, t, n) {
      var s = t ? Math.min(Math[V._rounding || "round"](Math.max(100 * (e - f) / j, 0) / D / N) * N * 100 / (_ - k + m), 100) : Math.max(0, Math.min(100 * (e - f) / j, 100));
      g && (s = 100 - s), te(Math.round((k - m + s / D) * F) / F, b, n, s);
    }

    function te(e, t, n, s, a, o) {
      var r = i.eq(t),
          l = r.parent();
      e = Math.min(_, Math.max(e, k)), void 0 === o && (o = n), V._update ? e = V._update(e, z, t, s, w, a, l) : l.css({
        left: g ? "auto" : (s || H(e, k, _)) + "%",
        right: g ? (s || H(e, k, _)) + "%" : "auto"
      }), e > k ? l.removeClass("mbsc-slider-start") : (z[t] > k || a) && l.addClass("mbsc-slider-start"), n && (z[t] = e), n && C[t] != e && (d = !0, C[t] = e, V._fillValue(e, t, o)), r.attr("aria-valuenow", e);
    }

    Ge.call(this, e, t, !0), V._onTap = A, V.___init = A, V.___destroy = A, V._attachChange = function () {
      s.on(O.changeEvent, K);
    }, V.__init = function () {
      var e;
      i && (e = !0, i.parent().remove()), V.___init(), l = V._$parent, c = V._$track, s = l.find("input"), O = V.settings, k = V._min, _ = V._max, m = V._base || 0, N = V._step, S = V._live, F = N % 1 != 0 ? 100 / (100 * +(N % 1).toFixed(2)) : 1, D = 100 / (_ - k + m) || 100, w = s.length > 1, g = O.rtl, z = [], C = [], s.each(function (e) {
        z[e] = V._readValue(Y(this)), Y(this).attr("data-index", e);
      }), i = l.find(".mbsc-slider-handle"), r = l.find(w ? ".mbsc-slider-handle-cont" : ".mbsc-progress-cont"), i.on("keydown", Z).on("keyup", X).on("blur", X), r.on("touchstart mousedown" + (O.hover ? " mouseenter" : ""), R).on("touchmove", $).on("touchend touchcancel" + (O.hover ? " mouseleave" : ""), B).on("pointercancel", W), e || (s.on("click", G), l.on("click", q));
    }, V.__destroy = function () {
      l.off("click", q), s.off(O.changeEvent, K).off("click", G), i.off("keydown", Z).off("keyup", X).off("blur", X), r.off("touchstart mousedown mouseenter", R).off("touchmove", $).off("touchend touchcancel mouseleave", B).off("pointercancel", W), V.___destroy();
    }, V.refresh = function () {
      s.each(function (e) {
        te(V._readValue(Y(this)), e, !0, !1, !0, !1);
      });
    }, V.getVal = function () {
      return w ? z.slice(0) : z[0];
    }, V.setVal = V._setVal = function (e, t, n) {
      Y.isArray(e) || (e = [e]), Y.each(e, function (e, t) {
        z[e] = t;
      }), Y.each(e, function (e, t) {
        te(t, e, !0, !1, !0, n);
      });
    }, n || V.init();
  },
      Ze = function Ze(e, t) {
    var n,
        s,
        a,
        o,
        i = this;
    Q(t = t || {}, {
      changeEvent: "click",
      round: !1
    }), qe.call(this, e, t, !0), i._readValue = function () {
      return e.checked ? 1 : 0;
    }, i._fillValue = function (e, t, s) {
      n.prop("checked", !!e), s && n.trigger("change");
    }, i._onTap = function (e) {
      i._setVal(e ? 0 : 1);
    }, i.___init = function () {
      a = i.settings, n = Y(e), (s = n.parent()).find(".mbsc-switch-track").remove(), s.prepend(n), n.attr("data-role", "switch").after('<span class="mbsc-progress-cont mbsc-switch-track"><span class="mbsc-progress-track mbsc-progress-anim"><span class="mbsc-slider-handle-cont"><span class="mbsc-slider-handle mbsc-switch-handle" data-index="0"><span class="mbsc-switch-txt-off">' + a.offText + '</span><span class="mbsc-switch-txt-on">' + a.onText + "</span></span></span></span></span>"), o && o.destroy(), o = new Le(e, a), i._$track = s.find(".mbsc-progress-track"), i._min = 0, i._max = 1, i._step = 1;
    }, i.___destroy = function () {
      o.destroy();
    }, i.getVal = function () {
      return e.checked;
    }, i.setVal = function (e, t, n) {
      i._setVal(e ? 1 : 0, t, n);
    }, i.init();
  };

  Ze.prototype = {
    _class: "switch",
    _css: "mbsc-switch",
    _hasTheme: !0,
    _hasLang: !0,
    _hasDef: !0,
    _defaults: {
      stopProp: !0,
      offText: "Off",
      onText: "On"
    }
  }, Z.Switch = Ze;
  /* eslint-disable no-unused-vars */

  var Xe = function Xe(e, t, n) {
    var s,
        a,
        o,
        i,
        r,
        l,
        c,
        u,
        m,
        d,
        p,
        h,
        f,
        T,
        x = this;

    function b() {
      var e = v("value", c);
      e !== f && y(e);
    }

    function v(e, t, n) {
      var s = a.attr(e);
      return void 0 === s || "" === s ? t : n ? s : +s;
    }

    function y(e, t, n, s) {
      e = Math.min(u, Math.max(e, c)), i.css("width", 100 * (e - c) / (u - c) + "%"), void 0 === n && (n = !0), void 0 === s && (s = n), (e !== f || t) && x._display(e), e !== f && (f = e, n && a.attr("value", f), s && a.trigger("change"));
    }

    Ge.call(this, e, t, !0), x._display = function (e) {
      T = h && p.returnAffix ? h.replace(/\{value\}/, e).replace(/\{max\}/, u) : e, r && r.html(T), s && s.html(T);
    }, x._attachChange = function () {
      a.on("change", b);
    }, x.__init = function () {
      var n, T, b, y;
      if (p = x.settings, a = Y(e), y = !!o, o = x._$parent, c = x._min = void 0 === t.min ? v("min", p.min) : t.min, u = x._max = void 0 === t.max ? v("max", p.max) : t.max, m = void 0 === t.inputStyle ? v("data-input-style", p.inputStyle, !0) : t.inputStyle, d = void 0 === t.labelStyle ? v("data-label-style", p.labelStyle, !0) : t.labelStyle, f = v("value", c), n = a.attr("data-val") || p.val, b = (b = a.attr("data-step-labels")) ? JSON.parse(b) : p.stepLabels, h = a.attr("data-template") || (100 != u || p.template ? p.template : "{value}%"), y ? (n && (s.remove(), o.removeClass("mbsc-progress-value-" + ("right" == n ? "right" : "left"))), b && Y(".mbsc-progress-step-label", l).remove()) : (Pe(o, null, m, d, e), Ee(a), o.find(".mbsc-input-wrap").append('<span class="mbsc-progress-cont"><span class="mbsc-progress-track mbsc-progress-anim"><span class="mbsc-progress-bar"></span></span></span>'), i = x._$progress = o.find(".mbsc-progress-bar"), l = x._$track = o.find(".mbsc-progress-track")), a.attr("min", c).attr("max", u), n && (s = Y('<span class="mbsc-progress-value"></span>'), o.addClass("mbsc-progress-value-" + ("right" == n ? "right" : "left")).find(".mbsc-input-wrap").append(s)), b) for (T = 0; T < b.length; ++T) {
        l.append('<span class="mbsc-progress-step-label" style="' + (p.rtl ? "right" : "left") + ": " + 100 * (b[T] - c) / (u - c) + '%" >' + b[T] + "</span>");
      }
      r = Y(a.attr("data-target") || p.target);
    }, x.__destroy = function () {
      o.removeClass("mbsc-ic-left mbsc-ic-right").find(".mbsc-progress-cont").remove(), o.find(".mbsc-input-ic").remove(), a.off("change", b);
    }, x.refresh = function () {
      y(v("value", c), !0, !1);
    }, x.getVal = function () {
      return f;
    }, x.setVal = function (e, t, n) {
      y(e, !0, t, n);
    }, n || x.init();
  };

  Xe.prototype = {
    _class: "progress",
    _css: "mbsc-progress",
    _hasTheme: !0,
    _hasLang: !0,
    _hasDef: !0,
    _defaults: {
      min: 0,
      max: 100,
      returnAffix: !0
    }
  }, Z.Progress = Xe;

  var Qe = function Qe(e, t, n) {
    var s,
        a,
        o,
        i,
        r,
        l,
        c,
        u,
        m,
        d,
        p,
        h,
        f,
        T = this;
    Xe.call(this, e, t, !0);
    var x = T.__init,
        b = T.__destroy;
    qe.call(this, e, t, !0);
    var v = T.__init,
        y = T.__destroy;
    T.__init = function () {
      x(), v();
    }, T.__destroy = function () {
      b(), y();
    }, T._update = function (e, t, n, s, a, r, h) {
      return u ? 0 === n ? (e = Math.min(e, t[1]), o.css({
        width: H(t[1], p, d) - H(e, p, d) + "%",
        left: m ? "auto" : H(e, p, d) + "%",
        right: m ? H(e, p, d) + "%" : "auto"
      })) : (e = Math.max(e, t[0]), o.css({
        width: H(e, p, d) - H(t[0], p, d) + "%"
      })) : a || !l ? h.css({
        left: m ? "auto" : (s || H(e, p, d)) + "%",
        right: m ? (s || H(e, p, d)) + "%" : "auto"
      }) : o.css("width", (s || H(e, p, d)) + "%"), c && i.eq(n).html(e), a || t[n] == e && !r || T._display(e), e;
    }, T._readValue = function (e) {
      return +e.val();
    }, T._fillValue = function (e, t, n) {
      s.eq(t).val(e), n && s.eq(t).trigger("change");
    }, T._markupReady = function () {
      var e, t;
      if (c && a.addClass("mbsc-slider-has-tooltip"), 1 != h) for (t = (d - p) / h, e = 0; e <= t; ++e) {
        r.append('<span class="mbsc-slider-step" style="' + (m ? "right" : "left") + ":" + 100 / t * e + '%"></span>');
      }
      s.each(function (e) {
        "range" == this.type && Y(this).attr("min", p).attr("max", d).attr("step", h), (l ? o : r).append('<span class="mbsc-slider-handle-cont' + (u && !e ? " mbsc-slider-handle-left" : "") + '"><span tabindex="0" class="mbsc-slider-handle" aria-valuemin="' + p + '" aria-valuemax="' + d + '" data-index="' + e + '"></span>' + (c ? '<span class="mbsc-slider-tooltip"></span>' : "") + "</span>");
      }), i = a.find(".mbsc-slider-tooltip");
    }, T.___init = function () {
      a && (a.removeClass("mbsc-slider-has-tooltip"), 1 != h && Y(".mbsc-slider-step", r).remove()), a = T._$parent, r = T._$track, o = T._$progress, s = a.find("input"), f = T.settings, p = T._min, d = T._max, T._step = h = void 0 === t.step ? +s.attr("step") || f.step : t.step, T._live = j("data-live", f.live, s), c = j("data-tooltip", f.tooltip, s), l = j("data-highlight", f.highlight, s) && s.length < 3, u = l && 2 == s.length, m = f.rtl, T._markupReady();
    }, n || T.init();
  };

  Qe.prototype = {
    _class: "progress",
    _css: "mbsc-progress mbsc-slider",
    _hasTheme: !0,
    _hasLang: !0,
    _hasDef: !0,
    _defaults: {
      changeEvent: "change",
      stopProp: !0,
      min: 0,
      max: 100,
      step: 1,
      live: !0,
      highlight: !0,
      round: !0,
      returnAffix: !0
    }
  }, Z.Slider = Qe;

  var et = function et(e, t, n) {
    var s,
        a,
        o,
        i,
        r,
        l,
        c,
        u = this,
        m = Y(e);
    Qe.call(this, e, t, !0), u._update = function (e, t, n, a, i, r) {
      return s.css("width", H(e, 0, o) + "%"), i || t[n] == e && !r || u._display(e), e;
    }, u._markupReady = function () {
      var e,
          t = "",
          n = "";

      for (a = u._$track, s = u._$progress, c = u.settings, i = u._min, o = u._max, u._base = i, u._rounding = c.rtl ? "floor" : "ceil", r = m.attr("data-empty") || c.empty, l = m.attr("data-filled") || c.filled, e = 0; e < o; ++e) {
        t += '<span class="mbsc-ic mbsc-ic-' + r + '"></span>', n += '<span class="mbsc-ic mbsc-ic-' + l + '"></span>';
      }

      a.html(t), a.append(s), s.html(n), a.append('<span class="mbsc-rating-handle-cont"><span tabindex="0" class="mbsc-slider-handle" aria-valuemin="' + i + '" aria-valuemax="' + o + '" data-index="0"></span></span>');
    }, n || u.init();
  };

  et.prototype = {
    _class: "progress",
    _css: "mbsc-progress mbsc-rating",
    _hasTheme: !0,
    _hasLang: !0,
    _hasDef: !0,
    _defaults: {
      changeEvent: "change",
      stopProp: !0,
      min: 1,
      max: 5,
      step: 1,
      live: !0,
      round: !0,
      hover: !0,
      highlight: !0,
      returnAffix: !0,
      empty: "star",
      filled: "star3"
    }
  }, Z.Rating = et;

  var tt = 1,
      nt = function () {
    function e(t, n) {
      var s = this;
      i(this, e);
      var a = void 0,
          o = void 0,
          r = void 0,
          l = Y(t);

      if (this.settings = n, this._isOpen = n.isOpen || !1, l.addClass("mbsc-collapsible " + (this._isOpen ? "mbsc-collapsible-open" : "")), l.hasClass("mbsc-card") ? (o = l.find(".mbsc-card-header").eq(0).addClass("mbsc-collapsible-header"), r = l.find(".mbsc-card-content").eq(0).addClass("mbsc-collapsible-content")) : l.hasClass("mbsc-form-group") || l.hasClass("mbsc-form-group-inset") ? (o = l.find(".mbsc-form-group-title").eq(0).addClass("mbsc-collapsible-header"), r = l.find(".mbsc-form-group-content").eq(0).addClass("mbsc-collapsible-content")) : (o = l.find(".mbsc-collapsible-header").eq(0), r = l.find(".mbsc-collapsible-content").eq(0)), (a = r[0]) && !a.id && (a.id = "mbsc-collapsible-" + tt++), o.length && a) {
        var c = Y('<span class="mbsc-collapsible-icon mbsc-ic mbsc-ic-arrow-down5"></span>');
        B(this, o, function () {
          s.collapse();
        }), o.attr("role", "button").attr("aria-expanded", this._isOpen).attr("aria-controls", a.id).attr("tabindex", "0").on("mousedown", function (e) {
          e.preventDefault();
        }).on("keydown", function (e) {
          32 !== e.which && 13 != e.keyCode || (e.preventDefault(), s.collapse());
        }).append(c);
      }

      t.mbscInst = this, this._$header = o, this._$content = r, this._$elm = l, this._$accordionParent = l.parent("[mbsc-accordion], mbsc-accordion, .mbsc-accordion"), this.show = this.show.bind(this), this.hide = this.hide.bind(this), this.toggle = this.toggle.bind(this);
    }

    return r(e, [{
      key: "collapse",
      value: function value(e) {
        var t = this._$elm,
            n = this._$content;
        void 0 === e && (e = !this._isOpen), e && this._isOpen || !e && !this._isOpen || !n.length || (e ? (ge && n.on("transitionend", function e() {
          n.off("transitionend", e).css("height", "");
        }).css("height", n[0].scrollHeight), t.addClass("mbsc-collapsible-open")) : (ge && n.css("height", getComputedStyle(n[0]).height), setTimeout(function () {
          n.css("height", 0), t.removeClass("mbsc-collapsible-open");
        })), e && this._$accordionParent && this._$accordionParent.find(".mbsc-collapsible-open").each(function () {
          this !== t[0] && this.mbscInst.hide();
        }), this._isOpen = e, this._$header.attr("aria-expanded", this._isOpen));
      }
    }, {
      key: "show",
      value: function value() {
        this.collapse(!0);
      }
    }, {
      key: "hide",
      value: function value() {
        this.collapse(!1);
      }
    }, {
      key: "toggle",
      value: function value() {
        this.collapse();
      }
    }, {
      key: "destroy",
      value: function value() {
        this._$elm.removeClass("mbsc-collapsible mbsc-collapsible-open"), this._$content.removeClass("mbsc-collapsible-content"), this._$header.removeClass("mbsc-collapsible-header").find("mbsc-collapsible-icon").remove();
      }
    }]), e;
  }();

  Z.CollapsibleBase = nt;
  var st = 0;
  var at,
      ot,
      it = "position:absolute;left:0;top:0;",
      rt = it + "right:0;bottom:0;overflow:hidden;z-index:-1;",
      lt = '<div style="' + rt + '"><div style="' + it + '"></div></div><div style="' + rt + '"><div style="' + it + 'width:200%;height:200%;"></div></div>';

  function ct(e, t) {
    function n() {
      i.style.width = "100000px", i.style.height = "100000px", o.scrollLeft = 1e5, o.scrollTop = 1e5, c.scrollLeft = 1e5, c.scrollTop = 1e5;
    }

    function s() {
      l || (l = P(a));
    }

    function a() {
      l = 0, n(), t();
    }

    var o = void 0,
        i = void 0,
        r = void 0,
        l = void 0,
        c = void 0,
        u = void 0,
        m = 0,
        d = document.createElement("div");
    return d.innerHTML = lt, d.dir = "ltr", c = d.childNodes[1], o = d.childNodes[0], i = o.childNodes[0], e.appendChild(d), o.addEventListener("scroll", s), c.addEventListener("scroll", s), P(function e() {
      var t = new Date();
      r = 0, u || (t - m > 200 && !o.scrollTop && !o.scrollLeft && (m = t, n()), r || (r = P(e)));
    }), {
      detach: function detach() {
        e.removeChild(d), u = !0;
      }
    };
  }

  var ut = s.themes,
      mt = /(iphone|ipod)/i.test(O) && _ >= 7,
      dt = "android" == g,
      pt = "ios" == g,
      ht = pt && 8 == _,
      ft = pt && _ > 7,
      Tt = function Tt(e) {
    e.preventDefault();
  },
      xt = "input,select,textarea,button",
      bt = 'textarea,button,input[type="button"],input[type="submit"]',
      vt = xt + ',[tabindex="0"]',
      yt = function yt(e, t, n) {
    var a,
        o,
        i,
        r,
        l,
        c,
        u,
        m,
        d,
        p,
        h,
        f,
        T,
        x,
        b,
        v,
        y,
        g,
        S,
        _,
        k,
        M,
        w,
        C,
        N,
        O,
        D,
        E,
        P,
        H,
        j,
        z,
        V,
        I,
        R,
        $ = this,
        B = Y(e),
        W = [],
        K = new Date();

    function G(e) {
      h && h.removeClass("mbsc-active"), (h = Y(this)).hasClass("mbsc-disabled") || h.hasClass("mbsc-fr-btn-nhl") || h.addClass("mbsc-active"), "mousedown" === e.type ? Y(document).on("mouseup", q) : "pointerdown" === e.type && Y(document).on("pointerup", q);
    }

    function q(e) {
      h && (h.removeClass("mbsc-active"), h = null), "mouseup" === e.type ? Y(document).off("mouseup", q) : "pointerup" === e.type && Y(document).off("pointerup", q);
    }

    function Z(e) {
      s.activeInstance == $ && (13 != e.keyCode || Y(e.target).is(bt) && !e.shiftKey ? 27 == e.keyCode && $.cancel() : $.select());
    }

    function X(e) {
      e || dt || !$._activeElm || (K = new Date(), $._activeElm.focus());
    }

    function Q(e) {
      var t = at,
          n = E.focusOnClose;
      $._markupRemove(), r.remove(), b && (f.mbscModals--, E.scrollLock && f.mbscLock--, f.mbscLock || i.removeClass("mbsc-fr-lock"), f.mbscModals || (i.removeClass("mbsc-fr-lock-ios mbsc-fr-lock-ctx"), M && (a.css({
        top: "",
        left: ""
      }), m.scrollLeft(P), m.scrollTop(j))), f.mbscModals && !D || e || (t || (t = B), setTimeout(function () {
        void 0 === n || !0 === n ? (ot = !0, t[0].focus()) : n && Y(n)[0].focus();
      }, 200))), D = void 0, v = !1, V("onHide");
    }

    function ee() {
      clearTimeout(O), O = setTimeout(function () {
        $.position(!0) && (N.style.visibility = "hidden", N.offsetHeight, N.style.visibility = "");
      }, 200);
    }

    function te(e) {
      s.activeInstance == $ && e.target.nodeType && !C.contains(e.target) && new Date() - K > 100 && (K = new Date(), $._activeElm.focus());
    }

    function ne(e, t) {
      if (b) r.appendTo(a);else if (B.is("div") && !$._hasContent) B.empty().append(r);else if (B.hasClass("mbsc-control")) {
        var n = B.closest(".mbsc-control-w");
        r.insertAfter(n), n.hasClass("mbsc-select") && n.addClass("mbsc-select-inline");
      } else r.insertAfter(B);
      v = !0, $._markupInserted(r), V("onMarkupInserted", {
        target: g
      }), r.on("mousedown", ".mbsc-btn-e,.mbsc-fr-btn-e", Tt).on("touchstart mousedown", function (e) {
        E.stopProp && e.stopPropagation();
      }).on("keydown", ".mbsc-fr-btn-e", function (e) {
        32 == e.keyCode && (e.preventDefault(), e.stopPropagation(), this.click());
      }).on("keydown", function (e) {
        if (32 != e.keyCode || Y(e.target).is(xt)) {
          if (9 == e.keyCode && b && E.focusTrap) {
            var t = r.find(vt).filter(function () {
              return this.offsetWidth > 0 || this.offsetHeight > 0;
            }),
                n = t.index(Y(":focus", r)),
                s = t.length - 1,
                a = 0;
            e.shiftKey && (s = 0, a = -1), n === s && (t.eq(a)[0].focus(), e.preventDefault());
          }
        } else e.preventDefault();
      }).on("touchstart mousedown pointerdown", ".mbsc-fr-btn-e", G).on("touchend", ".mbsc-fr-btn-e", q), g.addEventListener("touchstart", function () {
        z || (z = !0, a.find(".mbsc-no-touch").removeClass("mbsc-no-touch"));
      }, !0), Y.each(p, function (e, t) {
        $.tap(Y(".mbsc-fr-btn" + e, r), function (e) {
          (F((t = F(t) ? $.buttons[t] : t).handler) ? $.handlers[t.handler] : t.handler).call(this, e, $);
        }, !0);
      }), $._attachEvents(r), !1 !== $.position() && (w = ct(g, ee), b && (r.removeClass("mbsc-fr-pos"), T && !e ? r.addClass("mbsc-anim-in mbsc-anim-trans mbsc-anim-trans-" + T).on(be, function e() {
        r.off(be, e).removeClass("mbsc-anim-in mbsc-anim-trans mbsc-anim-trans-" + T).find(".mbsc-fr-popup").removeClass("mbsc-anim-" + T), X(t);
      }).find(".mbsc-fr-popup").addClass("mbsc-anim-" + T) : X(t)), V("onShow", {
        target: g,
        valueText: $._tempValue
      }));
    }

    function se(e, t) {
      $._isVisible || (e && e(), !1 !== $.show() && (at = t));
    }

    function oe() {
      $._fillValue(), V("onSet", {
        valueText: $._value
      });
    }

    function ie() {
      V("onCancel", {
        valueText: $._value
      });
    }

    function re() {
      $.setVal(null, !0);
    }

    ae.call(this, e, t, !0), $.position = function (e) {
      var t,
          n,
          s,
          o,
          i,
          l,
          p,
          h,
          T,
          y,
          M,
          w,
          C,
          O,
          D,
          P,
          A,
          F,
          j,
          z = {},
          J = 0,
          U = 0,
          W = 0,
          K = 0;
      if (!v) return !1;

      if (P = I, D = R, C = g.offsetHeight, (O = g.offsetWidth) && C && (I !== O || R !== C || !e)) {
        if ($._checkResp(O)) return !1;
        if (I = O, R = C, $._isFullScreen || /top|bottom/.test(E.display) ? u.width(O) : b && d.width(""), $._position(r), !$._isFullScreen && /center|bubble/.test(E.display) && (Y(".mbsc-w-p", r).each(function () {
          A = this.getBoundingClientRect().width, K += A, W = A > W ? A : W;
        }), w = K > O - 16 || !0 === E.tabs, d.css({
          width: $._isLiquid ? Math.min(E.maxPopupWidth, O - 16) : Math.ceil(w ? W : K),
          "white-space": w ? "" : "nowrap"
        })), !1 !== V("onPosition", {
          target: g,
          popup: N,
          hasTabs: w,
          oldWidth: P,
          oldHeight: D,
          windowWidth: O,
          windowHeight: C
        }) && b) return k && (J = m.scrollLeft(), U = m.scrollTop(), I && c.css({
          width: "",
          height: ""
        })), S = N.offsetWidth, _ = N.offsetHeight, H = _ <= C && S <= O, "center" == E.display ? (j = Math.max(0, J + (O - S) / 2), F = Math.max(0, U + (C - _) / 2)) : "bubble" == E.display ? (t = void 0 === E.anchor ? B : Y(E.anchor), p = Y(".mbsc-fr-arr-i", r)[0], i = (o = t.offset()).top + (x ? U - a.offset().top : 0), l = o.left + (x ? J - a.offset().left : 0), n = t[0].offsetWidth, s = t[0].offsetHeight, h = p.offsetWidth, T = p.offsetHeight, j = L(l - (S - n) / 2, J + 3, J + O - S - 3), (F = i + s + T / 2) + _ + 8 > U + C && i - _ - T / 2 > U ? (u.removeClass("mbsc-fr-bubble-bottom").addClass("mbsc-fr-bubble-top"), F = i - _ - T / 2) : u.removeClass("mbsc-fr-bubble-top").addClass("mbsc-fr-bubble-bottom"), Y(".mbsc-fr-arr", r).css({
          left: L(l + n / 2 - (j + (S - h) / 2), 0, h)
        }), H = F > U && j > J && F + _ <= U + C && j + S <= J + O) : (j = J, F = "top" == E.display ? U : Math.max(0, U + C - _)), k && (y = Math.max(F + _, x ? f.scrollHeight : Y(document).height()), M = Math.max(j + S, x ? f.scrollWidth : Y(document).width()), c.css({
          width: M,
          height: y
        }), E.scroll && "bubble" == E.display && (F + _ + 8 > U + C || i > U + C || i + s < U) && m.scrollTop(Math.min(i, F + _ - C + 8, y - C))), z.top = Math.floor(F), z.left = Math.floor(j), u.css(z), !0;
      }
    }, $.attachShow = function (e, t) {
      var n,
          s = Y(e).off(".mbsc"),
          a = s.prop("readonly");
      "inline" !== E.display && ((E.showOnFocus || E.showOnTap) && s.is("input,select") && (s.prop("readonly", !0).on("mousedown.mbsc", function (e) {
        e.preventDefault();
      }).on("focus.mbsc", function () {
        $._isVisible && this.blur();
      }), (n = Y('label[for="' + s.attr("id") + '"]')).length || (n = s.closest("label"))), s.is("select") || (E.showOnFocus && s.on("focus.mbsc", function () {
        ot ? ot = !1 : se(t, s);
      }), E.showOnTap && (s.on("keydown.mbsc", function (e) {
        32 != e.keyCode && 13 != e.keyCode || (e.preventDefault(), e.stopPropagation(), se(t, s));
      }), $.tap(s, function (e) {
        e.isMbscTap && (z = !0), se(t, s);
      }), n && n.length && $.tap(n, function (e) {
        e.target !== s[0] && se(t, s);
      }))), W.push({
        readOnly: a,
        el: s,
        lbl: n
      }));
    }, $.select = function () {
      b ? $.hide(!1, "set", !1, oe) : oe();
    }, $.cancel = function () {
      b ? $.hide(!1, "cancel", !1, ie) : ie();
    }, $.clear = function () {
      $._clearValue(), V("onClear"), b && $._isVisible && !$.live ? $.hide(!1, "clear", !1, re) : re();
    }, $.enable = function () {
      E.disabled = !1, Y.each(W, function (e, t) {
        t.el.is("input,select") && (t.el[0].disabled = !1);
      });
    }, $.disable = function () {
      E.disabled = !0, Y.each(W, function (e, t) {
        t.el.is("input,select") && (t.el[0].disabled = !0);
      });
    }, $.show = function (e, t) {
      var n, h;

      if (!E.disabled && !$._isVisible) {
        if ($._readValue(), !1 === V("onBeforeShow")) return !1;

        if (at = null, T = E.animate, p = E.buttons || [], k = x || "bubble" == E.display, M = mt && !k && E.scrollLock, n = p.length > 0, !1 !== T && ("top" == E.display ? T = T || "slidedown" : "bottom" == E.display ? T = T || "slideup" : "center" != E.display && "bubble" != E.display || (T = T || "pop")), b && (j = Math.max(0, m.scrollTop()), P = Math.max(0, m.scrollLeft()), I = 0, R = 0, M && !i.hasClass("mbsc-fr-lock-ios") && a.css({
          top: -j + "px",
          left: -P + "px"
        }), i.addClass((E.scrollLock ? "mbsc-fr-lock" : "") + (M ? " mbsc-fr-lock-ios" : "") + (x ? " mbsc-fr-lock-ctx" : "")), Y(document.activeElement).is("input,textarea") && document.activeElement.blur(), D = s.activeInstance, s.activeInstance = $, f.mbscModals = f.mbscModals || 0, f.mbscLock = f.mbscLock || 0, f.mbscModals++, E.scrollLock && f.mbscLock++), h = '<div lang="' + E.lang + '" class="mbsc-fr mbsc-' + E.theme + (E.baseTheme ? " mbsc-" + E.baseTheme : "") + " mbsc-fr-" + E.display + " " + (E.cssClass || "") + " " + (E.compClass || "") + ($._isLiquid ? " mbsc-fr-liq" : "") + (b ? " mbsc-fr-pos" : "") + (y ? " mbsc-fr-pointer" : "") + (ft ? " mbsc-fr-hb" : "") + (z ? "" : " mbsc-no-touch") + (M ? " mbsc-platform-ios" : "") + (n ? p.length >= 3 ? " mbsc-fr-btn-block " : "" : " mbsc-fr-nobtn") + '">' + (b ? '<div class="mbsc-fr-persp"><div class="mbsc-fr-overlay"></div><div role="dialog" class="mbsc-fr-scroll">' : "") + '<div class="mbsc-fr-popup' + (E.rtl ? " mbsc-rtl" : " mbsc-ltr") + (E.headerText ? " mbsc-fr-has-hdr" : "") + '">' + ("bubble" === E.display ? '<div class="mbsc-fr-arr-w"><div class="mbsc-fr-arr-i"><div class="mbsc-fr-arr"></div></div></div>' : "") + (b ? '<div class="mbsc-fr-focus" tabindex="-1"></div>' : "") + '<div class="mbsc-fr-w">' + (E.headerText ? '<div class="mbsc-fr-hdr">' + (F(E.headerText) ? E.headerText : "") + "</div>" : "") + '<div class="mbsc-fr-c">', h += $._generateContent(), h += "</div>", n) {
          var v,
              S,
              _,
              w = p.length;

          for (h += '<div class="mbsc-fr-btn-cont">', S = 0; S < p.length; S++) {
            _ = E.btnReverse ? w - S - 1 : S, "set" === (v = F(v = p[_]) ? $.buttons[v] : v).handler && (v.parentClass = "mbsc-fr-btn-s"), "cancel" === v.handler && (v.parentClass = "mbsc-fr-btn-c"), h += "<div" + (E.btnWidth ? ' style="width:' + 100 / p.length + '%"' : "") + ' class="mbsc-fr-btn-w ' + (v.parentClass || "") + '"><div tabindex="0" role="button" class="mbsc-fr-btn' + _ + " mbsc-fr-btn-e " + (void 0 === v.cssClass ? E.btnClass : v.cssClass) + (v.icon ? " mbsc-ic mbsc-ic-" + v.icon : "") + '">' + (v.text || "") + "</div></div>";
          }

          h += "</div>";
        }

        var O, A, L, B;
        if (r = Y(h += "</div></div></div></div>" + (b ? "</div></div>" : "")), c = Y(".mbsc-fr-persp", r), l = Y(".mbsc-fr-scroll", r), d = Y(".mbsc-fr-w", r), u = Y(".mbsc-fr-popup", r), o = Y(".mbsc-fr-hdr", r), g = r[0], C = l[0], N = u[0], $._activeElm = Y(".mbsc-fr-focus", r)[0], $._markup = r, $._isVisible = !0, $.markup = g, $._markupReady(r), V("onMarkupReady", {
          target: g
        }), b) if (Y(window).on("keydown", Z), E.scrollLock && r.on("touchmove mousewheel wheel", function (e) {
          H && e.preventDefault();
        }), E.focusTrap && m.on("focusin", te), E.closeOnOverlayTap) l.on("touchstart mousedown", function (e) {
          A || e.target != C || (A = !0, O = !1, L = U(e, "X"), B = U(e, "Y"));
        }).on("touchmove mousemove", function (e) {
          A && !O && (Math.abs(U(e, "X") - L) > 9 || Math.abs(U(e, "Y") - B) > 9) && (O = !0);
        }).on("touchcancel", function () {
          A = !1;
        }).on("touchend click", function (e) {
          A && !O && ($.cancel(), "touchend" == e.type && J()), A = !1;
        });
        b && M ? setTimeout(function () {
          ne(e, t);
        }, 100) : ne(e, t);
      }
    }, $.hide = function (e, t, n, a) {
      if (!$._isVisible || !n && !$._isValid && "set" == t || !n && !1 === V("onBeforeClose", {
        valueText: $._tempValue,
        button: t
      })) return !1;
      $._isVisible = !1, w && (w.detach(), w = null), b && (Y(document.activeElement).is("input,textarea") && N.contains(document.activeElement) && document.activeElement.blur(), s.activeInstance == $ && (s.activeInstance = D), Y(window).off("keydown", Z), m.off("focusin", te)), r && (b && T && !e ? r.addClass("mbsc-anim-out mbsc-anim-trans mbsc-anim-trans-" + T).on(be, function t() {
        r.off(be, t), Q(e);
      }).find(".mbsc-fr-popup").addClass("mbsc-anim-" + T) : Q(e), $._detachEvents(r)), a && a(), B.trigger("blur"), V("onClose", {
        valueText: $._value
      });
    }, $.isVisible = function () {
      return $._isVisible;
    }, $.setVal = A, $.getVal = A, $._generateContent = A, $._attachEvents = A, $._detachEvents = A, $._readValue = A, $._clearValue = A, $._fillValue = A, $._markupReady = A, $._markupInserted = A, $._markupRemove = A, $._position = A, $.__processSettings = A, $.__init = A, $.__destroy = A, $._destroy = function () {
      $.hide(!0, !1, !0), B.off(".mbsc"), Y.each(W, function (e, t) {
        t.el.off(".mbsc").prop("readonly", t.readOnly), t.lbl && t.lbl.off(".mbsc");
      }), $.__destroy();
    }, $._updateHeader = function () {
      var t = E.headerText,
          n = t ? "function" == typeof t ? t.call(e, $._tempValue) : t.replace(/\{value\}/i, $._tempValue) : "";
      o.html(n || "&nbsp;");
    }, $._processSettings = function (e) {
      var n, s;

      for ($.__processSettings(e), (y = !E.touchUi) && (E.display = e.display || t.display || "bubble", E.buttons = e.buttons || t.buttons || []), E.buttons = E.buttons || ("inline" !== E.display ? ["cancel", "set"] : []), E.headerText = void 0 === E.headerText ? "inline" !== E.display && "{value}" : E.headerText, p = E.buttons || [], b = "inline" !== E.display, x = "body" != E.context, a = Y(E.context), i = x ? a : Y("body,html"), f = a[0], $._$window = m = Y(x ? E.context : window), $.live = !0, s = 0; s < p.length; s++) {
        "ok" != (n = p[s]) && "set" != n && "set" != n.handler || ($.live = !1);
      }

      $.buttons.set = {
        text: E.setText,
        icon: E.setIcon,
        handler: "set"
      }, $.buttons.cancel = {
        text: E.cancelText,
        icon: E.cancelIcon,
        handler: "cancel"
      }, $.buttons.close = {
        text: E.closeText,
        icon: E.closeIcon,
        handler: "cancel"
      }, $.buttons.clear = {
        text: E.clearText,
        icon: E.clearIcon,
        handler: "clear"
      }, $._isInput = B.is("input");
    }, $._init = function (e) {
      var t = $._isVisible,
          n = t && !r.hasClass("mbsc-fr-pos");
      t && $.hide(!0, !1, !0), B.off(".mbsc"), $.__init(e), $._isLiquid = "liquid" == E.layout, b ? ($._readValue(), $._hasContent || E.skipShow || $.attachShow(B), t && $.show(n)) : $.show(), B.removeClass("mbsc-cloak").filter("input, select, textarea").on("change.mbsc", function () {
        $._preventChange || $.setVal(B.val(), !0, !1), $._preventChange = !1;
      });
    }, $.buttons = {}, $.handlers = {
      set: $.select,
      cancel: $.cancel,
      clear: $.clear
    }, $._value = null, $._isValid = !0, $._isVisible = !1, E = $.settings, V = $.trigger, n || $.init();
  };

  yt.prototype._defaults = {
    lang: "en",
    setText: "Set",
    selectedText: "{count} selected",
    closeText: "Close",
    cancelText: "Cancel",
    clearText: "Clear",
    context: "body",
    maxPopupWidth: 600,
    disabled: !1,
    closeOnOverlayTap: !0,
    showOnFocus: dt || pt,
    showOnTap: !0,
    display: "center",
    scroll: !0,
    scrollLock: !0,
    tap: !0,
    touchUi: !0,
    btnClass: "mbsc-fr-btn",
    btnWidth: !0,
    focusTrap: !0,
    focusOnClose: !ht
  }, Z.Frame = yt, ut.frame.mobiscroll = {
    headerText: !1,
    btnWidth: !1
  }, ut.scroller.mobiscroll = Q({}, ut.frame.mobiscroll, {
    rows: 5,
    showLabel: !1,
    selectedLineBorder: 1,
    weekDays: "min",
    checkIcon: "ion-ios7-checkmark-empty",
    btnPlusClass: "mbsc-ic mbsc-ic-arrow-down5",
    btnMinusClass: "mbsc-ic mbsc-ic-arrow-up5",
    btnCalPrevClass: "mbsc-ic mbsc-ic-arrow-left5",
    btnCalNextClass: "mbsc-ic mbsc-ic-arrow-right5"
  }), N && Y(window).on("focus", function () {
    at && (ot = !0);
  });

  var gt = function gt(e, t, n) {
    function s(e) {
      Y(".mbsc-fr-c", e).hasClass("mbsc-wdg-c") || (Y(".mbsc-fr-c", e).addClass("mbsc-wdg-c").append(i.show()), Y(".mbsc-w-p", e).length || Y(".mbsc-fr-c", e).addClass("mbsc-w-p"));
    }

    var a,
        o,
        i = Y(e),
        r = this;
    yt.call(this, e, t, !0), r._generateContent = function () {
      return "";
    }, r._markupReady = function (e) {
      "inline" != a.display && s(e);
    }, r._markupInserted = function (e) {
      "inline" == a.display && s(e), e.trigger("mbsc-enhance", [{
        theme: a.theme,
        lang: a.lang
      }]);
    }, r._markupRemove = function () {
      i.hide(), o && o.parent().length && o.after(i);
    }, r.__processSettings = function () {
      a = r.settings, r.buttons.ok = {
        text: a.okText,
        icon: a.okIcon,
        handler: "set"
      }, a.buttons = a.buttons || ("inline" == a.display ? [] : ["ok"]), !o && i.parent().length && (o = Y(document.createComment("popup")), i.before(o)), i.hide();
    }, n || r.init();
  };

  gt.prototype = {
    _hasDef: !0,
    _hasTheme: !0,
    _hasContent: !0,
    _hasLang: !0,
    _class: "popup",
    _defaults: Q({}, yt.prototype._defaults, {
      compClass: "mbsc-wdg",
      okText: "OK",
      headerText: !1
    })
  }, Z.Popup = gt, Z.Widget = gt, s.themes.popup = s.themes.frame;
  var St = N && !!window.Promise,
      _t = [],
      kt = [];

  function Mt(e) {
    _t.length || e.show(), _t.push(e);
  }

  function wt(e, t, n, s) {
    return Q({
      display: t.display || "center",
      cssClass: "mbsc-alert",
      okText: t.okText,
      cancelText: t.cancelText,
      context: t.context,
      theme: t.theme,
      closeOnOverlayTap: !1,
      onBeforeClose: function onBeforeClose() {
        e.shift();
      },
      onHide: function onHide(e, s) {
        n && n(s._resolve), t.callback && t.callback(s._resolve), s && s.destroy(), _t.length ? _t[0].show() : kt.length && kt[0].show(!1, !0);
      }
    }, s);
  }

  function Ct(e) {
    return (e.title ? "<h2>" + e.title + "</h2>" : "") + "<p>" + (e.message || "") + "</p>";
  }

  function Nt(e, t, n) {
    Mt(new gt(e, wt(_t, t, n)));
  }

  function Ot(e, t, n) {
    var s = new gt(e, wt(_t, t, n, {
      buttons: ["cancel", "ok"],
      onSet: function onSet() {
        s._resolve = !0;
      }
    }));
    s._resolve = !1, Mt(s);
  }

  function Dt(e, t, n) {
    var s = void 0,
        a = new gt(e, wt(_t, t, n, {
      buttons: ["cancel", "ok"],
      onMarkupReady: function onMarkupReady(e, t) {
        s = t._markup.find("input")[0], setTimeout(function () {
          s.focus(), s.setSelectionRange(0, s.value.length);
        }, 300);
      },
      onSet: function onSet() {
        a._resolve = s.value;
      }
    }));
    a._resolve = null, Mt(a);
  }

  function Et(e, t, n, s, a) {
    var o,
        i,
        r = void 0,
        l = new gt(e, wt(kt, t, n, {
      display: t.display || "bottom",
      animate: a,
      cssClass: (s || "mbsc-snackbar") + (t.color ? " mbsc-" + t.color : ""),
      scrollLock: !1,
      focusTrap: !1,
      buttons: [],
      onShow: function onShow(e, n) {
        !1 !== t.duration && (r = setTimeout(function () {
          n && n.hide();
        }, t.duration || 3e3)), t.button && n.tap(Y(".mbsc-snackbar-btn", e.target), function () {
          n.hide(), t.button.action && t.button.action.call(this);
        });
      },
      onClose: function onClose() {
        clearTimeout(r);
      }
    }));
    o = l, i = kt.length, kt.push(o), _t.length || (i ? kt[0].hide() : o.show(!1, !0));
  }

  function Pt(e, t, n) {
    Et(e, t, n, "mbsc-toast", "fade");
  }

  function At(e, t, n) {
    var s = void 0;
    return St ? s = new Promise(function (s) {
      e(t, n, s);
    }) : e(t, n), s;
  }

  s.alert = function (e) {
    var t = document.createElement("div");
    return t.innerHTML = Ct(e), At(Nt, t, e);
  }, s.confirm = function (e) {
    var t = document.createElement("div");
    return t.innerHTML = Ct(e), At(Ot, t, e);
  }, s.prompt = function (e) {
    var t = document.createElement("div");
    return t.innerHTML = Ct(e) + '<label class="mbsc-input">' + (e.label ? '<span class="mbsc-label">' + e.label + "</span>" : "") + '<input tabindex="0" type="' + (e.inputType || "text") + '" placeholder="' + (e.placeholder || "") + '" value="' + (e.value || "") + '"></label>', At(Dt, t, e);
  }, s.snackbar = function (e) {
    var t = document.createElement("div"),
        n = e.button;
    return t.innerHTML = '<div class="mbsc-snackbar-cont"><div class="mbsc-snackbar-msg">' + (e.message || "") + "</div>" + (n ? '<button class="mbsc-snackbar-btn mbsc-btn mbsc-btn-flat">' + (n.icon ? '<span class="mbsc-ic ' + (n.text ? "mbsc-btn-ic " : "") + "mbsc-ic-" + n.icon + '"></span>' : "") + (n.text || "") + "</button>" : "") + "</div>", At(Et, t, e);
  }, s.toast = function (e) {
    var t = document.createElement("div");
    return t.innerHTML = '<div class="mbsc-toast-msg">' + (e.message || "") + "</div>", At(Pt, t, e);
  };

  var Ft = "ios" == g && _ > 7,
      Lt = function Lt(e, t) {
    var n,
        a = "",
        o = Y(e),
        i = {},
        r = this;

    function l() {
      o.removeClass("mbsc-no-touch");
    }

    ae.call(this, e, t, !0), r.refresh = function (e) {
      !function (e, t, n, s) {
        Y("input,select,textarea,progress,button", e).each(function () {
          var e = Y(this),
              s = R(e);
          if ("false" != e.attr("data-enhance")) if (e.hasClass("mbsc-control")) this.mbscInst && this.mbscInst.option({
            theme: n.theme,
            lang: n.lang,
            rtl: n.rtl,
            onText: n.onText,
            offText: n.offText,
            stopProp: n.stopProp
          });else switch (this.id || (this.id = "mbsc-form-control-" + ++st), s) {
            case "button":
            case "submit":
              t[this.id] = new ze(this, {
                theme: n.theme,
                tap: n.tap
              });
              break;

            case "switch":
              t[this.id] = new Ze(this, {
                theme: n.theme,
                lang: n.lang,
                rtl: n.rtl,
                tap: n.tap,
                onText: n.onText,
                offText: n.offText,
                stopProp: n.stopProp
              });
              break;

            case "checkbox":
              t[this.id] = new Ve(this, {
                tap: n.tap
              });
              break;

            case "range":
              Y(this).parent().hasClass("mbsc-slider") || (t[this.id] = new Qe(this, {
                theme: n.theme,
                lang: n.lang,
                rtl: n.rtl,
                stopProp: n.stopProp,
                labelStyle: n.labelStyle
              }));
              break;

            case "rating":
              t[this.id] = new et(this, {
                theme: n.theme,
                lang: n.lang,
                rtl: n.rtl,
                stopProp: n.stopProp
              });
              break;

            case "progress":
              t[this.id] = new Xe(this, {
                theme: n.theme,
                lang: n.lang,
                rtl: n.rtl,
                labelStyle: n.labelStyle
              });
              break;

            case "radio":
              t[this.id] = new Ie(this, {
                tap: n.tap
              });
              break;

            case "select":
            case "select-one":
            case "select-multiple":
              t[this.id] = new Je(this, {
                tap: n.tap,
                inputStyle: n.inputStyle,
                labelStyle: n.labelStyle
              });
              break;

            case "textarea":
              t[this.id] = new We(this, {
                tap: n.tap,
                inputStyle: n.inputStyle,
                labelStyle: n.labelStyle
              });
              break;

            case "segmented":
              t[this.id] = new Ke(this, {
                theme: n.theme,
                tap: n.tap
              });
              break;

            case "stepper":
              t[this.id] = new Ye(this, {
                theme: n.theme
              });
              break;

            case "hidden":
              return;

            default:
              t[this.id] = new je(this, {
                tap: n.tap,
                inputStyle: n.inputStyle,
                labelStyle: n.labelStyle
              });
          }
        }), Y("[data-collapsible]:not(.mbsc-collapsible)", e).each(function () {
          var e = Y(this).attr("data-open");
          this.id || (this.id = "mbsc-form-control-" + ++st), t[this.id] = new nt(this, {
            isOpen: void 0 !== e && "false" != e
          }), q[this.id] = t[this.id];
        }), s || $e();
      }(o, i, n, e);
    }, r._init = function () {
      s.themes.form[n.theme] || (n.theme = "mobiscroll"), o.hasClass("mbsc-form") || o.on("touchstart", l).show(), a && o.removeClass(a), a = "mbsc-form mbsc-no-touch mbsc-" + n.theme + (Ft ? " mbsc-form-hb" : "") + (n.baseTheme ? " mbsc-" + n.baseTheme : "") + (n.rtl ? " mbsc-rtl" : " mbsc-ltr") + ("box" == n.inputStyle ? " mbsc-form-box" : "") + ("outline" == n.inputStyle ? " mbsc-form-outline" : ""), o.addClass(a).removeClass("mbsc-cloak"), r.refresh();
    }, r._destroy = function () {
      for (var e in o.removeClass(a).off("touchstart", l), i) {
        i[e].destroy();
      }
    }, r.controls = i, n = r.settings, r.init();
  };

  Lt.prototype = {
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _class: "form",
    _defaults: {
      tap: ye,
      stopProp: !0,
      rtl: !1
    }
  }, s.themes.form.mobiscroll = {}, Z.Form = Lt, K("[mbsc-enhance],[mbsc-form]", Lt, !0);

  var Ht,
      jt,
      zt = function zt(e, t) {
    var n = "",
        s = Y(e),
        a = this.settings;
    ae.call(this, e, t, !0), this._init = function () {
      var e = a.context,
          t = Y(e),
          o = t.find(".mbsc-ms-top .mbsc-ms"),
          i = t.find(".mbsc-ms-bottom .mbsc-ms"),
          r = {};
      "body" == e ? Y("body,html").addClass("mbsc-page-ctx") : t.addClass("mbsc-page-ctx"), n && s.removeClass(n), o.length && (r.paddingTop = o[0].offsetHeight), i.length && (r.paddingBottom = i[0].offsetHeight), n = "mbsc-page mbsc-" + a.theme + (a.baseTheme ? " mbsc-" + a.baseTheme : "") + (a.rtl ? " mbsc-rtl" : " mbsc-ltr"), s.addClass(n).removeClass("mbsc-cloak").css(r);
    }, this._destroy = function () {
      s.removeClass(n);
    }, a = this.settings, this.init();
  };

  zt.prototype = {
    _hasDef: !0,
    _hasTheme: !0,
    _hasLang: !0,
    _class: "page",
    _defaults: {
      context: "body"
    }
  }, Z.Page = zt, s.themes.page.mobiscroll = {}, K("[mbsc-page]", zt);

  var Vt = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var s in n) {
        Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
      }
    }

    return e;
  },
      It = function (n) {
    function s(e) {
      return i(this, s), u(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this, e));
    }

    return c(s, _e), r(s, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new zt(t.findDOMNode(this), e);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e) {
        var t = !xe(this.getSettingsFromProps(this.props), this.getSettingsFromProps(e));
        return this.optimizeUpdate = {
          updateOptions: t
        }, !0;
      }
    }, {
      key: "render",
      value: function value() {
        return e.createElement("div", {
          className: this.initialCssClass
        }, this.props.children);
      }
    }]), s;
  }();

  It.propTypes = Vt({}, It.propTypes, pe, {
    onInit: n.func
  });

  var Jt = (jt = Ht = function (t) {
    function n(e) {
      return i(this, n), u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
    }

    return c(n, t), r(n, [{
      key: "render",
      value: function value() {
        var t = "mbsc-note mbsc-note-" + this.props.color;
        return e.createElement("div", {
          className: t
        }, this.props.children);
      }
    }]), n;
  }(e.Component), Ht.propTypes = {
    color: n.string
  }, Ht.defaultProps = {
    color: "primary"
  }, jt),
      Ut = function (t) {
    function n(e) {
      return i(this, n), u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
    }

    return c(n, t), r(n, [{
      key: "render",
      value: function value() {
        return e.createElement("img", {
          className: "mbsc-avatar",
          src: this.props.src,
          alt: this.props.alt
        });
      }
    }]), n;
  }(e.Component);

  s.Page = It, s.Note = Jt, s.Avatar = Ut;

  var Rt,
      $t,
      Bt,
      Wt,
      Kt,
      Yt,
      Gt,
      qt,
      Zt,
      Xt,
      Qt,
      en,
      tn,
      nn,
      sn,
      an,
      on,
      rn,
      ln,
      cn,
      un,
      mn,
      dn,
      pn,
      hn,
      fn,
      Tn,
      xn,
      bn = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var s in n) {
        Object.prototype.hasOwnProperty.call(n, s) && (e[s] = n[s]);
      }
    }

    return e;
  };

  function vn(e, t) {
    var n = {};

    for (var s in e) {
      t.indexOf(s) >= 0 || Object.prototype.hasOwnProperty.call(e, s) && (n[s] = e[s]);
    }

    return n;
  }

  var yn = n.number,
      gn = n.string,
      Sn = n.func,
      _n = n.bool,
      kn = {
    onInit: Sn,
    onChange: Sn,
    value: yn,
    disabled: _n,
    min: yn,
    max: yn,
    step: yn,
    val: n.oneOf(["left", "right"])
  },
      Mn = {
    onInit: Sn,
    onChange: Sn,
    checked: _n,
    disabled: _n,
    value: _n
  },
      wn = ($t = Rt = function (n) {
    function s(e) {
      return i(this, s), u(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this, e));
    }

    return c(s, ke), r(s, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new Lt(t.findDOMNode(this), e);
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        if (!this.optimizeUpdate.updateOptions && this.optimizeUpdate.updateChildren) this.instance.refresh(!0);else if (this.optimizeUpdate.updateOptions) {
          var e = this.getSettingsFromProps(this.props);
          this.instance.option(e);
        }
      }
    }, {
      key: "checkFormWrapper",
      value: function value(t) {
        return 1 == e.Children.count(t.props.children) && "form" == t.props.children.type;
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            n = t.action,
            s = t.method,
            a = t.noValidate,
            o = t.renderForm,
            i = t.name,
            r = t.target,
            l = t.autoComplete,
            c = t.onSubmit;
        return this.checkFormWrapper(this) || !o ? this.props.children : e.createElement("form", {
          className: this.initialCssClass,
          action: n,
          name: i,
          target: r,
          method: s,
          autoComplete: l,
          noValidate: a,
          onSubmit: c
        }, this.props.children);
      }
    }]), s;
  }(), Rt.defaultProps = {
    renderForm: !0
  }, Rt.propTypes = bn({}, pe, {
    labelStyle: gn,
    inputStyle: gn,
    onInit: Sn
  }), $t);
  s.Form = wn;
  var Cn = (Wt = Bt = function (t) {
    function n(t) {
      i(this, n);
      var s = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, t));
      return s.render = function () {
        /* eslint-disable no-unused-vars */
        var t = s.props,
            n = (t.valid, t.className, t.color, t.children),
            a = (t.presetName, t.inputStyle, t.labelStyle, vn(t, ["valid", "className", "color", "children", "presetName", "inputStyle", "labelStyle"]));
        return e.createElement("label", a, n);
      }, s;
    }

    return c(n, t), r(n, [{
      key: "componentDidMount",
      value: function value() {
        Te.call(this, "", this.getClasses(this.props));
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.cssClassUpdate && Te.call(this, this.cssClassUpdate.prev, this.cssClassUpdate.next);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e) {
        var t = this.getClasses(e),
            n = this.getClasses(this.props);
        return this.cssClassUpdate = n !== t ? {
          prev: n,
          next: t
        } : null, !0;
      }
    }, {
      key: "getClasses",
      value: function value(e) {
        /* eslint-disable no-unused-vars */
        var t = e.valid,
            n = e.className,
            s = e.color,
            a = e.presetName,
            o = e.inputStyle,
            i = e.labelStyle,
            r = [];
        s && r.push("mbsc-" + a + "-" + s), n && r.push(n), o && r.push("mbsc-input-" + o), i && r.push("mbsc-label-" + i), void 0 === t || t || r.push("mbsc-err");
        var l = "";
        return r.length && (l = r.reduce(function (e, t) {
          return e + " " + t;
        }).replace(/\s+/g, " ").trim()), l;
      }
    }]), n;
  }(e.Component), Bt.propTypes = bn({}, wn.propTypes, {
    valid: n.bool,
    color: n.string,
    presetName: n.string
  }), Wt);
  s.Form.Label = Cn, s.Label = Cn;
  var Nn = (Yt = Kt = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.inputMounted = t.inputMounted.bind(t), t;
    }

    return c(n, Se), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new je(this.inputNode, e);
      }
    }, {
      key: "inputMounted",
      value: function value(e) {
        this.inputNode = e;
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = t.valid,
            s = t.errorMessage,
            a = t.type,
            o = t.icon,
            i = t.iconAlign,
            r = t.passwordToggle,
            l = t.iconShow,
            c = t.iconHide,
            u = t.inputStyle,
            m = t.labelStyle,
            d = t.children,
            p = t.dropdown,
            h = vn(t, ["valid", "errorMessage", "type", "icon", "iconAlign", "passwordToggle", "iconShow", "iconHide", "inputStyle", "labelStyle", "children", "dropdown"]),
            f = null;
        s && !n && (f = e.createElement("span", {
          className: "mbsc-err-msg"
        }, s));
        var T = null;
        return p && (T = e.createElement("span", {
          className: "mbsc-select-ic mbsc-ic mbsc-ic-arrow-down5"
        })), a = a || "text", e.createElement(Cn, {
          valid: n,
          inputStyle: u,
          labelStyle: m,
          className: p ? "mbsc-select" : ""
        }, d, e.createElement("span", {
          className: "mbsc-input-wrap"
        }, e.createElement("input", bn({
          ref: this.inputMounted,
          type: a,
          "data-icon": o,
          "data-icon-align": i,
          "data-password-toggle": r,
          "data-icon-show": l,
          "data-icon-hide": c
        }, h)), T, f));
      }
    }]), n;
  }(), Kt.propTypes = {
    disabled: n.bool,
    valid: n.bool,
    errorMessage: n.string,
    type: n.string,
    icon: n.string,
    iconAlign: n.string,
    passwordToggle: n.bool,
    iconShow: n.string,
    iconHide: n.string,
    name: n.string,
    dropdown: n.bool,
    inputStyle: n.string,
    labelStyle: n.string
  }, Yt);
  s.Input = Nn;
  var On = (qt = Gt = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.textMounted = t.textMounted.bind(t), t;
    }

    return c(n, ke), r(n, [{
      key: "componentDidUpdate",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.optimizeUpdate ? (this.optimizeUpdate.updateOptions && this.instance.option(e), this.optimizeUpdate.updateValue && this.instance.refresh()) : (this.instance.option(e), void 0 !== this.props.value && this.instance.refresh());
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new We(this.inputNode, e);
      }
    }, {
      key: "textMounted",
      value: function value(e) {
        this.inputNode = e;
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = t.valid,
            s = t.errorMessage,
            a = t.icon,
            o = t.iconAlign,
            i = (t.inputStyle, t.labelStyle, t.children),
            r = vn(t, ["valid", "errorMessage", "icon", "iconAlign", "inputStyle", "labelStyle", "children"]),
            l = null;
        return s && !n && (l = e.createElement("span", {
          className: "mbsc-err-msg"
        }, s)), e.createElement(Cn, {
          valid: n
        }, i, e.createElement("span", {
          className: "mbsc-input-wrap"
        }, e.createElement("textarea", bn({
          ref: this.textMounted,
          "data-icon": a,
          "data-icon-align": o
        }, r)), l));
      }
    }]), n;
  }(), Gt.propTypes = {
    disabled: n.bool,
    valid: n.bool,
    errorMessage: n.string,
    icon: n.string,
    iconAlign: n.string,
    name: n.string,
    inputStyle: n.string,
    labelStyle: n.string
  }, qt);
  s.Textarea = On;
  var Dn = (Xt = Zt = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.selectMounted = t.selectMounted.bind(t), t;
    }

    return c(n, Se), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new Je(this.selectNode, e);
      }
    }, {
      key: "selectMounted",
      value: function value(e) {
        this.selectNode = e;
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.instance._setText();
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = t.label,
            s = t.valid,
            a = t.errorMessage,
            o = t.icon,
            i = t.iconAlign,
            r = (t.inputStyle, t.labelStyle, t.children),
            l = vn(t, ["label", "valid", "errorMessage", "icon", "iconAlign", "inputStyle", "labelStyle", "children"]),
            c = null;
        return c = a && !s ? e.createElement("span", {
          className: "mbsc-err-msg"
        }, a) : e.createElement("span", null), e.createElement(Cn, {
          valid: s
        }, n, e.createElement("span", {
          className: "mbsc-input-wrap"
        }, e.createElement("select", bn({
          ref: this.selectMounted,
          "data-icon": o,
          "data-icon-align": i
        }, l), r), c));
      }
    }]), n;
  }(), Zt.propTypes = {
    label: n.string,
    disabled: n.bool,
    valid: n.bool,
    errorMessage: n.string,
    icon: n.string,
    iconAlign: n.string,
    name: n.string,
    inputStyle: n.string,
    labelStyle: n.string
  }, Xt);
  s.Dropdown = Dn;
  var En = (en = Qt = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.btnMounted = t.btnMounted.bind(t), t;
    }

    return c(n, Se), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new ze(this.btnNode, e), Te.call(this, "", this.getCssClasses(this.props));
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.cssClassUpdate && Te.call(this, this.cssClassUpdate.prev, this.cssClassUpdate.next);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e) {
        var t = this.getCssClasses(e),
            n = this.getCssClasses(this.props);
        return this.cssClassUpdate = n !== t ? {
          prev: n,
          next: t
        } : null, !0;
      }
    }, {
      key: "btnMounted",
      value: function value(e) {
        this.btnNode = e;
      }
    }, {
      key: "getCssClasses",
      value: function value(e) {
        var t = e.className,
            n = e.color,
            s = e.flat,
            a = e.block,
            o = e.outline,
            i = [];
        s && i.push("mbsc-btn-flat"), a && i.push("mbsc-btn-block"), o && i.push("mbsc-btn-outline"), n && i.push("mbsc-btn-" + n), t && i.push(t);
        var r = "";
        return i.length && (r = i.reduce(function (e, t) {
          return e + " " + t;
        }).replace(/\s+/g, " ").trim()), r;
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = t.type,
            s = t.children,
            a = (t.className, t.color, t.flat, t.block, t.outline, t.icon),
            o = vn(t, ["type", "children", "className", "color", "flat", "block", "outline", "icon"]);
        return n = n || "button", e.createElement("button", bn({
          ref: this.btnMounted,
          type: n,
          "data-icon": a
        }, o), s);
      }
    }]), n;
  }(), Qt.propTypes = {
    type: n.string,
    color: n.string,
    flat: n.bool,
    block: n.bool,
    outline: n.bool,
    icon: n.string,
    disabled: n.bool,
    name: n.string
  }, en);
  s.Button = En;
  var Pn = (nn = tn = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.inputMounted = t.inputMounted.bind(t), t;
    }

    return c(n, Se), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new Ve(this.inputNode, e);
      }
    }, {
      key: "inputMounted",
      value: function value(e) {
        this.inputNode = e;
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = t.color,
            s = t.children,
            a = (t.inputStyle, vn(t, ["color", "children", "inputStyle"]));
        return e.createElement(Cn, {
          color: n,
          presetName: "checkbox"
        }, e.createElement("input", bn({
          ref: this.inputMounted,
          type: "checkbox"
        }, a)), s);
      }
    }]), n;
  }(), tn.propTypes = {
    color: n.string,
    disabled: n.bool,
    name: n.string,
    inputStyle: n.string
  }, nn);
  s.Checkbox = Pn;
  var An = (an = sn = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.inputMounted = t.inputMounted.bind(t), t;
    }

    return c(n, Se), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new Ie(this.inputNode, e);
      }
    }, {
      key: "inputMounted",
      value: function value(e) {
        this.inputNode = e;
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = t.color,
            s = t.children,
            a = (t.inputStyle, vn(t, ["color", "children", "inputStyle"]));
        return e.createElement(Cn, {
          color: n,
          presetName: "radio"
        }, e.createElement("input", bn({
          ref: this.inputMounted,
          type: "radio"
        }, a)), s);
      }
    }]), n;
  }(), sn.propTypes = {
    color: n.string,
    name: n.string,
    disabled: n.bool,
    inputStyle: n.string
  }, an);
  s.Radio = An;
  var Fn = (rn = on = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.inputMounted = t.inputMounted.bind(t), t;
    }

    return c(n, Se), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new Ke(this.inputNode, e);
      }
    }, {
      key: "inputMounted",
      value: function value(e) {
        this.inputNode = e;
      }
    }, {
      key: "render",
      value: function value() {
        var t = this.props,
            n = t.color,
            s = t.children,
            a = t.multiSelect,
            o = t.icon,
            i = vn(t, ["color", "children", "multiSelect", "icon"]),
            r = a ? "checkbox" : "radio";
        return e.createElement(Cn, {
          color: n,
          presetName: "segmented"
        }, e.createElement("input", bn({
          ref: this.inputMounted,
          type: r,
          "data-icon": o,
          "data-role": "segmented"
        }, i)), s);
      }
    }]), n;
  }(), on.propTypes = {
    color: n.string,
    name: n.string,
    disabled: n.bool,
    multiSelect: n.bool,
    icon: n.string
  }, rn);
  s.Segmented = Fn;

  var Ln = (cn = ln = function (t) {
    function n(e, t) {
      i(this, n);
      var s = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return s.presetName = t, s.inputMounted = s.inputMounted.bind(s), s;
    }

    return c(n, ke), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props, this.mbscInit);
        this.instance = new Z[this.mbscInit.component || "Scroller"](this.inputNode, e), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0), Y(this.inputNode).on("change", this.props.onChange || function () {}), Te.call(this, "", this.getCssClasses(this.props));
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e) {
        var t = this.getCssClasses(e),
            s = this.getCssClasses(this.props);
        return this.cssClassUpdate = s !== t ? {
          prev: s,
          next: t
        } : null, l(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "shouldComponentUpdate", this).call(this, e) || this.cssClassUpdate;
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        this.cssClassUpdate && Te.call(this, this.cssClassUpdate.prev, this.cssClassUpdate.next);
      }
    }, {
      key: "inputMounted",
      value: function value(e) {
        this.inputNode = e;
      }
    }, {
      key: "getCssClasses",
      value: function value(e) {
        var t = e.className,
            n = e.color,
            s = [];
        return n && s.push("mbsc-" + this.presetName + "-" + n), t && s.push(t), s.length ? s.reduce(function (e, t) {
          return e + " " + t;
        }).replace(/\s+/g, " ").trim() : "";
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = (t.className, t.children),
            s = (t.value, t.onChange, t.name),
            a = (t.color, vn(t, ["className", "children", "value", "onChange", "name", "color"])),
            o = this.inputType || "text";
        return e.createElement("div", null, n, e.createElement("input", bn({
          ref: this.inputMounted,
          type: o,
          "data-role": s
        }, a)));
      }
    }]), n;
  }(), ln.propTypes = bn({}, pe, {
    color: gn
  }), cn),
      Hn = function (e) {
    function t(e) {
      i(this, t);
      var n = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, "switch"));
      return n.mbscInit = {
        component: "Switch"
      }, n.inputType = "checkbox", n;
    }

    return c(t, Ln), t;
  }();

  Hn.propTypes = bn({}, Hn.propTypes, Mn), s.Switch = Hn;

  var jn = function (e) {
    function t(e) {
      i(this, t);
      var n = u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, "stepper"));
      return n.mbscInit = {
        component: "Stepper"
      }, n;
    }

    return c(t, Ln), t;
  }();

  jn.propTypes = bn({}, jn.propTypes, kn), s.Stepper = jn;

  var zn = function (e) {
    function t(e) {
      return i(this, t), u(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
    }

    return c(t, ke), r(t, [{
      key: "componentDidMount",
      value: function value() {
        Te.call(this, "", this.getCssClasses(this.props));
      }
    }, {
      key: "componentDidUpdate",
      value: function value() {
        l(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "componentDidUpdate", this).call(this), this.cssClassUpdate && Te.call(this, this.cssClassUpdate.prev, this.cssClassUpdate.next);
      }
    }, {
      key: "shouldComponentUpdate",
      value: function value(e) {
        var n = this.getCssClasses(e),
            s = this.getCssClasses(this.props);
        return this.cssClassUpdate = s !== n ? {
          prev: s,
          next: n
        } : null, l(t.prototype.__proto__ || Object.getPrototypeOf(t.prototype), "shouldComponentUpdate", this).call(this, e) || this.cssClassUpdate;
      }
    }, {
      key: "getCssClasses",
      value: function value(e) {
        var t = e.className,
            n = e.color,
            s = [];
        return n && s.push("mbsc-" + this.presetName + "-" + n), t && s.push(t), s.length ? s.reduce(function (e, t) {
          return e + " " + t;
        }).replace(/\s+/g, " ").trim() : "";
      }
    }]), t;
  }(),
      Vn = (mn = un = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.presetName = "progress", t.progressMounted = t.progressMounted.bind(t), t;
    }

    return c(n, zn), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new Xe(this.progressNode, e), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0), l(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "componentDidMount", this).call(this);
      }
    }, {
      key: "progressMounted",
      value: function value(e) {
        this.progressNode = e;
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = (t.className, t.children),
            s = (t.value, t.color, t.inputStyle, vn(t, ["className", "children", "value", "color", "inputStyle"]));
        return e.createElement("div", null, n, e.createElement("progress", bn({
          ref: this.progressMounted
        }, s)));
      }
    }]), n;
  }(), un.propTypes = bn({}, pe, {
    "data-icon": gn,
    "data-icon-align": n.oneOf(["left", "right"]),
    val: n.oneOf(["left", "right"]),
    disabled: _n,
    max: yn,
    value: yn,
    color: gn,
    inputStyle: gn
  }), mn);

  s.Progress = Vn;
  var In = (pn = dn = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.presetName = "slider", t.firstInputMounted = t.firstInputMounted.bind(t), t.parentMounted = t.parentMounted.bind(t), t;
    }

    return c(n, zn), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this.getSettingsFromProps(this.props);
        this.instance = new Qe(this.firstInput, e), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0);
        var t = this;
        Y(this.label).on("change", function () {
          if (t.props.onChange) {
            var e = t.instance.getVal();
            t.props.onChange(e);
          }
        }), l(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "componentDidMount", this).call(this);
      }
    }, {
      key: "firstInputMounted",
      value: function value(e) {
        this.firstInput = e;
      }
    }, {
      key: "parentMounted",
      value: function value(e) {
        this.label = e;
      }
    }, {
      key: "onValueChanged",
      value: function value() {}
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = t.children,
            s = t.value,
            a = (t.onChange, t.className, t.icon),
            o = t.live,
            i = (t.stepLabels, t.tooltip, t.color, t.inputStyle, vn(t, ["children", "value", "onChange", "className", "icon", "live", "stepLabels", "tooltip", "color", "inputStyle"])),
            r = s || [];
        return o = o || this.props["data-live"] || !1, a = a || this.props["data-icon"], void 0 === s || Array.isArray(s) || (r = [s]), e.createElement("label", {
          ref: this.parentMounted
        }, n, r.map(function (t, n) {
          return 0 === n ? e.createElement("input", bn({
            ref: this.firstInputMounted,
            "data-icon": a,
            "data-live": o,
            key: n,
            type: "range"
          }, i)) : e.createElement("input", {
            key: n,
            type: "range",
            "data-live": o,
            "data-index": n
          });
        }, this));
      }
    }]), n;
  }(), dn.propTypes = bn({}, pe, {
    highlight: _n,
    live: _n,
    stepLabels: n.arrayOf(yn),
    "data-icon": gn,
    tooltip: _n,
    val: n.oneOf(["left", "right"]),
    disabled: _n,
    max: yn,
    min: yn,
    step: yn,
    values: yn,
    color: gn,
    inputStyle: gn
  }), pn);
  s.Slider = In;
  var Jn = (fn = hn = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.presetName = "rating", t.inputMounted = t.inputMounted.bind(t), t.parentMounted = t.parentMounted.bind(t), t;
    }

    return c(n, zn), r(n, [{
      key: "componentDidMount",
      value: function value() {
        var e = this,
            t = this.getSettingsFromProps(this.props);
        this.instance = new et(this.inputNode, t), void 0 !== this.props.value && this.instance.setVal(this.props.value, !0), Y(this.label).on("change", function () {
          if (e.props.onChange) {
            var t = e.instance.getVal();
            e.props.onChange(t);
          }
        }), l(n.prototype.__proto__ || Object.getPrototypeOf(n.prototype), "componentDidMount", this).call(this);
      }
    }, {
      key: "inputMounted",
      value: function value(e) {
        this.inputNode = e;
      }
    }, {
      key: "parentMounted",
      value: function value(e) {
        this.label = e;
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = (t.className, t.children),
            s = (t.onChange, t.value, t.empty),
            a = t.filled,
            o = t.template,
            i = t.val,
            r = (t.color, t.inputStyle, vn(t, ["className", "children", "onChange", "value", "empty", "filled", "template", "val", "color", "inputStyle"]));
        return e.createElement("label", {
          ref: this.parentMounted
        }, n, e.createElement("input", bn({
          type: "rating",
          "data-role": "rating",
          "data-val": i,
          "data-template": o,
          "data-empty": s,
          "data-filled": a,
          ref: this.inputMounted
        }, r)));
      }
    }]), n;
  }(), hn.propTypes = bn({}, pe, {
    val: n.oneOf(["left", "right"]),
    disabled: _n,
    max: yn,
    min: yn,
    step: yn,
    template: gn,
    empty: gn,
    filled: gn,
    value: yn,
    color: gn,
    inputStyle: gn
  }), fn);
  s.Rating = Jn;
  var Un = (xn = Tn = function (n) {
    function s(e) {
      return i(this, s), u(this, (s.__proto__ || Object.getPrototypeOf(s)).call(this, e));
    }

    return c(s, n), r(s, [{
      key: "componentDidMount",
      value: function value() {
        if (void 0 !== this.props.collapsible) {
          var e = this.props.open || !1;
          this.instance = new nt(t.findDOMNode(this), {
            isOpen: e
          });
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        void 0 !== this.props.open && this.props.open != e.open && (this.props.open ? this.instance.show() : this.instance.hide());
      }
    }, {
      key: "render",
      value: function value() {
        /* eslint-disable no-unused-vars */
        var t = this.props,
            n = t.children,
            s = t.inset,
            a = (t.collapsible, t.className),
            o = vn(t, ["children", "inset", "collapsible", "className"]),
            i = "mbsc-form-group" + (void 0 !== s ? "-inset" : "") + " " + (a || "");
        return e.createElement("div", bn({
          className: i
        }, o), n);
      }
    }]), s;
  }(e.Component), Tn.propTypes = {
    collapsible: n.any,
    open: n.bool,
    inset: n.any
  }, xn);
  s.FormGroup = Un, s.MbscFormGroup = Un;

  var Rn = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.cssClasses = "mbsc-form-group-title " + (t.props.className || ""), t;
    }

    return c(n, t), r(n, [{
      key: "render",
      value: function value() {
        return e.createElement("div", {
          className: this.cssClasses
        }, this.props.children);
      }
    }]), n;
  }(e.Component);

  s.FormGroupTitle = Rn, s.MbscFormGroupTitle = Rn;

  var $n = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.cssClasses = "mbsc-form-group-content " + (t.props.className || ""), t;
    }

    return c(n, t), r(n, [{
      key: "render",
      value: function value() {
        return e.createElement("div", {
          className: this.cssClasses
        }, this.props.children);
      }
    }]), n;
  }(e.Component);

  s.FormGroupContent = $n, s.MbscFormGroupContent = $n;

  var Bn = function (t) {
    function n(e) {
      i(this, n);
      var t = u(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
      return t.cssClasses = "mbsc-accordion " + (t.props.className || ""), t;
    }

    return c(n, t), r(n, [{
      key: "render",
      value: function value() {
        return e.createElement("div", {
          className: this.cssClasses
        }, this.props.children);
      }
    }]), n;
  }(e.Component);

  s.Accordion = Bn, s.i18n.ar = {
    rtl: !0,
    setText: "تعيين",
    cancelText: "إلغاء",
    clearText: "مسح",
    selectedText: "{count} المحدد",
    dateFormat: "dd/mm/yy",
    dayNames: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
    dayNamesShort: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
    dayNamesMin: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
    dayText: "يوم",
    hourText: "ساعات",
    minuteText: "الدقائق",
    monthNames: ["كانون الثاني", "شهر فبراير", "مارس", "أبريل", "قد", "يونيو", "يوليو", "أغسطس", "سبتمبر", "شهر اكتوبر", "شهر نوفمبر", "ديسمبر"],
    monthNamesShort: ["كانون الثاني", "شهر فبراير", "مارس", "أبريل", "قد", "يونيو", "يوليو", "أغسطس", "سبتمبر", "شهر اكتوبر", "شهر نوفمبر", "ديسمبر"],
    monthText: "شهر",
    secText: "ثواني",
    amText: "ص",
    pmText: "م",
    timeFormat: "hh:ii A",
    yearText: "عام",
    nowText: "الآن",
    firstDay: 0,
    dateText: "تاريخ",
    timeText: "وقت",
    closeText: "إغلاق",
    todayText: "اليوم",
    prevMonthText: "الشهر السابق",
    nextMonthText: "الشهر القادم",
    prevYearText: "السنه السابقة",
    nextYearText: "العام القادم",
    allDayText: "اليوم كله",
    noEventsText: "لا توجد احداث",
    eventText: "الحدث",
    eventsText: "أحداث",
    moreEventsText: "واحد آخر",
    moreEventsPluralText: "اثنان آخران {count}",
    fromText: "يبدا",
    toText: "ينتهي",
    wholeText: "كامل",
    fractionText: "جزء",
    unitText: "وحدة",
    delimiter: "/",
    decimalSeparator: ".",
    thousandsSeparator: ",",
    labels: ["سنوات", "أشهر", "أيام", "ساعة", "دقائق", "ثواني", ""],
    labelsShort: ["سنوات", "أشهر", "أيام", "ساعة", "دقائق", "ثواني", ""],
    startText: "بدء",
    stopText: "إيقاف",
    resetText: "إعادة ضبط",
    lapText: "الدورة",
    hideText: "إخفاء",
    offText: "إيقاف",
    onText: "تشغيل",
    backText: "رجوع",
    undoText: "تراجع"
  }, s.i18n.bg = {
    setText: "Задаване",
    cancelText: "Отмяна",
    clearText: "Изчистване",
    selectedText: "{count} подбран",
    dateFormat: "dd.mm.yy",
    dayNames: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
    dayNamesShort: ["Нед", "Пон", "Вто", "Сря", "Чет", "Пет", "Съб"],
    dayNamesMin: ["Не", "По", "Вт", "Ср", "Че", "Пе", "Съ"],
    dayText: "ден",
    delimiter: ".",
    hourText: "час",
    minuteText: "минута",
    monthNames: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
    monthNamesShort: ["Яну", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Нов", "Дек"],
    monthText: "месец",
    secText: "секунди",
    timeFormat: "H:ii",
    yearText: "година",
    nowText: "Сега",
    pmText: "pm",
    amText: "am",
    firstDay: 1,
    dateText: "Дата",
    timeText: "път",
    todayText: "днес",
    prevMonthText: "Предишния месец",
    nextMonthText: "Следващият месец",
    prevYearText: "Предходната година",
    nextYearText: "Следващата година",
    closeText: "затвори",
    eventText: "Събитие",
    eventsText: "Събития",
    allDayText: "Цял ден",
    noEventsText: "Няма събития",
    moreEventsText: "Още {count}",
    fromText: "ОТ",
    toText: "ДО",
    wholeText: "цяло",
    fractionText: "фракция",
    unitText: "единица",
    labels: ["Години", "месеца", "дни", "часа", "минути", "секунди", ""],
    labelsShort: ["Години", "месеца", "дни", "часа", "минути", "секунди", ""],
    startText: "Старт",
    stopText: "Стоп",
    resetText: "Нулиране",
    lapText: "Обиколка",
    hideText: "крия",
    backText: "връщане",
    undoText: "ОТМЯНА",
    offText: "ИЗКЛ",
    onText: "ВКЛ",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.ca = {
    setText: "Acceptar",
    cancelText: "Cancel·lar",
    clearText: "Esborrar",
    selectedText: "{count} seleccionat",
    selectedPluralText: "{count} seleccionats",
    dateFormat: "dd/mm/yy",
    dayNames: ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"],
    dayNamesShort: ["Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"],
    dayNamesMin: ["Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"],
    dayText: "Dia",
    hourText: "Hores",
    minuteText: "Minuts",
    monthNames: ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"],
    monthNamesShort: ["Gen", "Feb", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Des"],
    monthText: "Mes",
    secText: "Segons",
    timeFormat: "HH:ii",
    yearText: "Any",
    nowText: "Ara",
    pmText: "pm",
    amText: "am",
    todayText: "Avui",
    firstDay: 1,
    dateText: "Data",
    timeText: "Temps",
    closeText: "Tancar",
    allDayText: "Tot el dia",
    noEventsText: "Cap esdeveniment",
    eventText: "Esdeveniments",
    eventsText: "Esdeveniments",
    moreEventsText: "{count} més",
    fromText: "Iniciar",
    toText: "Final",
    wholeText: "Sencer",
    fractionText: "Fracció",
    unitText: "Unitat",
    labels: ["Anys", "Mesos", "Dies", "Hores", "Minuts", "Segons", ""],
    labelsShort: ["Anys", "Mesos", "Dies", "Hrs", "Mins", "Secs", ""],
    startText: "Iniciar",
    stopText: "Aturar",
    resetText: "Reiniciar",
    lapText: "Volta",
    hideText: "Amagar",
    backText: "Enrere",
    undoText: "Desfés",
    offText: "No",
    onText: "Si"
  }, s.i18n.cs = {
    setText: "Zadej",
    cancelText: "Storno",
    clearText: "Vymazat",
    selectedText: "Označený: {count}",
    dateFormat: "dd.mm.yy",
    dayNames: ["Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
    dayNamesShort: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
    dayNamesMin: ["N", "P", "Ú", "S", "Č", "P", "S"],
    dayText: "Den",
    hourText: "Hodiny",
    minuteText: "Minuty",
    monthNames: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
    monthNamesShort: ["Led", "Úno", "Bře", "Dub", "Kvě", "Čer", "Čvc", "Spr", "Zář", "Říj", "Lis", "Pro"],
    monthText: "Měsíc",
    secText: "Sekundy",
    timeFormat: "HH:ii",
    yearText: "Rok",
    nowText: "Teď",
    amText: "am",
    pmText: "pm",
    todayText: "Dnes",
    firstDay: 1,
    dateText: "Datum",
    timeText: "Čas",
    closeText: "Zavřít",
    allDayText: "Celý den",
    noEventsText: "Žádné události",
    eventText: "Událostí",
    eventsText: "Události",
    moreEventsText: "{count} další",
    fromText: "Začátek",
    toText: "Konec",
    wholeText: "Celý",
    fractionText: "Část",
    unitText: "Jednotka",
    labels: ["Roky", "Měsíce", "Dny", "Hodiny", "Minuty", "Sekundy", ""],
    labelsShort: ["Rok", "Měs", "Dny", "Hod", "Min", "Sec", ""],
    startText: "Start",
    stopText: "Stop",
    resetText: "Resetovat",
    lapText: "Etapa",
    hideText: "Schovat",
    backText: "Zpět",
    undoText: "Zpět",
    offText: "O",
    onText: "I",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.da = {
    setText: "Sæt",
    cancelText: "Annuller",
    clearText: "Ryd",
    selectedText: "{count} valgt",
    selectedPluralText: "{count} valgt",
    dateFormat: "dd/mm/yy",
    dayNames: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
    dayNamesShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
    dayNamesMin: ["S", "M", "T", "O", "T", "F", "L"],
    dayText: "Dag",
    hourText: "Timer",
    minuteText: "Minutter",
    monthNames: ["Januar", "Februar", "Marts", "April", "Maj", "Juni", "Juli", "August", "September", "Oktober", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
    monthText: "Måned",
    secText: "Sekunder",
    amText: "am",
    pmText: "pm",
    timeFormat: "HH.ii",
    yearText: "År",
    nowText: "Nu",
    todayText: "I dag",
    firstDay: 1,
    dateText: "Dato",
    timeText: "Tid",
    closeText: "Luk",
    allDayText: "Hele dagen",
    noEventsText: "Ingen begivenheder",
    eventText: "Begivenheder",
    eventsText: "Begivenheder",
    moreEventsText: "{count} mere",
    fromText: "Start",
    toText: "Slut",
    wholeText: "Hele",
    fractionText: "Dele",
    unitText: "Enhed",
    labels: ["År", "Måneder", "Dage", "Timer", "Minutter", "Sekunder", ""],
    labelsShort: ["År", "Mdr", "Dg", "Timer", "Min", "Sek", ""],
    startText: "Start",
    stopText: "Stop",
    resetText: "Nulstil",
    lapText: "Omgang",
    hideText: "Skjul",
    offText: "Fra",
    onText: "Til",
    backText: "Tilbage",
    undoText: "Fortryd"
  }, s.i18n.de = {
    setText: "OK",
    cancelText: "Abbrechen",
    clearText: "Löschen",
    selectedText: "{count} ausgewählt",
    dateFormat: "dd.mm.yy",
    dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    dayNamesMin: ["S", "M", "D", "M", "D", "F", "S"],
    dayText: "Tag",
    delimiter: ".",
    hourText: "Stunde",
    minuteText: "Minuten",
    monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthText: "Monat",
    secText: "Sekunden",
    timeFormat: "HH:ii",
    yearText: "Jahr",
    nowText: "Jetzt",
    pmText: "pm",
    amText: "am",
    todayText: "Heute",
    firstDay: 1,
    dateText: "Datum",
    timeText: "Zeit",
    closeText: "Schließen",
    allDayText: "Ganztägig",
    noEventsText: "Keine Ereignisse",
    eventText: "Ereignis",
    eventsText: "Ereignisse",
    moreEventsText: "{count} weiteres Element",
    moreEventsPluralText: "{count} weitere Elemente",
    fromText: "Von",
    toText: "Bis",
    wholeText: "Ganze Zahl",
    fractionText: "Bruchzahl",
    unitText: "Maßeinheit",
    labels: ["Jahre", "Monate", "Tage", "Stunden", "Minuten", "Sekunden", ""],
    labelsShort: ["Jahr.", "Mon.", "Tag.", "Std.", "Min.", "Sek.", ""],
    startText: "Starten",
    stopText: "Stoppen",
    resetText: "Zurücksetzen",
    lapText: "Lap",
    hideText: "Ausblenden",
    backText: "Zurück",
    undoText: "Rückgängig machen",
    offText: "Aus",
    onText: "Ein",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.el = {
    setText: "Ορισμος",
    cancelText: "Ακυρωση",
    clearText: "Διαγραφη",
    selectedText: "{count} επιλεγμένα",
    dateFormat: "dd/mm/yy",
    dayNames: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"],
    dayNamesShort: ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"],
    dayNamesMin: ["Κυ", "Δε", "Τρ", "Τε", "Πε", "Πα", "Σα"],
    dayText: "ημέρα",
    delimiter: "/",
    hourText: "ώρα",
    minuteText: "λεπτό",
    monthNames: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"],
    monthNamesShort: ["Ιαν", "Φεβ", "Μαρ", "Απρ", "Μαι", "Ιουν", "Ιουλ", "Αυγ", "Σεπ", "Οκτ", "Νοε", "Δεκ"],
    monthText: "Μήνας",
    secText: "δευτερόλεπτα",
    timeFormat: "H:ii",
    yearText: "έτος",
    nowText: "τώρα",
    pmText: "μμ",
    amText: "πμ",
    firstDay: 1,
    dateText: "Ημερομηνία",
    timeText: "φορά",
    todayText: "Σήμερα",
    prevMonthText: "Προηγούμενο μήνα",
    nextMonthText: "Επόμενο μήνα",
    prevYearText: "Προηγούμενο έτος",
    nextYearText: "Επόμενο έτος",
    closeText: "Κλείσιμο",
    eventText: "Γεγονότα",
    eventsText: "Γεγονότα",
    allDayText: "Ολοήμερο",
    noEventsText: "Δεν υπάρχουν γεγονότα",
    moreEventsText: "{count} ακόμη",
    fromText: "Αρχή",
    toText: "Τέλος",
    wholeText: "Ολόκληρος",
    fractionText: "κλάσμα",
    unitText: "Μονάδα",
    labels: ["Χρόνια", "Μήνες", "Ημέρες", "Ωρες", "Λεπτά", "δευτερόλεπτα", ""],
    labelsShort: ["Χρόνια", "Μήνες", "Ημέρες", "Ωρες", "Λεπτά", "δευτ", ""],
    startText: "΄Εναρξη",
    stopText: "Διακοπή",
    resetText: "Επαναφορά",
    lapText: "Γύρος",
    hideText: "κρύβω",
    backText: "Πίσω",
    undoText: "Αναιρεση",
    offText: "Ανενεργό",
    onText: "Ενεργό",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n["en-GB"] = s.i18n["en-UK"] = {
    dateFormat: "dd/mm/yy",
    timeFormat: "HH:ii"
  }, s.i18n.es = {
    setText: "Aceptar",
    cancelText: "Cancelar",
    clearText: "Borrar",
    selectedText: "{count} seleccionado",
    selectedPluralText: "{count} seleccionados",
    dateFormat: "dd/mm/yy",
    dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    dayNamesShort: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    dayText: "Día",
    hourText: "Horas",
    minuteText: "Minutos",
    monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    monthText: "Mes",
    secText: "Segundos",
    timeFormat: "HH:ii",
    yearText: "A&ntilde;o",
    nowText: "Ahora",
    pmText: "pm",
    amText: "am",
    todayText: "Hoy",
    firstDay: 1,
    dateText: "Fecha",
    timeText: "Tiempo",
    closeText: "Cerrar",
    allDayText: "Todo el día",
    noEventsText: "No hay eventos",
    eventText: "Evento",
    eventsText: "Eventos",
    moreEventsText: "{count} más",
    fromText: "Iniciar",
    toText: "Final",
    wholeText: "Entero",
    fractionText: "Fracción",
    unitText: "Unidad",
    labels: ["Años", "Meses", "Días", "Horas", "Minutos", "Segundos", ""],
    labelsShort: ["Año", "Mes", "Día", "Hora", "Min", "Seg", ""],
    startText: "Iniciar",
    stopText: "Deténgase",
    resetText: "Reinicializar",
    lapText: "Lap",
    hideText: "Esconder",
    backText: "Atrás",
    undoText: "Deshacer",
    offText: "No",
    onText: "Sí",
    decimalSeparator: ",",
    thousandsSeparator: " "
  };
  s.i18n.fa = {
    setText: "تاييد",
    cancelText: "انصراف",
    clearText: "واضح ",
    selectedText: "{count} منتخب",
    calendarSystem: "jalali",
    dateFormat: "yy/mm/dd",
    dayNames: ["يکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه"],
    dayNamesShort: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
    dayNamesMin: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
    dayText: "روز",
    hourText: "ساعت",
    minuteText: "دقيقه",
    monthNames: ["فروردين", "ارديبهشت", "خرداد", "تير", "مرداد", "شهريور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
    monthNamesShort: ["فروردين", "ارديبهشت", "خرداد", "تير", "مرداد", "شهريور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"],
    monthText: "ماه",
    secText: "ثانيه",
    timeFormat: "HH:ii",
    timeWheels: "iiHH",
    yearText: "سال",
    nowText: "اکنون",
    amText: "ب",
    pmText: "ص",
    todayText: "امروز",
    firstDay: 6,
    rtl: !0,
    dateText: "تاریخ ",
    timeText: "زمان ",
    closeText: "نزدیک",
    allDayText: "تمام روز",
    noEventsText: "هیچ رویداد",
    eventText: "رویداد",
    eventsText: "رویدادها",
    moreEventsText: "{count} مورد دیگر",
    fromText: "شروع ",
    toText: "پایان",
    wholeText: "تمام",
    fractionText: "کسر",
    unitText: "واحد",
    labels: ["سال", "ماه", "روز", "ساعت", "دقیقه", "ثانیه", ""],
    labelsShort: ["سال", "ماه", "روز", "ساعت", "دقیقه", "ثانیه", ""],
    startText: "شروع",
    stopText: "پايان",
    resetText: "تنظیم مجدد",
    lapText: "Lap",
    hideText: "پنهان کردن",
    backText: "پشت",
    undoText: "واچیدن"
  }, s.i18n.fi = {
    setText: "Aseta",
    cancelText: "Peruuta",
    clearText: "Tyhjennä",
    selectedText: "{count} valita",
    dateFormat: "d. MM yy",
    dayNames: ["Sunnuntai", "Maanantai", "Tiistai", "Keskiviiko", "Torstai", "Perjantai", "Lauantai"],
    dayNamesShort: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"],
    dayNamesMin: ["S", "M", "T", "K", "T", "P", "L"],
    dayText: "Päivä",
    delimiter: ".",
    hourText: "Tuntia",
    minuteText: "Minuutti",
    monthNames: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"],
    monthNamesShort: ["Tam", "Hel", "Maa", "Huh", "Tou", "Kes", "Hei", "Elo", "Syy", "Lok", "Mar", "Jou"],
    monthText: "Kuukausi",
    secText: "Sekunda",
    timeFormat: "H:ii",
    yearText: "Vuosi",
    nowText: "Nyt",
    pmText: "pm",
    amText: "am",
    firstDay: 1,
    dateText: "Päiväys",
    timeText: "Aika",
    todayText: "Tänään",
    prevMonthText: "Edellinen kuukausi",
    nextMonthText: "Ensi kuussa",
    prevYearText: "Edellinen vuosi",
    nextYearText: "Ensi vuosi",
    closeText: "Sulje",
    eventText: "Tapahtumia",
    eventsText: "Tapahtumia",
    allDayText: "Koko päivä",
    noEventsText: "Ei tapahtumia",
    moreEventsText: "{count} muu",
    moreEventsPluralText: "{count} muuta",
    fromText: "Alkaa",
    toText: "Päättyy",
    wholeText: "Kokonainen",
    fractionText: "Murtoluku",
    unitText: "Yksikkö",
    labels: ["Vuosi", "Kuukausi", "Päivä", "Tunnin", "Minuutti", "sekuntia", ""],
    labelsShort: ["Vuo", "Kuu", "Päi", "Tun", "Min", "Sek", ""],
    startText: "Käynnistys",
    stopText: "Seis",
    resetText: "Aseta uudelleen",
    lapText: "Kierros",
    hideText: "Vuota",
    backText: "Edellinen",
    undoText: "Kumoa",
    offText: "Pois",
    onText: "Päällä",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.fr = {
    setText: "Terminer",
    cancelText: "Annuler",
    clearText: "Effacer",
    selectedText: "{count} sélectionné",
    selectedPluralText: "{count} sélectionnés",
    dateFormat: "dd/mm/yy",
    dayNames: ["&#68;imanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
    dayNamesShort: ["&#68;im.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."],
    dayNamesMin: ["&#68;", "L", "M", "M", "J", "V", "S"],
    dayText: "Jour",
    monthText: "Mois",
    monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
    monthNamesShort: ["Janv.", "Févr.", "Mars", "Avril", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."],
    hourText: "Heures",
    minuteText: "Minutes",
    secText: "Secondes",
    timeFormat: "HH:ii",
    yearText: "Année",
    nowText: "Maintenant",
    pmText: "pm",
    amText: "am",
    todayText: "Aujourd'hui",
    firstDay: 1,
    dateText: "Date",
    timeText: "Heure",
    closeText: "Fermer",
    allDayText: "Toute la journée",
    noEventsText: "Aucun événement",
    eventText: "Événement",
    eventsText: "Événements",
    moreEventsText: "{count} autre",
    moreEventsPluralText: "{count} autres",
    fromText: "Démarrer",
    toText: "Fin",
    wholeText: "Entier",
    fractionText: "Fraction",
    unitText: "Unité",
    labels: ["Ans", "Mois", "Jours", "Heures", "Minutes", "Secondes", ""],
    labelsShort: ["Ans", "Mois", "Jours", "Hrs", "Min", "Sec", ""],
    startText: "Démarrer",
    stopText: "Arrêter",
    resetText: "Réinitialiser",
    lapText: "Lap",
    hideText: "Cachez",
    backText: "Retour",
    undoText: "Annuler",
    offText: "Non",
    onText: "Oui",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.he = {
    rtl: !0,
    setText: "שמירה",
    cancelText: "ביטול",
    clearText: "נקה",
    selectedText: "{count} נבחר",
    selectedPluralText: "{count} נבחרו",
    dateFormat: "dd/mm/yy",
    dayNames: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
    dayNamesShort: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ש'"],
    dayNamesMin: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
    dayText: "יום",
    hourText: "שעות",
    minuteText: "דקות",
    monthNames: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
    monthNamesShort: ["ינו", "פבר", "מרץ", "אפר", "מאי", "יונ", "יול", "אוג", "ספט", "אוק", "נוב", "דצמ"],
    monthText: "חודש",
    secText: "שניות",
    amText: "am",
    pmText: "pm",
    timeFormat: "HH:ii",
    timeWheels: "iiHH",
    yearText: "שנה",
    nowText: "עכשיו",
    firstDay: 0,
    dateText: "תאריך",
    timeText: "זמן",
    closeText: "סגירה",
    todayText: "היום",
    allDayText: "כל היום",
    noEventsText: "אין אירועים",
    eventText: "מִקרֶה",
    eventsText: "מִקרֶה",
    moreEventsText: "אירוע אחד נוסף",
    moreEventsPluralText: "{count} אירועים נוספים",
    fromText: "התחלה",
    toText: "סיום",
    wholeText: "כֹּל",
    fractionText: "שבריר",
    unitText: "יחידה",
    labels: ["שנים", "חודשים", "ימים", "שעות", "דקות", "שניים", ""],
    labelsShort: ["שנים", "חודשים", "ימים", "שעות", "דקות", "שניים", ""],
    startText: "התחל",
    stopText: "עצור",
    resetText: "אתחול",
    lapText: "הקפה",
    hideText: "הסתר",
    offText: "כיבוי",
    onText: "הפעלה",
    backText: "חזור",
    undoText: "ביטול פעולה"
  }, s.i18n.hi = {
    setText: "सैट करें",
    cancelText: "रद्द करें",
    clearText: "साफ़ को",
    selectedText: "{count} चयनित",
    dateFormat: "dd/mm/yy",
    dayNames: ["रविवार", "सोमवार", "मंगलवार", "बुधवार", "गुरुवार", "शुक्रवार", "शनिवार"],
    dayNamesShort: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
    dayNamesMin: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
    dayText: "दिन",
    delimiter: ".",
    hourText: "घंटा",
    minuteText: "मिनट",
    monthNames: ["जनवरी ", "फरवरी", "मार्च", "अप्रेल", "मई", "जून", "जूलाई", "अगस्त ", "सितम्बर", "अक्टूबर", "नवम्बर", "दिसम्बर"],
    monthNamesShort: ["जन", "फर", "मार्च", "अप्रेल", "मई", "जून", "जूलाई", "अग", "सित", "अक्ट", "नव", "दि"],
    monthText: "महीना",
    secText: "सेकंड",
    timeFormat: "H:ii",
    yearText: "साल",
    nowText: "अब",
    pmText: "अपराह्न",
    amText: "पूर्वाह्न",
    firstDay: 1,
    dateText: "तिथि",
    timeText: "समय",
    todayText: "आज",
    prevMonthText: "पिछ्ला महिना",
    nextMonthText: "अगले महीने",
    prevYearText: "पिछला साल",
    nextYearText: "अगले वर्ष",
    closeText: "बंद",
    eventText: "इवेट३",
    eventsText: "इवेट३",
    allDayText: "पूरे दिन",
    noEventsText: "Ei tapahtumia",
    moreEventsText: "{count} और",
    fromText: "से",
    toText: "तक",
    wholeText: "समूचा",
    fractionText: "अंश",
    unitText: "इकाई",
    labels: ["साल", "महीने", "दिन", "घंटे", "मिनट", "सेकंड", ""],
    labelsShort: ["साल", "महीने", "दिन", "घंटे", "मिनट", "सेकंड", ""],
    startText: "प्रारंभ",
    stopText: "रोकें",
    resetText: "रीसेट करें",
    lapText: "लैप",
    hideText: "छिपाना",
    backText: "वापस",
    undoText: "वापस लाएं",
    offText: "बंद",
    onText: "चालू",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.hr = {
    setText: "Postavi",
    cancelText: "Izlaz",
    clearText: "Izbriši",
    selectedText: "{count} odabran",
    dateFormat: "dd.mm.yy",
    dayNames: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
    dayNamesShort: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
    dayNamesMin: ["Ne", "Po", "Ut", "Sr", "Če", "Pe", "Su"],
    dayText: "Dan",
    delimiter: ".",
    hourText: "Sat",
    minuteText: "Minuta",
    monthNames: ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"],
    monthNamesShort: ["Sij", "Velj", "Ožu", "Tra", "Svi", "Lip", "Srp", "Kol", "Ruj", "Lis", "Stu", "Pro"],
    monthText: "Mjesec",
    secText: "Sekunda",
    timeFormat: "H:ii",
    yearText: "Godina",
    nowText: "Sada",
    pmText: "pm",
    amText: "am",
    firstDay: 1,
    dateText: "Datum",
    timeText: "Vrijeme",
    todayText: "Danas",
    prevMonthText: "Prethodni mjesec",
    nextMonthText: "Sljedeći mjesec",
    prevYearText: "Prethodni godina",
    nextYearText: "Slijedeće godine",
    closeText: "Zatvori",
    eventText: "Događaj",
    eventsText: "događaja",
    allDayText: "Cijeli dan",
    noEventsText: "Bez događaja",
    moreEventsText: "Još {count}",
    fromText: "Počinje",
    toText: "Završava",
    wholeText: "Cjelina",
    fractionText: "Frakcija",
    unitText: "Jedinica",
    labels: ["godina", "mjesec", "dan", "sat", "minuta", "sekunda", ""],
    labelsShort: ["god", "mje", "dan", "sat", "min", "sec", ""],
    startText: "Početak",
    stopText: "Prekid",
    resetText: "Resetiraj",
    lapText: "Ciklus",
    hideText: "Sakriti",
    backText: "Natrag",
    undoText: "Poništavanje",
    offText: "Uklj.",
    onText: "Isklj.",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.hu = {
    setText: "OK",
    cancelText: "Mégse",
    clearText: "Törlés",
    selectedText: "{count} kiválasztva",
    dateFormat: "yy.mm.dd.",
    dayNames: ["Vasárnap", "Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat"],
    dayNamesShort: ["Va", "Hé", "Ke", "Sze", "Csü", "Pé", "Szo"],
    dayNamesMin: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
    dayText: "Nap",
    delimiter: ".",
    hourText: "Óra",
    minuteText: "Perc",
    monthNames: ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Már", "Ápr", "Máj", "Jún", "Júl", "Aug", "Szep", "Okt", "Nov", "Dec"],
    monthText: "Hónap",
    secText: "Másodperc",
    timeFormat: "H:ii",
    yearText: "Év",
    nowText: "Most",
    pmText: "pm",
    amText: "am",
    firstDay: 1,
    dateText: "Dátum",
    timeText: "Idő",
    todayText: "Ma",
    prevMonthText: "Előző hónap",
    nextMonthText: "Következő hónap",
    prevYearText: "Előző év",
    nextYearText: "Következő év",
    closeText: "Bezár",
    eventText: "esemény",
    eventsText: "esemény",
    allDayText: "Egész nap",
    noEventsText: "Nincs esemény",
    moreEventsText: "{count} további",
    fromText: "Eleje",
    toText: "Vége",
    wholeText: "Egész",
    fractionText: "Tört",
    unitText: "Egység",
    labels: ["Év", "Hónap", "Nap", "Óra", "Perc", "Másodperc", ""],
    labelsShort: ["Év", "Hó.", "Nap", "Óra", "Perc", "Mp.", ""],
    startText: "Indít",
    stopText: "Megállít",
    resetText: "Visszaállít",
    lapText: "Lap",
    hideText: "Elrejt",
    backText: "Vissza",
    undoText: "Visszavon",
    offText: "Ki",
    onText: "Be",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.it = {
    setText: "OK",
    cancelText: "Annulla",
    clearText: "Chiarire",
    selectedText: "{count} selezionato",
    selectedPluralText: "{count} selezionati",
    dateFormat: "dd/mm/yy",
    dayNames: ["Domenica", "Lunedì", "Mertedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
    dayNamesShort: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
    dayNamesMin: ["D", "L", "M", "M", "G", "V", "S"],
    dayText: "Giorno",
    hourText: "Ore",
    minuteText: "Minuti",
    monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
    monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
    monthText: "Mese",
    secText: "Secondi",
    timeFormat: "HH:ii",
    yearText: "Anno",
    nowText: "Ora",
    pmText: "pm",
    amText: "am",
    todayText: "Oggi",
    firstDay: 1,
    dateText: "Data",
    timeText: "Volta",
    closeText: "Chiudere",
    allDayText: "Tutto il giorno",
    noEventsText: "Nessun evento",
    eventText: "Evento",
    eventsText: "Eventi",
    moreEventsText: "{count} altro",
    moreEventsPluralText: "altri {count}",
    fromText: "Inizio",
    toText: "Fine",
    wholeText: "Intero",
    fractionText: "Frazione",
    unitText: "Unità",
    labels: ["Anni", "Mesi", "Giorni", "Ore", "Minuti", "Secondi", ""],
    labelsShort: ["Anni", "Mesi", "Gio", "Ore", "Min", "Sec", ""],
    startText: "Inizio",
    stopText: "Arresto",
    resetText: "Ripristina",
    lapText: "Lap",
    hideText: "Nascondi",
    backText: "Indietro",
    undoText: "Annulla",
    offText: "Via",
    onText: "Su",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.ja = {
    setText: "セット",
    cancelText: "キャンセル",
    clearText: "クリア",
    selectedText: "{count} 選択",
    dateFormat: "yy年mm月dd日",
    dayNames: ["日", "月", "火", "水", "木", "金", "土"],
    dayNamesShort: ["日", "月", "火", "水", "木", "金", "土"],
    dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
    dayText: "日",
    hourText: "時",
    minuteText: "分",
    monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    monthNamesShort: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    monthText: "月",
    secText: "秒",
    timeFormat: "HH:ii",
    yearText: "年",
    nowText: "今",
    pmText: "午後",
    amText: "午前",
    yearSuffix: "年",
    monthSuffix: "月",
    daySuffix: "日",
    todayText: "今日",
    dateText: "日付",
    timeText: "時間",
    closeText: "クローズ",
    allDayText: "終日",
    noEventsText: "イベントはありません",
    eventText: "イベント",
    eventsText: "イベント",
    moreEventsText: "他 {count} 件",
    fromText: "開始",
    toText: "終わり",
    wholeText: "全数",
    fractionText: "分数",
    unitText: "単位",
    labels: ["年間", "月間", "日間", "時間", "分", "秒", ""],
    labelsShort: ["年間", "月間", "日間", "時間", "分", "秒", ""],
    startText: "開始",
    stopText: "停止",
    resetText: "リセット",
    lapText: "ラップ",
    hideText: "隠す",
    backText: "バック",
    undoText: "アンドゥ"
  }, s.i18n.ko = {
    setText: "설정",
    cancelText: "취소",
    clearText: "삭제",
    selectedText: "{count} 선택된",
    dateFormat: "yy년mm월dd일",
    dayNames: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"],
    dayNamesShort: ["일", "월", "화", "수", "목", "금", "토"],
    dayNamesMin: ["일", "월", "화", "수", "목", "금", "토"],
    dayText: "일",
    delimiter: "-",
    hourText: "시간",
    minuteText: "분",
    monthNames: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
    monthNamesShort: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"],
    monthText: "달",
    secText: "초",
    timeFormat: "H:ii",
    yearText: "년",
    nowText: "지금",
    pmText: "오후",
    amText: "오전",
    yearSuffix: "년",
    monthSuffix: "월",
    daySuffix: "일",
    firstDay: 0,
    dateText: "날짜",
    timeText: "시간",
    todayText: "오늘",
    prevMonthText: "이전 달",
    nextMonthText: "다음 달",
    prevYearText: "이전 년",
    nextYearText: "다음 년",
    closeText: "닫기",
    eventText: "이벤트",
    eventsText: "이벤트",
    allDayText: "종일",
    noEventsText: "이벤트 없음",
    moreEventsText: "{count}개 더보기",
    fromText: "시작",
    toText: "종료",
    wholeText: "정수",
    fractionText: "분수",
    unitText: "단위",
    labels: ["년", "달", "일", "시간", "분", "초", ""],
    labelsShort: ["년", "달", "일", "시간", "분", "초", ""],
    startText: "시작",
    stopText: "중지 ",
    resetText: "초기화",
    lapText: "기록",
    hideText: "숨는 장소",
    backText: "뒤로",
    undoText: "실행취소",
    offText: "끔",
    onText: "켬",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.lt = {
    setText: "OK",
    cancelText: "Atšaukti",
    clearText: "Išvalyti",
    selectedText: "Pasirinktas {count}",
    selectedPluralText: "Pasirinkti {count}",
    dateFormat: "yy-mm-dd",
    dayNames: ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadienis"],
    dayNamesShort: ["S", "Pr", "A", "T", "K", "Pn", "Š"],
    dayNamesMin: ["S", "Pr", "A", "T", "K", "Pn", "Š"],
    dayText: "Diena",
    hourText: "Valanda",
    minuteText: "Minutes",
    monthNames: ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"],
    monthNamesShort: ["Sau", "Vas", "Kov", "Bal", "Geg", "Bir", "Lie", "Rugp", "Rugs", "Spa", "Lap", "Gruo"],
    monthText: "Mėnuo",
    secText: "Sekundes",
    amText: "am",
    pmText: "pm",
    timeFormat: "HH:ii",
    yearText: "Metai",
    nowText: "Dabar",
    todayText: "Šiandien",
    firstDay: 1,
    dateText: "Data",
    timeText: "Laikas",
    closeText: "Uždaryti",
    allDayText: "Visą dieną",
    noEventsText: "Nėra įvykių",
    eventText: "Įvykių",
    eventsText: "Įvykiai",
    moreEventsText: "Dar {count}",
    fromText: "Nuo",
    toText: "Iki",
    wholeText: "Visas",
    fractionText: "Frakcija",
    unitText: "Vienetas",
    labels: ["Metai", "Mėnesiai", "Dienos", "Valandos", "Minutes", "Sekundes", ""],
    labelsShort: ["m", "mėn.", "d", "h", "min", "s", ""],
    startText: "Pradėti",
    stopText: "Sustabdyti",
    resetText: "Išnaujo",
    lapText: "Ratas",
    hideText: "Slėpti",
    backText: "Atgal",
    undoText: "Anuliuoti",
    offText: "Išj.",
    onText: "Įj.",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.nl = {
    setText: "Instellen",
    cancelText: "Annuleren",
    clearText: "Leegmaken",
    selectedText: "{count} gekozen",
    dateFormat: "dd-mm-yy",
    dayNames: ["zondag", "maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
    dayNamesShort: ["zo", "ma", "di", "wo", "do", "vr", "za"],
    dayNamesMin: ["z", "m", "d", "w", "d", "v", "z"],
    dayText: "Dag",
    hourText: "Uur",
    minuteText: "Minuten",
    monthNames: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
    monthNamesShort: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
    monthText: "Maand",
    secText: "Seconden",
    timeFormat: "HH:ii",
    yearText: "Jaar",
    nowText: "Nu",
    pmText: "pm",
    amText: "am",
    todayText: "Vandaag",
    firstDay: 1,
    dateText: "Datum",
    timeText: "Tijd",
    closeText: "Sluiten",
    allDayText: "Hele dag",
    noEventsText: "Geen activiteiten",
    eventText: "Activiteit",
    eventsText: "Activiteiten",
    moreEventsText: "nog {count}",
    fromText: "Start",
    toText: "Einde",
    wholeText: "geheel",
    fractionText: "fractie",
    unitText: "eenheid",
    labels: ["Jaren", "Maanden", "Dagen", "Uren", "Minuten", "Seconden", ""],
    labelsShort: ["j", "m", "d", "u", "min", "sec", ""],
    startText: "Start",
    stopText: "Stop",
    resetText: "Reset",
    lapText: "Ronde",
    hideText: "Verbergen",
    backText: "Terug",
    undoText: "Onged. maken",
    offText: "Uit",
    onText: "Aan",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.no = {
    setText: "OK",
    cancelText: "Avbryt",
    clearText: "Tømme",
    selectedText: "{count} valgt",
    dateFormat: "dd.mm.yy",
    dayNames: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
    dayNamesShort: ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"],
    dayNamesMin: ["S", "M", "T", "O", "T", "F", "L"],
    dayText: "Dag",
    delimiter: ".",
    hourText: "Time",
    minuteText: "Minutt",
    monthNames: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
    monthText: "Måned",
    secText: "Sekund",
    timeFormat: "HH:ii",
    yearText: "År",
    nowText: "Nå",
    pmText: "pm",
    amText: "am",
    todayText: "I dag",
    firstDay: 1,
    dateText: "Dato",
    timeText: "Tid",
    closeText: "Lukk",
    allDayText: "Hele dagen",
    noEventsText: "Ingen hendelser",
    eventText: "Hendelse",
    eventsText: "Hendelser",
    moreEventsText: "{count} mere",
    fromText: "Start",
    toText: "End",
    wholeText: "Hele",
    fractionText: "Fraksjon",
    unitText: "Enhet",
    labels: ["År", "Måneder", "Dager", "Timer", "Minutter", "Sekunder", ""],
    labelsShort: ["År", "Mån", "Dag", "Time", "Min", "Sek", ""],
    startText: "Start",
    stopText: "Stopp",
    resetText: "Tilbakestille",
    lapText: "Runde",
    hideText: "Skjul",
    backText: "Tilbake",
    undoText: "Angre",
    offText: "Av",
    onText: "På",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.pl = {
    setText: "Zestaw",
    cancelText: "Anuluj",
    clearText: "Oczyścić",
    selectedText: "Wybór: {count}",
    dateFormat: "yy-mm-dd",
    dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
    dayNamesShort: ["Niedz.", "Pon.", "Wt.", "Śr.", "Czw.", "Pt.", "Sob."],
    dayNamesMin: ["N", "P", "W", "Ś", "C", "P", "S"],
    dayText: "Dzień",
    hourText: "Godziny",
    minuteText: "Minuty",
    monthNames: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
    monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
    monthText: "Miesiąc",
    secText: "Sekundy",
    timeFormat: "HH:ii",
    yearText: "Rok",
    nowText: "Teraz",
    amText: "am",
    pmText: "pm",
    todayText: "Dzisiaj",
    firstDay: 1,
    dateText: "Data",
    timeText: "Czas",
    closeText: "Zakończenie",
    allDayText: "Cały dzień",
    noEventsText: "Brak wydarzeń",
    eventText: "Wydarzeń",
    eventsText: "Wydarzenia",
    moreEventsText: "Jeszcze {count}",
    fromText: "Rozpoczęcie",
    toText: "Koniec",
    wholeText: "Cały",
    fractionText: "Ułamek",
    unitText: "Jednostka",
    labels: ["Lata", "Miesiąc", "Dni", "Godziny", "Minuty", "Sekundy", ""],
    labelsShort: ["R", "M", "Dz", "Godz", "Min", "Sek", ""],
    startText: "Rozpoczęcie",
    stopText: "Zatrzymać",
    resetText: "Zresetować",
    lapText: "Zakładka",
    hideText: "Ukryć",
    backText: "Wróć",
    undoText: "Cofnij",
    offText: "Wył",
    onText: "Wł",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n["pt-BR"] = {
    setText: "Selecionar",
    cancelText: "Cancelar",
    clearText: "Claro",
    selectedText: "{count} selecionado",
    selectedPluralText: "{count} selecionados",
    dateFormat: "dd/mm/yy",
    dayNames: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    dayText: "Dia",
    hourText: "Hora",
    minuteText: "Minutos",
    monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    monthText: "Mês",
    secText: "Segundo",
    timeFormat: "HH:ii",
    yearText: "Ano",
    nowText: "Agora",
    pmText: "pm",
    amText: "am",
    todayText: "Hoje",
    dateText: "Data",
    timeText: "Tempo",
    closeText: "Fechar",
    allDayText: "Dia inteiro",
    noEventsText: "Nenhum evento",
    eventText: "Evento",
    eventsText: "Eventos",
    moreEventsText: "Mais {count}",
    fromText: "In&iacute;cio",
    toText: "Fim",
    wholeText: "Inteiro",
    fractionText: "Fração",
    unitText: "Unidade",
    labels: ["Anos", "Meses", "Dias", "Horas", "Minutos", "Segundos", ""],
    labelsShort: ["Ano", "M&ecirc;s", "Dia", "Hora", "Min", "Seg", ""],
    startText: "Começar",
    stopText: "Pare",
    resetText: "Reinicializar",
    lapText: "Lap",
    hideText: "Esconder",
    backText: "Anterior",
    undoText: "Desfazer",
    offText: "Desl",
    onText: "Lig",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n["pt-PT"] = {
    setText: "Seleccionar",
    cancelText: "Cancelar",
    clearText: "Claro",
    selectedText: "{count} selecionado",
    selectedPluralText: "{count} selecionados",
    dateFormat: "dd-mm-yy",
    dayNames: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    dayText: "Dia",
    hourText: "Horas",
    minuteText: "Minutos",
    monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    monthText: "Mês",
    secText: "Segundo",
    timeFormat: "HH:ii",
    yearText: "Ano",
    nowText: "Actualizar",
    pmText: "pm",
    amText: "am",
    todayText: "Hoy",
    firstDay: 1,
    dateText: "Data",
    timeText: "Tempo",
    closeText: "Fechar",
    allDayText: "Todo o dia",
    noEventsText: "Nenhum evento",
    eventText: "Evento",
    eventsText: "Eventos",
    moreEventsText: "mais {count}",
    fromText: "Início",
    toText: "Fim",
    wholeText: "Inteiro",
    fractionText: "Fracção",
    unitText: "Unidade",
    labels: ["Anos", "Meses", "Dias", "Horas", "Minutos", "Segundos", ""],
    labelsShort: ["Ano", "Mês", "Dia", "Hora", "Min", "Seg", ""],
    startText: "Começar",
    stopText: "Parar",
    resetText: "Reinicializar",
    lapText: "Lap",
    hideText: "Esconder",
    backText: "Anterior",
    undoText: "Anular",
    offText: "Desl",
    onText: "Lig",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.ro = {
    setText: "Setare",
    cancelText: "Anulare",
    clearText: "Ştergere",
    selectedText: "{count} selectat",
    selectedPluralText: "{count} selectate",
    dateFormat: "dd.mm.yy",
    dayNames: ["Duminică", "Luni", "Marți", "Miercuri", "Joi", "Vineri", "Sâmbătă"],
    dayNamesShort: ["Du", "Lu", "Ma", "Mi", "Jo", "Vi", "Sâ"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    dayText: " Ziua",
    delimiter: ".",
    hourText: " Ore ",
    minuteText: "Minute",
    monthNames: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
    monthNamesShort: ["Ian.", "Feb.", "Mar.", "Apr.", "Mai", "Iun.", "Iul.", "Aug.", "Sept.", "Oct.", "Nov.", "Dec."],
    monthText: "Luna",
    secText: "Secunde",
    timeFormat: "HH:ii",
    yearText: "Anul",
    nowText: "Acum",
    amText: "am",
    pmText: "pm",
    todayText: "Astăzi",
    prevMonthText: "Luna anterioară",
    nextMonthText: "Luna următoare",
    prevYearText: "Anul anterior",
    nextYearText: "Anul următor",
    eventText: "Eveniment",
    eventsText: "Evenimente",
    allDayText: "Toată ziua",
    noEventsText: "Niciun eveniment",
    moreEventsText: "Încă unul",
    moreEventsPluralText: "Încă {count}",
    firstDay: 1,
    dateText: "Data",
    timeText: "Ora",
    closeText: "Închidere",
    fromText: "Start",
    toText: "Final",
    wholeText: "Complet",
    fractionText: "Parţial",
    unitText: "Unitate",
    labels: ["Ani", "Luni", "Zile", "Ore", "Minute", "Secunde", ""],
    labelsShort: ["Ani", "Luni", "Zile", "Ore", "Min.", "Sec.", ""],
    startText: "Start",
    stopText: "Stop",
    resetText: "Resetare",
    lapText: "Tură",
    hideText: "Ascundere",
    backText: "Înapoi",
    undoText: "Anulează",
    offText: "Nu",
    onText: "Da",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n["ru-UA"] = {
    setText: "Установить",
    cancelText: "Отменить",
    clearText: "Очиститьr",
    selectedText: "{count} Вібрать",
    dateFormat: "dd.mm.yy",
    dayNames: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
    dayNamesShort: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
    dayNamesMin: ["в", "п", "в", "с", "ч", "п", "с"],
    dayText: "День",
    delimiter: ".",
    hourText: "Часы",
    minuteText: "Минуты",
    monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    monthNamesShort: ["Янв.", "Февр.", "Март", "Апр.", "Май", "Июнь", "Июль", "Авг.", "Сент.", "Окт.", "Нояб.", "Дек."],
    monthText: "Месяцы",
    secText: "Сикунды",
    timeFormat: "HH:ii",
    yearText: "Год",
    nowText: "Сейчас",
    amText: "am",
    pmText: "pm",
    todayText: "Cегодня",
    firstDay: 1,
    dateText: "Дата",
    timeText: "Время",
    closeText: "Закрыть",
    allDayText: "Весь день",
    noEventsText: "Нет событий",
    eventText: "Мероприятия",
    eventsText: "Мероприятия",
    moreEventsText: "Ещё {count}",
    fromText: "Начало",
    toText: "Конец",
    wholeText: "Весь",
    fractionText: "Часть",
    unitText: "Единица",
    labels: ["Годы", " Месяцы ", " Дни ", " Часы ", " Минуты ", " Секунды", ""],
    labelsShort: ["Год", "Мес.", "Дн.", "Ч.", "Мин.", "Сек.", ""],
    startText: "Старт",
    stopText: "Стоп",
    resetText: " Сброс ",
    lapText: " Этап ",
    hideText: " Скрыть ",
    backText: "назад",
    undoText: "ОтменитЬ",
    offText: "O",
    onText: "I",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n["ru-RU"] = s.i18n.ru = {
    setText: "Установить",
    cancelText: "Отмена",
    clearText: "Очистить",
    selectedText: "{count} Выбрать",
    dateFormat: "dd.mm.yy",
    dayNames: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
    dayNamesShort: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
    dayNamesMin: ["в", "п", "в", "с", "ч", "п", "с"],
    dayText: "День",
    delimiter: ".",
    hourText: "Час",
    minuteText: "Минут",
    monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
    monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
    monthText: "Месяц",
    secText: "Секунд",
    timeFormat: "HH:ii",
    yearText: "Год",
    nowText: "Сейчас",
    amText: "am",
    pmText: "pm",
    todayText: "Cегодня",
    firstDay: 1,
    dateText: "Дата",
    timeText: "Время",
    closeText: "Закрыть",
    allDayText: "Весь день",
    noEventsText: "Нет событий",
    eventText: "Мероприятия",
    eventsText: "Мероприятия",
    moreEventsText: "Ещё {count}",
    fromText: "Начало",
    toText: "Конец",
    wholeText: "Целое",
    fractionText: "Дробное",
    unitText: "Единица",
    labels: ["Лет", "Месяцев", "Дней", "Часов", "Минут", "Секунд", ""],
    labelsShort: ["Лет", "Мес", "Дн", "Час", "Мин", "Сек", ""],
    startText: "Старт",
    stopText: "Стоп",
    resetText: "Сбросить",
    lapText: "Круг",
    hideText: "Скрыть",
    backText: "назад",
    undoText: "ОтменитЬ",
    offText: "O",
    onText: "I",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.sk = {
    setText: "Zadaj",
    cancelText: "Zrušiť",
    clearText: "Vymazať",
    selectedText: "Označený: {count}",
    dateFormat: "d.m.yy",
    dayNames: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
    dayNamesShort: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
    dayNamesMin: ["N", "P", "U", "S", "Š", "P", "S"],
    dayText: "Ďeň",
    hourText: "Hodiny",
    minuteText: "Minúty",
    monthNames: ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Máj", "Jún", "Júl", "Aug", "Sep", "Okt", "Nov", "Dec"],
    monthText: "Mesiac",
    secText: "Sekundy",
    timeFormat: "H:ii",
    yearText: "Rok",
    nowText: "Teraz",
    amText: "am",
    pmText: "pm",
    todayText: "Dnes",
    firstDay: 1,
    dateText: "Datum",
    timeText: "Čas",
    closeText: "Zavrieť",
    allDayText: "Celý deň",
    noEventsText: "Žiadne udalosti",
    eventText: "Udalostí",
    eventsText: "Udalosti",
    moreEventsText: "{count} ďalšia",
    moreEventsPluralText: "{count} ďalšie",
    fromText: "Začiatok",
    toText: "Koniec",
    wholeText: "Celý",
    fractionText: "Časť",
    unitText: "Jednotka",
    labels: ["Roky", "Mesiace", "Dni", "Hodiny", "Minúty", "Sekundy", ""],
    labelsShort: ["Rok", "Mes", "Dni", "Hod", "Min", "Sec", ""],
    startText: "Start",
    stopText: "Stop",
    resetText: "Resetovať",
    lapText: "Etapa",
    hideText: "Schovať",
    backText: "Späť",
    undoText: "Späť",
    offText: "O",
    onText: "I",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.sr = {
    setText: "Постави",
    cancelText: "Откажи",
    clearText: "Обриши",
    selectedText: "{count} изабрана",
    dateFormat: "dd.mm.yy",
    dayNames: ["Недеља", "Понедељак", "Уторак", "Среда", "Четвртак", "Петак", "Субота"],
    dayNamesShort: ["Нед", "Пон", "Уто", "Сре", "Чет", "Пет", "Суб"],
    dayNamesMin: ["Не", "По", "Ут", "Ср", "Че", "Пе", "Су"],
    dayText: "Дан",
    delimiter: ".",
    hourText: "Час",
    minuteText: "Минут",
    monthNames: ["Јануар", "Фебруар", "Март", "Април", "Мај", "Јун", "Јул", "Август", "Септембар", "Октобар", "Новембар", "Децембар"],
    monthNamesShort: ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"],
    monthText: "месец",
    secText: "Секунд",
    timeFormat: "H:ii",
    yearText: "година",
    nowText: "сада",
    pmText: "pm",
    amText: "am",
    firstDay: 1,
    dateText: "Датум",
    timeText: "време",
    todayText: "Данас",
    prevMonthText: "Претходни мјесец",
    nextMonthText: "Следећег месеца",
    prevYearText: "Претходна године",
    nextYearText: "Следеће године",
    closeText: "Затвори",
    eventText: "Догађај",
    eventsText: "Догађаји",
    allDayText: "Цео дан",
    noEventsText: "Нема догађаја",
    moreEventsText: "Још {count}",
    fromText: "Од",
    toText: "До",
    wholeText: "цео",
    fractionText: "Фракција",
    unitText: "единица",
    labels: ["Године", "Месеци", "Дана", "Сати", "Минута", "Секунди", ""],
    labelsShort: ["Год", "Мес", "Дана", "Сати", "Мину", "Секу", ""],
    startText: "Започни",
    stopText: "Стоп",
    resetText: "Ресетуј",
    lapText: "Круг",
    hideText: "Сакрити",
    backText: "Повратак",
    undoText: "Опозови",
    offText: "нe",
    onText: "да",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.sv = {
    setText: "OK",
    cancelText: "Avbryt",
    clearText: "Klara",
    selectedText: "{count} vald",
    dateFormat: "yy-mm-dd",
    dayNames: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
    dayNamesShort: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
    dayNamesMin: ["S", "M", "T", "O", "T", "F", "L"],
    dayText: "Dag",
    hourText: "Timme",
    minuteText: "Minut",
    monthNames: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
    monthText: "Månad",
    secText: "Sekund",
    timeFormat: "HH:ii",
    yearText: "År",
    nowText: "Nu",
    pmText: "pm",
    amText: "am",
    todayText: "I dag",
    firstDay: 1,
    dateText: "Datum",
    timeText: "Tid",
    closeText: "Stäng",
    allDayText: "Heldag",
    noEventsText: "Inga aktiviteter",
    eventText: "Händelse",
    eventsText: "Händelser",
    moreEventsText: "{count} till",
    fromText: "Start",
    toText: "Slut",
    wholeText: "Hela",
    fractionText: "Bråk",
    unitText: "Enhet",
    labels: ["År", "Månader", "Dagar", "Timmar", "Minuter", "Sekunder", ""],
    labelsShort: ["År", "Mån", "Dag", "Tim", "Min", "Sek", ""],
    startText: "Start",
    stopText: "Stopp",
    resetText: "Återställ",
    lapText: "Varv",
    hideText: "Dölj",
    backText: "Tillbaka",
    undoText: "Ångra",
    offText: "Av",
    onText: "På"
  }, s.i18n.tr = {
    setText: "Seç",
    cancelText: "İptal",
    clearText: "Temizleyin",
    selectedText: "{count} seçilmiş",
    dateFormat: "dd.mm.yy",
    dayNames: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
    dayNamesShort: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
    dayNamesMin: ["P", "P", "S", "Ç", "P", "C", "C"],
    dayText: "Gün",
    delimiter: ".",
    hourText: "Saat",
    minuteText: "Dakika",
    monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
    monthNamesShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
    monthText: "Ay",
    secText: "Saniye",
    timeFormat: "HH:ii",
    yearText: "Yıl",
    nowText: "Şimdi",
    pmText: "pm",
    amText: "am",
    todayText: "Bugün",
    firstDay: 1,
    dateText: "Tarih",
    timeText: "Zaman",
    closeText: "Kapatmak",
    allDayText: "Tüm gün",
    noEventsText: "Etkinlik Yok",
    eventText: "Etkinlik",
    eventsText: "Etkinlikler",
    moreEventsText: "{count} tane daha",
    fromText: "Başla",
    toText: "Son",
    wholeText: "Tam",
    fractionText: "Kesir",
    unitText: "Birim",
    labels: ["Yıl", "Ay", "Gün", "Saat", "Dakika", "Saniye", ""],
    labelsShort: ["Yıl", "Ay", "Gün", "Sa", "Dak", "Sn", ""],
    startText: "Başla",
    stopText: "Durdur",
    resetText: "Sıfırla",
    lapText: "Tur",
    hideText: "Gizle",
    backText: "Geri",
    undoText: "Geri Al",
    offText: "O",
    onText: "I",
    decimalSeparator: ",",
    thousandsSeparator: "."
  }, s.i18n.vi = {
    setText: "Đặt",
    cancelText: "Hủy bò",
    clearText: "Xóa",
    selectedText: "{count} chọn",
    dateFormat: "dd/mm/yy",
    dayNames: ["Chủ Nhật", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy"],
    dayNamesShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
    dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
    dayText: "",
    delimiter: "/",
    hourText: "Giờ",
    minuteText: "Phút",
    monthNames: ["Tháng Một", "Tháng Hai", "Tháng Ba", "Tháng Tư", "Tháng Năm", "Tháng Sáu", "Tháng Bảy", "Tháng Tám", "Tháng Chín", "Tháng Mười", "Tháng Mười Một", "Tháng Mười Hai"],
    monthNamesShort: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"],
    monthText: "Tháng",
    secText: "Giây",
    timeFormat: "H:ii",
    yearText: "Năm",
    nowText: "Bây giờ",
    pmText: "pm",
    amText: "am",
    firstDay: 0,
    dateText: "Ngày",
    timeText: "Hồi",
    todayText: "Hôm nay",
    prevMonthText: "Tháng trước",
    nextMonthText: "Tháng tới",
    prevYearText: "Măm trước",
    nextYearText: "Năm tới",
    closeText: "Đóng",
    eventText: "Sự kiện",
    eventsText: "Sự kiện",
    allDayText: "Cả ngày",
    noEventsText: "Không có sự kiện",
    moreEventsText: "{count} thẻ khác",
    fromText: "Từ",
    toText: "Tới",
    wholeText: "Toàn thể",
    fractionText: "Phân số",
    unitText: "đơn vị",
    labels: ["Năm", "Tháng", "Ngày", "Giờ", "Phút", "Giây", ""],
    labelsShort: ["Năm", "Tháng", "Ngày", "Giờ", "Phút", "Giây", ""],
    startText: "Bắt đầu",
    stopText: "Dừng",
    resetText: "Đặt lại",
    lapText: "Vòng",
    hideText: "Giấu",
    backText: "Quay lại",
    undoText: "Hoàn tác",
    offText: "Tất",
    onText: "Bật",
    decimalSeparator: ",",
    thousandsSeparator: " "
  }, s.i18n.zh = {
    setText: "确定",
    cancelText: "取消",
    clearText: "明确",
    selectedText: "{count} 选",
    dateFormat: "yy年mm月d日",
    dayNames: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
    dayNamesShort: ["日", "一", "二", "三", "四", "五", "六"],
    dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
    dayText: "日",
    hourText: "时",
    minuteText: "分",
    monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    monthNamesShort: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "十一", "十二"],
    monthText: "月",
    secText: "秒",
    timeFormat: "HH:ii",
    yearText: "年",
    nowText: "当前",
    pmText: "下午",
    amText: "上午",
    yearSuffix: "年",
    monthSuffix: "月",
    daySuffix: "日",
    todayText: "今天",
    dateText: "日",
    timeText: "时间",
    closeText: "关闭",
    allDayText: "全天",
    noEventsText: "无事件",
    eventText: "活动",
    eventsText: "活动",
    moreEventsText: "他 {count} 件",
    fromText: "开始时间",
    toText: "结束时间",
    wholeText: "合计",
    fractionText: "分数",
    unitText: "单位",
    labels: ["年", "月", "日", "小时", "分钟", "秒", ""],
    labelsShort: ["年", "月", "日", "点", "分", "秒", ""],
    startText: "开始",
    stopText: "停止",
    resetText: "重置",
    lapText: "圈",
    hideText: "隐藏",
    backText: "返回",
    undoText: "复原",
    offText: "关闭",
    onText: "开启",
    decimalSeparator: ",",
    thousandsSeparator: " "
  };
  var Wn,
      Kn,
      Yn = s.themes;

  function Gn(e, t) {
    var n = U(t, "X", !0),
        s = U(t, "Y", !0),
        a = e.offset(),
        o = n - a.left,
        i = s - a.top,
        r = Math.max(o, e[0].offsetWidth - o),
        l = Math.max(i, e[0].offsetHeight - i),
        c = 2 * Math.sqrt(Math.pow(r, 2) + Math.pow(l, 2));
    qn(Kn), Kn = Y('<span class="mbsc-ripple"></span>').css({
      width: c,
      height: c,
      top: s - a.top - c / 2,
      left: n - a.left - c / 2
    }).appendTo(e), setTimeout(function () {
      Kn.addClass("mbsc-ripple-scaled mbsc-ripple-visible");
    }, 10);
  }

  function qn(e) {
    setTimeout(function () {
      e && (e.removeClass("mbsc-ripple-visible"), setTimeout(function () {
        e.remove();
      }, 2e3));
    }, 100);
  }

  function Zn(e, t, n, s) {
    var a, o;
    e.off(".mbsc-ripple").on("touchstart.mbsc-ripple mousedown.mbsc-ripple", t, function (e) {
      we(e, this) && (a = U(e, "X"), o = U(e, "Y"), (Wn = Y(this)).hasClass(n) || Wn.hasClass(s) ? Wn = null : Gn(Wn, e));
    }).on("touchmove.mbsc-ripple mousemove.mbsc-ripple", t, function (e) {
      (Wn && Math.abs(U(e, "X") - a) > 9 || Math.abs(U(e, "Y") - o) > 9) && (qn(Kn), Wn = null);
    }).on("touchend.mbsc-ripple touchcancel.mbsc-ripple mouseleave.mbsc-ripple mouseup.mbsc-ripple", t, function () {
      Wn && (setTimeout(function () {
        qn(Kn);
      }, 100), Wn = null);
    });
  }

  Yn.frame.ios = {
    display: "bottom",
    headerText: !1,
    btnWidth: !1,
    deleteIcon: "ios-backspace",
    scroll3d: "wp" != g && ("android" != g || _ > 7)
  }, Yn.scroller.ios = Q({}, Yn.frame.ios, {
    rows: 5,
    height: 34,
    minWidth: 55,
    selectedLineHeight: !0,
    selectedLineBorder: 1,
    showLabel: !1,
    useShortLabels: !0,
    btnPlusClass: "mbsc-ic mbsc-ic-arrow-down5",
    btnMinusClass: "mbsc-ic mbsc-ic-arrow-up5",
    checkIcon: "ion-ios7-checkmark-empty",
    filterClearIcon: "ion-close-circled",
    dateDisplay: "MMdyy",
    btnCalPrevClass: "mbsc-ic mbsc-ic-arrow-left5",
    btnCalNextClass: "mbsc-ic mbsc-ic-arrow-right5"
  }), Yn.listview.ios = {
    leftArrowClass: "mbsc-ic-ion-ios7-arrow-back",
    rightArrowClass: "mbsc-ic-ion-ios7-arrow-forward"
  }, Yn.form.ios = {};
  var Xn = s.themes;
  Xn.frame.material = {
    headerText: !1,
    btnWidth: !1,
    deleteIcon: "material-backspace",
    onMarkupReady: function onMarkupReady(e) {
      Zn(Y(e.target), ".mbsc-fr-btn-e", "mbsc-disabled", "mbsc-fr-btn-nhl");
    }
  }, Xn.scroller.material = Q({}, Xn.frame.material, {
    showLabel: !1,
    selectedLineBorder: 2,
    weekDays: "min",
    icon: {
      filled: "material-star",
      empty: "material-star-outline"
    },
    checkIcon: "material-check",
    btnPlusClass: "mbsc-ic mbsc-ic-material-keyboard-arrow-down",
    btnMinusClass: "mbsc-ic mbsc-ic-material-keyboard-arrow-up",
    btnCalPrevClass: "mbsc-ic mbsc-ic-material-keyboard-arrow-left",
    btnCalNextClass: "mbsc-ic mbsc-ic-material-keyboard-arrow-right",
    onEventBubbleShow: function onEventBubbleShow(e) {
      var t = Y(e.eventList),
          n = Y(e.target).closest(".mbsc-cal-row").index() < 2,
          s = Y(".mbsc-cal-event-color", t).eq(n ? 0 : -1).css("background-color");
      Y(".mbsc-cal-events-arr", t).css("border-color", n ? "transparent transparent " + s + " transparent" : s + "transparent transparent transparent");
    }
  }), Xn.listview.material = {
    leftArrowClass: "mbsc-ic-material-keyboard-arrow-left",
    rightArrowClass: "mbsc-ic-material-keyboard-arrow-right",
    onItemActivate: function onItemActivate(e) {
      Gn(Y(e.target), e.domEvent);
    },
    onItemDeactivate: function onItemDeactivate() {
      qn(Kn);
    },
    onSlideStart: function onSlideStart(e) {
      Y(".mbsc-ripple", e.target).remove();
    },
    onSortStart: function onSortStart(e) {
      Y(".mbsc-ripple", e.target).remove();
    }
  }, Xn.navigation.material = {
    onInit: function onInit() {
      Zn(Y(this), ".mbsc-ms-item.mbsc-btn-e", "mbsc-disabled", "mbsc-btn-nhl");
    },
    onMarkupInit: function onMarkupInit() {
      Y(".mbsc-ripple", this).remove();
    },
    onDestroy: function onDestroy() {
      Y(this).off(".mbsc-ripple");
    }
  }, Xn.form.material = {
    addRipple: function addRipple(e, t) {
      Gn(e, t);
    },
    removeRipple: function removeRipple() {
      qn(Kn);
    }
  };
  var Qn = s.themes;
  Qn.frame.windows = {
    headerText: !1,
    deleteIcon: "backspace4",
    btnReverse: !0
  }, Qn.scroller.windows = Q({}, Qn.frame.windows, {
    rows: 6,
    minWidth: 88,
    height: 44,
    btnPlusClass: "mbsc-ic mbsc-ic-arrow-down5",
    btnMinusClass: "mbsc-ic mbsc-ic-arrow-up5",
    checkIcon: "material-check",
    dateDisplay: "MMdyy",
    showLabel: !1,
    showScrollArrows: !0,
    btnCalPrevClass: "mbsc-ic mbsc-ic-arrow-left5",
    btnCalNextClass: "mbsc-ic mbsc-ic-arrow-right5",
    dayNamesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    useShortLabels: !0
  }), Qn.form.windows = {}, s.customTheme("ios-dark", "ios"), s.customTheme("material-dark", "material"), s.customTheme("mobiscroll-dark", "mobiscroll"), s.customTheme("windows-dark", "windows");
  var es = s.themes,
      ts = "mobiscroll";
  return "android" == g ? ts = "material" : "ios" == g ? ts = "ios" : "wp" == g && (ts = "windows"), Y.each(es.frame, function (e, t) {
    if (ts && t.baseTheme == ts && "mobiscroll-dark" != e && "material-dark" != e && "windows-dark" != e && "ios-dark" != e) return s.autoTheme = e, !1;
    e == ts && (s.autoTheme = e);
  }), s;
});